<template functional>
  <div
    :ref="data.ref"
    :class="['SvgIconsCmp', data.staticClass, data.class]"
    :style="[data.style, data.staticStyle]"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <!-- Logo -->
    <div>
      <span>icon-logo</span>
      <svg
        id="icon-logo"
        viewBox="0 0 490 311"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleLogo contentLogo"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title v-if="$options.getString('icon-logo', 'title')" id="titleLogo">
          {{ $options.getString('icon-logo', 'title') }}
        </title>
        <desc id="contentLogo">
          {{ $options.getString('icon-logo', 'description') }}
        </desc>
        <path
          d="M216.71 216.73C216.854 216.725 216.997 216.749 217.132 216.8C217.266 216.851 217.389 216.929 217.493 217.029C217.596 217.129 217.679 217.249 217.735 217.381C217.791 217.514 217.82 217.656 217.82 217.8C217.824 217.947 217.798 218.093 217.744 218.23C217.69 218.366 217.608 218.49 217.504 218.594C217.4 218.698 217.276 218.78 217.14 218.834C217.003 218.889 216.857 218.914 216.71 218.91H207.88V226.63H216.29C216.436 226.615 216.583 226.632 216.721 226.68C216.859 226.728 216.985 226.806 217.09 226.908C217.195 227.01 217.276 227.134 217.328 227.271C217.38 227.408 217.401 227.554 217.39 227.7C217.396 227.847 217.371 227.993 217.318 228.129C217.265 228.266 217.184 228.39 217.081 228.494C216.978 228.598 216.854 228.68 216.718 228.734C216.582 228.789 216.437 228.814 216.29 228.81H207.88V238.75C207.88 239.053 207.76 239.343 207.546 239.556C207.332 239.77 207.042 239.89 206.74 239.89C206.438 239.89 206.148 239.77 205.934 239.556C205.72 239.343 205.6 239.053 205.6 238.75V218.12C205.603 217.935 205.642 217.752 205.715 217.582C205.788 217.412 205.894 217.258 206.027 217.129C206.16 217 206.317 216.898 206.489 216.83C206.661 216.761 206.845 216.728 207.03 216.73H216.71Z"
        />
        <path
          d="M245.84 223.79V232.45C245.84 237.04 242.84 239.87 238.31 239.87C233.78 239.87 230.79 237.04 230.79 232.45V223.78C230.79 219.19 233.79 216.39 238.31 216.39C242.83 216.39 245.84 219.2 245.84 223.79ZM233.07 223.63V232.63C233.07 235.76 235.07 237.75 238.31 237.75C241.55 237.75 243.59 235.75 243.59 232.63V223.63C243.59 220.47 241.59 218.52 238.31 218.52C235.03 218.52 233.07 220.45 233.07 223.63Z"
        />
        <path
          d="M267.56 216.73C271.79 216.73 274.14 219.46 274.14 223.17C274.236 224.633 273.759 226.076 272.812 227.196C271.864 228.315 270.519 229.022 269.06 229.17L274.17 238.06C274.313 238.262 274.393 238.502 274.4 238.75C274.395 239.049 274.273 239.335 274.06 239.546C273.847 239.758 273.56 239.877 273.26 239.88C273.08 239.883 272.903 239.84 272.744 239.756C272.585 239.672 272.449 239.55 272.35 239.4L266.55 229.46H262.55V238.75C262.55 239.052 262.43 239.342 262.216 239.556C262.002 239.77 261.712 239.89 261.41 239.89C261.108 239.89 260.818 239.77 260.604 239.556C260.39 239.342 260.27 239.052 260.27 238.75V218.12C260.273 217.934 260.312 217.752 260.385 217.582C260.458 217.411 260.564 217.258 260.697 217.128C260.83 216.999 260.987 216.898 261.159 216.829C261.331 216.761 261.515 216.727 261.7 216.73H267.56ZM262.56 218.84V227.34H267.56C270.13 227.34 271.89 225.88 271.89 223.21C271.936 222.628 271.856 222.042 271.655 221.494C271.454 220.946 271.138 220.447 270.727 220.032C270.316 219.617 269.82 219.296 269.273 219.09C268.727 218.884 268.143 218.799 267.56 218.84H262.56Z"
        />
        <path
          d="M50.2101 257.01C55.8401 257.01 58.7401 260.45 58.7401 265.01C58.7401 269.84 55.9101 272.86 50.7401 272.86H45.8701V281.86C45.8701 282.39 45.6594 282.899 45.2843 283.274C44.9093 283.649 44.4006 283.86 43.8701 283.86C43.3397 283.86 42.831 283.649 42.4559 283.274C42.0808 282.899 41.8701 282.39 41.8701 281.86V259.32C41.8832 258.699 42.1404 258.109 42.5859 257.676C43.0314 257.244 43.6293 257.004 44.2501 257.01H50.2101ZM45.8701 260.71V269.25H50.2101C53.2101 269.25 54.7801 267.7 54.7801 265.02C54.7801 262.34 52.9301 260.71 50.2101 260.71H45.8701Z"
        />
        <path
          d="M83.3099 257.01C88.5599 257.01 91.5399 260.11 91.5399 264.79C91.6434 266.437 91.1446 268.065 90.1364 269.372C89.1281 270.678 87.6793 271.573 86.0599 271.89L91.4599 280.77C91.6473 281.104 91.7535 281.477 91.7699 281.86C91.7723 282.285 91.6391 282.7 91.3898 283.044C91.1405 283.388 90.788 283.644 90.3835 283.775C89.9789 283.905 89.5433 283.903 89.1399 283.769C88.7364 283.635 88.3862 283.376 88.1399 283.03L81.7199 272.45H78.1299V281.89C78.1299 282.42 77.9192 282.929 77.5441 283.304C77.169 283.679 76.6603 283.89 76.1299 283.89C75.5994 283.89 75.0907 283.679 74.7157 283.304C74.3406 282.929 74.1299 282.42 74.1299 281.89V259.32C74.1404 258.698 74.3968 258.106 74.8428 257.673C75.2889 257.241 75.8883 257.002 76.5099 257.01H83.3099ZM78.1299 260.71V268.76H83.3099C86.0599 268.76 87.5699 267.25 87.5699 264.76C87.5699 262.27 85.9899 260.68 83.3099 260.68L78.1299 260.71Z"
        />
        <path
          d="M125.65 265.85V274.65C125.65 280.46 121.92 283.86 116.33 283.86C110.74 283.86 107 280.45 107 274.65V265.85C107 260.03 110.74 256.63 116.37 256.63C122 256.63 125.65 260.03 125.65 265.85ZM111 265.55V274.91C111 278.2 113 280.16 116.37 280.16C119.74 280.16 121.69 278.16 121.69 274.91V265.55C121.69 262.3 119.69 260.33 116.37 260.33C113.05 260.33 111 262.3 111 265.55Z"
        />
        <path
          d="M155.26 257.01C155.767 257.01 156.253 257.211 156.611 257.569C156.969 257.928 157.17 258.413 157.17 258.92C157.17 259.427 156.969 259.912 156.611 260.271C156.253 260.629 155.767 260.83 155.26 260.83H145.78V267.83H154.78C155.042 267.811 155.305 267.846 155.553 267.933C155.8 268.02 156.027 268.158 156.219 268.336C156.411 268.515 156.565 268.732 156.669 268.972C156.774 269.213 156.828 269.473 156.828 269.735C156.828 269.997 156.774 270.257 156.669 270.498C156.565 270.738 156.411 270.955 156.219 271.134C156.027 271.312 155.8 271.449 155.553 271.537C155.305 271.624 155.042 271.659 154.78 271.64H145.78V281.84C145.78 282.37 145.57 282.879 145.194 283.254C144.819 283.629 144.311 283.84 143.78 283.84C143.25 283.84 142.741 283.629 142.366 283.254C141.991 282.879 141.78 282.37 141.78 281.84V259.32C141.791 258.698 142.047 258.106 142.493 257.673C142.939 257.241 143.539 257.002 144.16 257.01H155.26Z"
        />
        <path
          d="M185.94 257.01C186.446 257.01 186.932 257.211 187.29 257.57C187.648 257.928 187.85 258.414 187.85 258.92C187.85 259.427 187.648 259.913 187.29 260.271C186.932 260.629 186.446 260.83 185.94 260.83H176.35V267.83H185.45C185.711 267.811 185.974 267.846 186.222 267.934C186.469 268.021 186.696 268.158 186.889 268.337C187.081 268.515 187.234 268.732 187.339 268.972C187.444 269.213 187.498 269.473 187.498 269.735C187.498 269.998 187.444 270.257 187.339 270.498C187.234 270.739 187.081 270.955 186.889 271.134C186.696 271.312 186.469 271.45 186.222 271.537C185.974 271.624 185.711 271.659 185.45 271.64H176.35V279.64H186.21C186.716 279.64 187.202 279.841 187.56 280.2C187.918 280.558 188.12 281.044 188.12 281.55C188.12 282.057 187.918 282.543 187.56 282.901C187.202 283.259 186.716 283.46 186.21 283.46H174.77C174.46 283.47 174.153 283.417 173.864 283.305C173.576 283.193 173.313 283.024 173.091 282.809C172.869 282.593 172.692 282.336 172.572 282.051C172.452 281.766 172.39 281.46 172.39 281.15V259.32C172.388 259.01 172.449 258.704 172.569 258.418C172.689 258.132 172.865 257.874 173.088 257.658C173.31 257.443 173.574 257.274 173.863 257.163C174.152 257.051 174.46 256.999 174.77 257.01H185.94Z"
        />
        <path
          d="M218.05 258.03C218.4 258.182 218.695 258.436 218.897 258.759C219.099 259.082 219.198 259.459 219.18 259.84C219.19 260.075 219.152 260.309 219.069 260.529C218.986 260.749 218.859 260.949 218.697 261.119C218.534 261.289 218.339 261.425 218.123 261.517C217.908 261.61 217.675 261.659 217.44 261.66C216.86 261.629 216.294 261.472 215.78 261.2C214.352 260.583 212.806 260.287 211.25 260.33C209.1 260.33 207.06 261.47 207.06 263.51C207.06 265.32 208.06 266.19 210.19 267.17L214.61 269.17C217.14 270.34 219.9 272.04 219.9 276.42C219.9 280.99 216.2 283.82 211.29 283.82C208.878 283.847 206.488 283.345 204.29 282.35C203.927 282.21 203.615 281.961 203.398 281.637C203.182 281.313 203.071 280.93 203.08 280.54C203.063 280.293 203.098 280.046 203.183 279.814C203.267 279.581 203.4 279.369 203.571 279.191C203.743 279.013 203.95 278.873 204.178 278.78C204.407 278.687 204.653 278.642 204.9 278.65C205.493 278.672 206.074 278.826 206.6 279.1C208.083 279.771 209.693 280.112 211.32 280.1C214.04 280.1 215.93 278.85 215.93 276.51C215.93 274.51 214.75 273.57 212.49 272.51L207.88 270.36C205.24 269.11 203.12 267.15 203.12 263.64C203.12 259.37 206.52 256.64 211.51 256.64C213.769 256.589 216.008 257.065 218.05 258.03Z"
        />
        <path
          d="M249.49 258.03C249.839 258.181 250.135 258.436 250.336 258.759C250.538 259.082 250.637 259.459 250.62 259.84C250.628 260.074 250.589 260.308 250.505 260.527C250.422 260.746 250.295 260.946 250.133 261.116C249.971 261.286 249.776 261.421 249.561 261.514C249.346 261.608 249.114 261.657 248.88 261.66C248.3 261.629 247.733 261.472 247.22 261.2C245.791 260.584 244.245 260.287 242.69 260.33C240.54 260.33 238.5 261.47 238.5 263.51C238.5 265.32 239.5 266.19 241.63 267.17L246.05 269.17C248.58 270.34 251.34 272.04 251.34 276.42C251.34 280.99 247.64 283.82 242.73 283.82C240.317 283.847 237.928 283.345 235.73 282.35C235.366 282.209 235.055 281.96 234.838 281.636C234.621 281.312 234.51 280.929 234.52 280.54C234.503 280.293 234.538 280.046 234.622 279.813C234.707 279.581 234.839 279.369 235.011 279.191C235.182 279.013 235.389 278.873 235.618 278.78C235.847 278.686 236.093 278.642 236.34 278.65C236.929 278.673 237.507 278.827 238.03 279.1C239.516 279.769 241.13 280.11 242.76 280.1C245.48 280.1 247.36 278.85 247.36 276.51C247.36 274.51 246.19 273.57 243.93 272.51L239.32 270.36C236.68 269.11 234.56 267.15 234.56 263.64C234.56 259.37 237.96 256.64 242.94 256.64C245.201 256.587 247.444 257.063 249.49 258.03Z"
        />
        <path
          d="M270.87 258.56V281.9C270.87 282.43 270.659 282.939 270.284 283.314C269.909 283.689 269.401 283.9 268.87 283.9C268.34 283.9 267.831 283.689 267.456 283.314C267.081 282.939 266.87 282.43 266.87 281.9V258.56C266.87 258.029 267.081 257.52 267.456 257.145C267.831 256.77 268.34 256.56 268.87 256.56C269.401 256.56 269.909 256.77 270.284 257.145C270.659 257.52 270.87 258.029 270.87 258.56Z"
        />
        <path
          d="M305.69 265.85V274.65C305.69 280.46 301.95 283.86 296.36 283.86C290.77 283.86 287 280.45 287 274.65V265.85C287 260.03 290.74 256.63 296.36 256.63C301.98 256.63 305.69 260.03 305.69 265.85ZM291 265.55V274.91C291 278.2 293 280.16 296.36 280.16C299.72 280.16 301.69 278.16 301.69 274.91V265.55C301.69 262.3 299.69 260.33 296.36 260.33C293.03 260.33 291 262.3 291 265.55Z"
        />
        <path
          d="M340 258.63V281.79C339.995 282.339 339.773 282.864 339.384 283.251C338.995 283.639 338.469 283.857 337.92 283.86C337.506 283.867 337.1 283.757 336.746 283.543C336.392 283.329 336.106 283.019 335.92 282.65L325.76 265.28V281.86C325.76 282.39 325.549 282.899 325.174 283.274C324.799 283.649 324.29 283.86 323.76 283.86C323.229 283.86 322.721 283.649 322.346 283.274C321.971 282.899 321.76 282.39 321.76 281.86V258.71C321.757 258.171 321.964 257.652 322.338 257.264C322.711 256.876 323.221 256.648 323.76 256.63C324.172 256.63 324.576 256.743 324.928 256.956C325.281 257.17 325.568 257.475 325.76 257.84L335.91 275.18V258.63C335.91 258.099 336.121 257.591 336.496 257.216C336.871 256.841 337.379 256.63 337.91 256.63C338.182 256.609 338.456 256.645 338.713 256.737C338.97 256.829 339.205 256.974 339.402 257.162C339.599 257.351 339.755 257.579 339.858 257.832C339.961 258.085 340.009 258.357 340 258.63Z"
        />
        <path
          d="M367.57 258.07L375.57 281.18C375.665 281.436 375.716 281.706 375.72 281.98C375.723 282.238 375.673 282.494 375.572 282.732C375.471 282.969 375.322 283.183 375.134 283.36C374.946 283.537 374.723 283.673 374.479 283.759C374.236 283.845 373.977 283.879 373.72 283.86C373.309 283.877 372.904 283.761 372.564 283.531C372.224 283.301 371.966 282.967 371.83 282.58L370.13 277.33H360.69L358.99 282.58C358.858 282.962 358.607 283.293 358.275 283.523C357.942 283.753 357.544 283.871 357.14 283.86C356.882 283.879 356.624 283.845 356.38 283.759C356.137 283.673 355.914 283.537 355.726 283.36C355.538 283.183 355.388 282.969 355.287 282.732C355.187 282.494 355.136 282.238 355.14 281.98C355.144 281.706 355.195 281.436 355.29 281.18L363.29 258.07C363.45 257.647 363.734 257.283 364.106 257.026C364.477 256.769 364.918 256.631 365.37 256.63C365.844 256.592 366.317 256.714 366.716 256.974C367.114 257.235 367.414 257.62 367.57 258.07ZM361.94 273.7H369L365.45 262.79L361.94 273.7Z"
        />
        <path
          d="M395 258.63V279.63H404.85C405.357 279.63 405.842 279.831 406.201 280.189C406.559 280.548 406.76 281.033 406.76 281.54C406.76 282.046 406.559 282.532 406.201 282.89C405.842 283.249 405.357 283.45 404.85 283.45H393.38C392.759 283.455 392.161 283.216 391.716 282.783C391.27 282.351 391.013 281.761 391 281.14V258.63C391 258.099 391.211 257.591 391.586 257.216C391.961 256.841 392.47 256.63 393 256.63C393.53 256.63 394.039 256.841 394.414 257.216C394.789 257.591 395 258.099 395 258.63Z"
        />
        <path
          d="M436.25 258.03C436.6 258.182 436.895 258.436 437.097 258.759C437.299 259.082 437.397 259.459 437.38 259.84C437.389 260.075 437.351 260.309 437.268 260.529C437.185 260.749 437.059 260.949 436.896 261.119C436.734 261.289 436.539 261.425 436.323 261.517C436.107 261.61 435.875 261.659 435.64 261.66C435.06 261.629 434.493 261.472 433.98 261.2C432.551 260.583 431.005 260.287 429.45 260.33C427.3 260.33 425.26 261.47 425.26 263.51C425.26 265.32 426.26 266.19 428.39 267.17L432.81 269.17C435.34 270.34 438.1 272.04 438.1 276.42C438.1 280.99 434.4 283.82 429.49 283.82C427.077 283.847 424.688 283.345 422.49 282.35C422.127 282.209 421.817 281.96 421.602 281.636C421.387 281.312 421.278 280.929 421.29 280.54C421.272 280.294 421.305 280.047 421.389 279.814C421.472 279.582 421.603 279.37 421.774 279.192C421.945 279.014 422.151 278.873 422.379 278.78C422.608 278.687 422.853 278.642 423.1 278.65C423.693 278.672 424.274 278.826 424.8 279.1C426.283 279.77 427.893 280.111 429.52 280.1C432.24 280.1 434.13 278.85 434.13 276.51C434.13 274.51 432.96 273.57 430.69 272.51L426.08 270.36C423.44 269.11 421.32 267.15 421.32 263.64C421.32 259.37 424.72 256.64 429.71 256.64C431.968 256.589 434.208 257.065 436.25 258.03Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.29 112.26C27.29 159.26 103.41 197.26 240.05 197.21C376.69 197.16 452.74 158.97 452.71 112C452.68 65.03 376.59 26.95 239.95 27C103.31 27.05 27.26 65.29 27.29 112.26Z"
          fill="#CC0935"
        />
        <path
          d="M181.9 41.6498C185.04 41.3998 187.12 42.9698 187.37 46.2298L187.61 49.1098C187.86 52.3098 186.08 54.2498 182.93 54.4998L180.45 54.6998C180.303 54.7165 180.154 54.7037 180.011 54.6623C179.869 54.6209 179.736 54.5517 179.621 54.4587C179.506 54.3657 179.41 54.2507 179.339 54.1205C179.269 53.9902 179.225 53.8472 179.21 53.6998L178.36 43.0898C178.349 42.9398 178.368 42.7891 178.416 42.6465C178.465 42.504 178.541 42.3725 178.64 42.2598C178.74 42.1471 178.861 42.0555 178.997 41.9902C179.132 41.9249 179.28 41.8874 179.43 41.8798L181.9 41.6498ZM180.34 43.6498L181.08 52.8298L182.82 52.6898C183.243 52.7022 183.663 52.6192 184.05 52.447C184.436 52.2748 184.779 52.0179 185.053 51.6952C185.327 51.3725 185.524 50.9923 185.631 50.5828C185.738 50.1734 185.751 49.7451 185.67 49.3298L185.43 46.3798C185.445 45.9562 185.364 45.5346 185.194 45.1464C185.024 44.7583 184.768 44.4135 184.446 44.1377C184.124 43.8619 183.745 43.6622 183.335 43.5535C182.925 43.4448 182.496 43.4299 182.08 43.5098L180.34 43.6498Z"
        />
        <path
          d="M203.24 40.7999L207.71 51.7999C207.761 51.9241 207.792 52.0559 207.8 52.1899C207.813 52.3168 207.799 52.4448 207.758 52.5658C207.718 52.6869 207.653 52.7981 207.568 52.8924C207.482 52.9867 207.377 53.0619 207.26 53.1131C207.144 53.1644 207.018 53.1905 206.89 53.1899C206.691 53.207 206.491 53.16 206.32 53.0556C206.149 52.9513 206.016 52.7952 205.94 52.6099L204.99 50.0999L200.4 50.3299L199.7 52.9199C199.645 53.1095 199.531 53.2766 199.375 53.397C199.218 53.5175 199.027 53.585 198.83 53.5899C198.707 53.6023 198.582 53.5892 198.463 53.5516C198.345 53.5139 198.236 53.4525 198.142 53.371C198.048 53.2895 197.972 53.1897 197.919 53.0777C197.865 52.9657 197.835 52.844 197.83 52.7199C197.831 52.5877 197.851 52.4563 197.89 52.3299L201.22 40.8999C201.291 40.6882 201.425 40.503 201.603 40.3691C201.782 40.2351 201.997 40.1587 202.22 40.1499C202.434 40.1365 202.647 40.1924 202.828 40.3095C203.008 40.4266 203.145 40.5985 203.22 40.7999H203.24ZM200.87 48.5399L204.32 48.3699L202.32 43.1499L200.87 48.5399Z"
        />
        <path
          d="M220.21 40.4503L220.45 50.6903L225.25 50.5803C225.479 50.6041 225.691 50.7118 225.845 50.8826C225.999 51.0535 226.084 51.2753 226.084 51.5052C226.084 51.7352 225.999 51.9571 225.845 52.1279C225.691 52.2987 225.479 52.4064 225.25 52.4303L219.69 52.5603C219.54 52.567 219.391 52.5441 219.25 52.4929C219.109 52.4417 218.98 52.3633 218.869 52.2621C218.759 52.1608 218.669 52.0388 218.606 51.9029C218.542 51.767 218.507 51.62 218.5 51.4703L218.24 40.4703C218.2 40.322 218.194 40.1663 218.224 40.0155C218.253 39.8647 218.317 39.7228 218.411 39.6007C218.504 39.4786 218.624 39.3796 218.762 39.3115C218.9 39.2434 219.051 39.208 219.205 39.208C219.359 39.208 219.51 39.2434 219.648 39.3115C219.786 39.3796 219.906 39.4786 220 39.6007C220.093 39.7228 220.157 39.8647 220.186 40.0155C220.216 40.1663 220.21 40.322 220.17 40.4703"
        />
        <path
          d="M248.73 40.3101L248.64 51.5801C248.644 51.7047 248.623 51.8288 248.577 51.9447C248.531 52.0607 248.462 52.166 248.374 52.2541C248.286 52.3422 248.181 52.4113 248.065 52.4571C247.949 52.5028 247.825 52.5243 247.7 52.5201C247.575 52.5228 247.45 52.5001 247.333 52.4534C247.217 52.4066 247.111 52.3367 247.022 52.2479C246.934 52.1592 246.864 52.0534 246.817 51.9369C246.77 51.8204 246.747 51.6956 246.75 51.5701L246.82 41.6401L245.14 42.5701C244.981 42.6694 244.798 42.7247 244.61 42.7301C244.491 42.7389 244.37 42.722 244.258 42.6805C244.145 42.639 244.043 42.574 243.958 42.4896C243.873 42.4053 243.806 42.3038 243.764 42.1917C243.721 42.0797 243.703 41.9598 243.71 41.8401C243.704 41.6772 243.746 41.5162 243.829 41.3761C243.912 41.236 244.034 41.1229 244.18 41.0501L247.13 39.4001C247.301 39.3129 247.489 39.265 247.68 39.2601C247.82 39.2529 247.96 39.2752 248.09 39.3254C248.221 39.3756 248.34 39.4527 248.439 39.5517C248.538 39.6507 248.615 39.7693 248.665 39.9C248.715 40.0306 248.737 40.1703 248.73 40.3101Z"
        />
        <path
          d="M267.66 43.2402C267.64 43.7816 267.484 44.3091 267.206 44.7741C266.928 45.2391 266.537 45.6264 266.07 45.9002C266.613 46.2146 267.061 46.6713 267.364 47.221C267.667 47.7708 267.814 48.3929 267.79 49.0203C267.694 50.0501 267.21 51.005 266.436 51.6908C265.662 52.3767 264.656 52.7421 263.622 52.7128C262.588 52.6835 261.604 52.2617 260.87 51.5332C260.136 50.8046 259.707 49.8238 259.67 48.7902C259.681 48.1652 259.863 47.5551 260.196 47.0262C260.529 46.4973 261.001 46.0698 261.56 45.7902C261.111 45.491 260.745 45.0826 260.497 44.6034C260.248 44.1242 260.125 43.5898 260.14 43.0503C260.231 42.0986 260.68 41.217 261.396 40.5839C262.112 39.9508 263.042 39.6135 263.998 39.6401C264.954 39.6668 265.863 40.0556 266.543 40.7277C267.223 41.3997 267.622 42.305 267.66 43.2602V43.2402ZM261.54 48.8802C261.523 49.4611 261.737 50.025 262.135 50.4479C262.534 50.8707 263.084 51.118 263.665 51.1352C264.246 51.1525 264.81 50.9383 265.233 50.5398C265.655 50.1413 265.903 49.5911 265.92 49.0102C265.937 48.4294 265.723 47.8655 265.324 47.4426C264.926 47.0198 264.376 46.7725 263.795 46.7552C263.214 46.738 262.65 46.9522 262.227 47.3507C261.804 47.7492 261.557 48.2994 261.54 48.8802ZM262.02 43.1002C261.995 43.3565 262.023 43.6151 262.103 43.8601C262.182 44.105 262.311 44.331 262.481 44.5241C262.651 44.7172 262.86 44.8733 263.093 44.9826C263.326 45.092 263.579 45.1523 263.836 45.1599C264.093 45.1674 264.35 45.122 264.589 45.0265C264.828 44.931 265.045 44.7874 265.226 44.6046C265.407 44.4218 265.549 44.2037 265.643 43.9639C265.736 43.724 265.78 43.4675 265.77 43.2102C265.752 42.7337 265.554 42.2818 265.215 41.9459C264.877 41.6101 264.423 41.4155 263.946 41.4015C263.47 41.3875 263.006 41.5552 262.648 41.8706C262.29 42.186 262.066 42.6256 262.02 43.1002Z"
        />
        <path
          d="M302.42 43.0599C302.442 42.9166 302.432 42.7702 302.392 42.631C302.351 42.4918 302.281 42.363 302.186 42.2537C302.091 42.1443 301.973 42.0569 301.841 41.9975C301.709 41.9382 301.565 41.9083 301.42 41.9099L295.26 41.4299C295.138 41.4116 295.013 41.4186 294.894 41.4505C294.775 41.4824 294.663 41.5386 294.566 41.6155C294.47 41.6924 294.39 41.7884 294.332 41.8976C294.274 42.0067 294.239 42.1266 294.229 42.2498C294.22 42.3729 294.236 42.4968 294.276 42.6136C294.316 42.7304 294.38 42.8376 294.464 42.9287C294.547 43.0197 294.649 43.0925 294.762 43.1426C294.875 43.1927 294.997 43.219 295.12 43.2199L300.26 43.6299L297.2 53.5399C297.165 53.6737 297.148 53.8116 297.15 53.9499C297.174 54.1663 297.272 54.3678 297.428 54.5206C297.583 54.6735 297.786 54.7684 298.002 54.7895C298.219 54.8105 298.436 54.7565 298.618 54.6365C298.8 54.5164 298.935 54.3376 299 54.1299L302.37 43.2299V43.0599"
        />
        <path
          d="M285.52 41.7503C285.539 41.6085 285.526 41.4644 285.485 41.3276C285.443 41.1908 285.372 41.0647 285.277 40.9576C285.183 40.8505 285.066 40.7649 284.935 40.7068C284.805 40.6486 284.663 40.6191 284.52 40.6203L278.35 40.2803C278.231 40.2662 278.111 40.2774 277.996 40.3131C277.882 40.3489 277.777 40.4083 277.687 40.4876C277.597 40.5669 277.525 40.6643 277.476 40.7733C277.426 40.8824 277.4 41.0006 277.4 41.1203C277.381 41.2433 277.389 41.3688 277.423 41.4885C277.457 41.6081 277.517 41.7191 277.597 41.8138C277.678 41.9086 277.778 41.985 277.89 42.0379C278.003 42.0907 278.126 42.1189 278.25 42.1203L283.4 42.4103L280.57 52.4103C280.53 52.5431 280.513 52.6818 280.52 52.8203C280.528 52.947 280.562 53.0706 280.621 53.1828C280.681 53.2951 280.763 53.3933 280.864 53.471C280.964 53.5486 281.08 53.6039 281.204 53.6331C281.327 53.6623 281.455 53.6648 281.58 53.6403C281.769 53.6269 281.948 53.5523 282.091 53.4278C282.233 53.3032 282.331 53.1356 282.37 52.9503L285.5 41.9503C285.503 41.8937 285.503 41.8369 285.5 41.7803"
        />
        <path
          d="M319.49 72.1099C319.554 71.8827 319.564 71.6437 319.519 71.412C319.474 71.1803 319.376 70.9621 319.233 70.7749C319.089 70.5876 318.904 70.4363 318.692 70.3331C318.48 70.2298 318.246 70.1774 318.01 70.1799H305.81C305.141 70.172 304.487 70.3811 303.946 70.7759C303.405 71.1706 303.007 71.7299 302.81 72.3699L280.38 145.16C280.31 145.399 280.297 145.651 280.344 145.895C280.391 146.139 280.496 146.369 280.649 146.565C280.803 146.761 281.001 146.917 281.228 147.02C281.454 147.124 281.702 147.172 281.95 147.16H294C294.673 147.152 295.326 146.931 295.865 146.528C296.404 146.126 296.801 145.563 297 144.92L319.49 72.1099Z"
        />
        <path
          d="M345.63 72.11C345.696 71.8835 345.707 71.6447 345.664 71.4129C345.621 71.181 345.524 70.9626 345.381 70.7749C345.238 70.5873 345.053 70.4358 344.841 70.3325C344.629 70.2292 344.396 70.1769 344.16 70.18H332C331.33 70.1705 330.675 70.3789 330.134 70.7739C329.593 71.1689 329.195 71.7291 329 72.37L306.57 145.16C306.497 145.399 306.483 145.652 306.529 145.897C306.575 146.142 306.679 146.373 306.833 146.57C306.987 146.766 307.187 146.922 307.414 147.025C307.642 147.128 307.891 147.174 308.14 147.16H320.21C320.882 147.149 321.533 146.927 322.072 146.525C322.61 146.122 323.008 145.561 323.21 144.92L345.63 72.11Z"
        />
        <path
          d="M178.68 111.16C189.58 108.96 202.99 110.33 202.99 110.33C203.152 110.333 203.312 110.282 203.443 110.187C203.575 110.091 203.672 109.955 203.72 109.8L204.85 106.16C207.05 98.9999 197.38 99.1599 196.21 99.0799C188.939 99.2571 181.712 100.264 174.67 102.08C174.553 102.156 174.415 102.194 174.275 102.189C174.135 102.183 174.001 102.134 173.891 102.048C173.78 101.962 173.7 101.843 173.66 101.709C173.621 101.575 173.624 101.432 173.67 101.3C174.39 99.4899 176 96.0699 176.8 94.2999C176.953 93.9181 177.197 93.5794 177.511 93.3129C177.825 93.0463 178.198 92.86 178.6 92.7699C181.7 91.6399 192.5 89.2699 209.23 90.6799C209.23 90.6799 225.73 92.0699 221.14 106.98L209.45 144.98C209.249 145.618 208.85 146.176 208.311 146.572C207.771 146.968 207.119 147.181 206.45 147.18H178.61C160 147.18 160.14 138.18 160.03 134.86C159.844 131.189 160.504 127.524 161.958 124.148C163.413 120.772 165.624 117.776 168.42 115.39C171.07 113.16 174.57 112.05 178.68 111.21V111.16ZM200.78 119.39C200.8 119.298 200.801 119.202 200.783 119.11C200.765 119.017 200.728 118.929 200.675 118.851C200.621 118.774 200.552 118.708 200.472 118.657C200.392 118.607 200.303 118.574 200.21 118.56C200.21 118.56 186.32 117.43 181.88 121.07C177.13 124.94 176.58 133.26 176.59 133.99C176.59 133.99 176.22 138.34 181.5 138.34H193.61C195.04 138.34 195.24 137.4 195.61 136.34L200.78 119.39Z"
        />
        <path
          d="M351.64 111.16C362.53 108.96 375.95 110.33 375.95 110.33C376.112 110.331 376.271 110.28 376.402 110.185C376.533 110.09 376.631 109.955 376.68 109.8L377.8 106.16C380.01 98.9999 370.34 99.1599 369.17 99.0799C361.903 99.2578 354.679 100.264 347.64 102.08C347.524 102.139 347.393 102.164 347.263 102.15C347.133 102.136 347.01 102.084 346.909 102.001C346.808 101.919 346.734 101.808 346.695 101.683C346.656 101.559 346.654 101.425 346.69 101.3C347.41 99.4899 349.02 96.0699 349.82 94.2999C349.974 93.9181 350.218 93.5794 350.531 93.3129C350.845 93.0463 351.218 92.86 351.62 92.7699C354.71 91.6399 365.52 89.2699 382.24 90.6799C382.24 90.6799 398.75 92.0699 394.16 106.98L382.47 144.98C382.27 145.618 381.87 146.176 381.331 146.572C380.791 146.968 380.139 147.181 379.47 147.18H351.56C332.95 147.18 333.1 138.18 332.98 134.86C332.794 131.189 333.454 127.524 334.908 124.148C336.363 120.772 338.574 117.776 341.37 115.39C344.03 113.16 347.53 112.05 351.64 111.21V111.16ZM373.74 119.39C373.759 119.298 373.759 119.203 373.74 119.111C373.721 119.019 373.684 118.931 373.631 118.854C373.578 118.776 373.51 118.711 373.43 118.66C373.351 118.609 373.263 118.575 373.17 118.56C373.17 118.56 359.28 117.43 354.83 121.07C350.09 124.94 349.54 133.26 349.54 133.99C349.54 133.99 349.18 138.34 354.46 138.34H366.57C368 138.34 368.19 137.4 368.52 136.34L373.74 119.39Z"
        />
        <path
          d="M153.33 72.6298H105.88C105.212 72.5816 104.548 72.7738 104.009 73.1717C103.47 73.5696 103.091 74.147 102.94 74.7999L81.71 143.7C81.5692 144.103 81.5301 144.534 81.5962 144.956C81.6622 145.377 81.8314 145.776 82.0887 146.116C82.346 146.457 82.6834 146.728 83.0709 146.907C83.4584 147.085 83.8841 147.165 84.31 147.14H132.37C156.89 147.14 157.55 119.01 157.55 119.01C157.546 116.677 156.825 114.401 155.485 112.491C154.146 110.581 152.252 109.129 150.06 108.33C149.993 108.301 149.936 108.254 149.895 108.194C149.854 108.133 149.832 108.063 149.83 107.99C149.829 107.91 149.853 107.831 149.9 107.767C149.947 107.702 150.014 107.654 150.09 107.63C153.213 106.837 156.065 105.221 158.35 102.95V102.9C164.86 95.7598 165.06 84.3498 165.06 84.3498C165.059 82.8108 164.754 81.287 164.164 79.8656C163.574 78.4441 162.709 77.1529 161.62 76.0655C160.531 74.9781 159.238 74.1159 157.816 73.5282C156.393 72.9404 154.869 72.6385 153.33 72.6399V72.6298ZM134.18 131.03C133.127 132.972 131.568 134.592 129.668 135.719C127.768 136.846 125.599 137.437 123.39 137.43H104.16C103.932 137.391 103.729 137.264 103.593 137.078C103.456 136.891 103.398 136.659 103.43 136.43L110.43 113.84C110.498 113.665 110.612 113.511 110.76 113.395C110.908 113.279 111.084 113.205 111.27 113.18H134C134.927 113.173 135.828 113.488 136.549 114.072C137.269 114.655 137.765 115.471 137.95 116.38C137.95 116.38 139.27 121.76 134.15 131.03H134.18ZM143.26 97.8398C142.348 99.5187 141 100.92 139.358 101.897C137.716 102.874 135.841 103.39 133.93 103.39H114.63C114.507 103.375 114.389 103.333 114.284 103.267C114.178 103.202 114.089 103.114 114.021 103.01C113.954 102.906 113.91 102.789 113.892 102.666C113.875 102.543 113.884 102.418 113.92 102.3L119.19 85.1899C120.11 82.1899 119.92 82.3998 121.55 82.3998H143.12C143.916 82.3995 144.689 82.6739 145.306 83.1767C145.924 83.6795 146.349 84.3799 146.51 85.1599C146.51 85.1599 147.67 89.8098 143.26 97.8198"
        />
        <path
          d="M286.86 93.1399C286.926 92.912 286.937 92.672 286.893 92.439C286.85 92.2059 286.752 91.9864 286.608 91.7979C286.464 91.6093 286.278 91.4571 286.065 91.3533C285.852 91.2494 285.617 91.1969 285.38 91.1999H273.18C272.511 91.192 271.857 91.4011 271.316 91.7959C270.775 92.1906 270.377 92.7499 270.18 93.3899L254.23 145.17C254.155 145.408 254.139 145.661 254.184 145.906C254.228 146.152 254.331 146.383 254.485 146.58C254.638 146.777 254.837 146.933 255.065 147.036C255.292 147.139 255.541 147.185 255.79 147.17H267.87C268.542 147.157 269.193 146.934 269.731 146.533C270.269 146.131 270.667 145.57 270.87 144.93L286.86 93.1399Z"
        />
        <path
          d="M292 77.8498C291.564 80.1721 290.336 82.2712 288.525 83.7886C286.714 85.3061 284.432 86.1477 282.07 86.1698C277.25 86.1698 273.9 82.4298 274.57 77.8298C275.005 75.5075 276.233 73.4084 278.044 71.8909C279.855 70.3735 282.137 69.5318 284.5 69.5098C289.32 69.5098 292.67 73.2498 292 77.8498Z"
        />
        <path
          d="M264.58 91.5697C259.14 89.5697 252.5 93.4397 250.46 94.7797C250 95.0697 249.93 94.9297 249.98 94.7797L250.78 92.2197C250.94 91.5897 250.59 91.2197 250.14 91.2197H237.14C236.492 91.226 235.862 91.4361 235.34 91.8202C234.817 92.2042 234.429 92.7428 234.23 93.3597L218.23 145.19C218.157 145.428 218.143 145.68 218.189 145.924C218.234 146.169 218.337 146.399 218.49 146.595C218.643 146.791 218.841 146.947 219.068 147.051C219.294 147.155 219.542 147.202 219.79 147.19H231.85C232.528 147.192 233.19 146.978 233.738 146.579C234.287 146.18 234.694 145.616 234.9 144.97L245.9 109.37C246.6 107.12 249.18 98.1197 261.2 101.44C261.94 101.57 262.61 101.6 262.91 100.76C263.31 99.5597 265.32 92.9297 265.32 92.9297C265.365 92.7958 265.382 92.6539 265.369 92.5132C265.355 92.3724 265.312 92.2362 265.242 92.1133C265.172 91.9905 265.077 91.8839 264.963 91.8005C264.849 91.7171 264.718 91.6589 264.58 91.6297"
        />
        <path
          d="M407.59 91.17C405.491 91.1674 403.477 91.9979 401.99 93.4791C400.504 94.9604 399.665 96.9712 399.66 99.07C399.733 101.118 400.598 103.058 402.072 104.481C403.547 105.904 405.516 106.699 407.565 106.699C409.614 106.699 411.584 105.904 413.058 104.481C414.533 103.058 415.397 101.118 415.47 99.07V99.02C415.471 97.9863 415.268 96.9624 414.872 96.0074C414.477 95.0525 413.896 94.1852 413.163 93.4556C412.431 92.726 411.561 92.1485 410.605 91.7562C409.649 91.364 408.624 91.1647 407.59 91.17ZM413.96 99.07C413.994 99.9311 413.854 100.79 413.548 101.596C413.242 102.401 412.776 103.137 412.179 103.758C411.582 104.379 410.865 104.874 410.073 105.211C409.28 105.549 408.427 105.723 407.565 105.723C406.703 105.723 405.851 105.549 405.058 105.211C404.265 104.874 403.548 104.379 402.951 103.758C402.354 103.137 401.888 102.401 401.582 101.596C401.276 100.79 401.136 99.9311 401.17 99.07C401.136 98.2089 401.276 97.3499 401.582 96.5443C401.888 95.7387 402.354 95.0032 402.951 94.3819C403.548 93.7607 404.265 93.2664 405.058 92.9288C405.851 92.5911 406.703 92.4171 407.565 92.4171C408.427 92.4171 409.28 92.5911 410.073 92.9288C410.865 93.2664 411.582 93.7607 412.179 94.3819C412.776 95.0032 413.242 95.7387 413.548 96.5443C413.854 97.3499 413.994 98.2089 413.96 99.07ZM408.05 94.64H405.23C404.988 94.64 404.755 94.7356 404.583 94.9059C404.411 95.0763 404.313 95.3078 404.31 95.55V102.26C404.313 102.502 404.411 102.734 404.583 102.904C404.755 103.074 404.988 103.17 405.23 103.17C405.475 103.173 405.711 103.079 405.887 102.908C406.063 102.738 406.165 102.505 406.17 102.26V100.34H407.68L409.62 102.76C409.701 102.895 409.818 103.004 409.957 103.077C410.097 103.149 410.253 103.181 410.41 103.17C410.639 103.16 410.855 103.061 411.014 102.896C411.172 102.73 411.26 102.509 411.26 102.28C411.255 102.049 411.171 101.826 411.02 101.65L409.64 99.99C410.161 99.801 410.607 99.4508 410.915 98.9903C411.222 98.5299 411.375 97.9832 411.35 97.43C411.36 97.0939 411.303 96.7592 411.183 96.4451C411.063 96.131 410.882 95.8438 410.65 95.6C410.299 95.2828 409.889 95.0388 409.442 94.8826C408.996 94.7263 408.522 94.6608 408.05 94.69V94.64ZM409.47 97.59C409.47 98.29 408.96 98.79 408.03 98.79H406.17V96.33H408C408.92 96.33 409.49 96.74 409.49 97.55L409.47 97.59Z"
        />
        <path
          d="M305 227.7C305 227.418 305.111 227.147 305.31 226.947C305.508 226.746 305.778 226.633 306.06 226.63H437.8C437.94 226.63 438.078 226.658 438.208 226.712C438.337 226.765 438.454 226.844 438.553 226.944C438.651 227.043 438.729 227.161 438.782 227.291C438.835 227.421 438.861 227.56 438.86 227.7C438.861 227.84 438.835 227.979 438.782 228.109C438.729 228.238 438.651 228.356 438.553 228.456C438.454 228.555 438.337 228.634 438.208 228.688C438.078 228.742 437.94 228.77 437.8 228.77H306.08C305.938 228.771 305.798 228.744 305.667 228.691C305.536 228.638 305.417 228.56 305.317 228.46C305.216 228.361 305.136 228.242 305.082 228.112C305.028 227.981 305 227.841 305 227.7ZM42.1997 228.77H173.92C174.202 228.767 174.471 228.653 174.67 228.453C174.868 228.253 174.98 227.982 174.98 227.7C174.98 227.418 174.868 227.147 174.67 226.947C174.471 226.746 174.202 226.633 173.92 226.63H42.1997C42.0596 226.63 41.921 226.658 41.7917 226.712C41.6625 226.765 41.5452 226.844 41.4466 226.944C41.348 227.043 41.2702 227.161 41.2175 227.291C41.1648 227.421 41.1384 227.56 41.1397 227.7C41.1384 227.84 41.1648 227.979 41.2175 228.109C41.2702 228.238 41.348 228.356 41.4466 228.456C41.5452 228.555 41.6625 228.634 41.7917 228.688C41.921 228.742 42.0596 228.77 42.1997 228.77Z"
        />
      </svg>
    </div>
    <!-- Country Selection -->
    <div>
      <span>icon-country-selection</span>
      <svg
        id="icon-country-selection"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleCountrySelection contentCountrySelection"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-country-selection', 'title')"
          id="titleCountrySelection"
        >
          {{ $options.getString('icon-country-selection', 'title') }}
        </title>
        <desc id="contentCountrySelection">
          {{ $options.getString('icon-country-selection', 'description') }}
        </desc>
        <path
          d="M8 15.3334C9.47276 15.3334 10.6667 12.0501 10.6667 8.00002C10.6667 3.94993 9.47276 0.666687 8 0.666687C6.52724 0.666687 5.33333 3.94993 5.33333 8.00002C5.33333 12.0501 6.52724 15.3334 8 15.3334Z"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 6H15"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1 10H15"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 15.3334C12.0501 15.3334 15.3333 12.0501 15.3333 8.00002C15.3333 3.94993 12.0501 0.666687 8 0.666687C3.94991 0.666687 0.666667 3.94993 0.666667 8.00002C0.666667 12.0501 3.94991 15.3334 8 15.3334Z"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- User -->
    <div>
      <span>icon-user</span>
      <svg
        id="icon-user"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleUser contentUser"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-user', 'title')" id="titleUser">
          {{ $options.getString('icon-user', 'title') }}
        </title>
        <desc id="contentUser">
          {{ $options.getString('icon-user', 'description') }}
        </desc>
        <path
          d="M8 7.33335C9.84095 7.33335 11.3333 5.84097 11.3333 4.00002C11.3333 2.15907 9.84095 0.666687 8 0.666687C6.15906 0.666687 4.66667 2.15907 4.66667 4.00002C4.66667 5.84097 6.15906 7.33335 8 7.33335Z"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 15.3333V13.5C14 11.5747 11.3 10 8 10C4.7 10 2 11.5747 2 13.5V15.3333"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Hamburger -->
    <div>
      <span>icon-hamburger</span>
      <svg
        id="icon-hamburger"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleHamburger contentHamburger"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-hamburger', 'title')"
          id="titleHamburger"
        >
          {{ $options.getString('icon-hamburger', 'title') }}
        </title>
        <desc id="contentHamburger">
          {{ $options.getString('icon-hamburger', 'description') }}
        </desc>
        <path
          d="M2 3.33334H14"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 8H14"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 12.6667H14"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 3.33334H14"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 8H14"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 12.6667H14"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Morbido -->
    <div>
      <span>icon-morbido</span>
      <svg
        id="icon-morbido"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleMorbido contentMorbido"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-morbido', 'title')"
          id="titleMorbido"
        >
          {{ $options.getString('icon-morbido', 'title') }}
        </title>
        <desc id="contentMorbido">
          {{ $options.getString('icon-morbido', 'description') }}
        </desc>
        <path
          d="M11.3789 30H60.6179C63.6269 30 66.0899 27.6 66.0899 24.666C66.0899 14.358 52.6199 6 35.9999 6C19.3799 6 5.90991 14.358 5.90991 24.666C5.90991 27.6 8.36991 30 11.3789 30V30Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M35.9099 15V15.03"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.9099 17.97V18"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M50.9099 17.97V18"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M65.9099 45C58.4159 45 58.4159 39 50.9249 39C43.4249 39 43.4249 45 35.9279 45C28.4249 45 28.4249 39 20.9189 39C13.4129 39 13.4159 45 5.90991 45"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.9099 66H14.9099C9.93891 66 5.90991 61.971 5.90991 57C5.90991 55.344 7.25391 54 8.90991 54H62.9099C64.5659 54 65.9099 55.344 65.9099 57C65.9099 61.971 61.8809 66 56.9099 66Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Vassoi -->
    <div>
      <span>icon-vassoi</span>
      <svg
        id="icon-vassoi"
        viewBox="0 0 67 30"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleVassoi contentVassoi"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-vassoi', 'title')"
          id="titleVassoi"
        >
          {{ $options.getString('icon-vassoi', 'title') }}
        </title>
        <desc id="contentVassoi">
          {{ $options.getString('icon-vassoi', 'description') }}
        </desc>
        <path
          d="M57 2V0.5H55.5V2H57ZM65 2H66.5V0.5H65V2ZM57 12.5059V14.0059H58.5V12.5059H57ZM10 12.5059H8.5V14.0059H10V12.5059ZM10 3H11.5V1.5H10V3ZM2 3V1.5H0.5V3H2ZM2 27.8429H0.5V29.3429H2V27.8429ZM64.9999 27.8429V29.3429H66.4999V27.8429H64.9999ZM64.9999 15V13.5H63.4999V15H64.9999ZM65 15V16.5H66.5V15H65ZM57 3.5H65V0.5H57V3.5ZM58.5 12.5059V2H55.5V12.5059H58.5ZM57 11.0059H10V14.0059H57V11.0059ZM11.5 12.5059V3H8.5V12.5059H11.5ZM10 1.5H2V4.5H10V1.5ZM0.5 3V12.5059H3.5V3H0.5ZM0.5 12.5059V15H3.5V12.5059H0.5ZM0.5 15V27.8429H3.5V15H0.5ZM2 29.3429H64.9999V26.3429H2V29.3429ZM66.4999 27.8429V15H63.4999V27.8429H66.4999ZM65 13.5H64.9999V16.5H65V13.5ZM63.5 2V15H66.5V2H63.5Z"
        />
        <rect x="41.7002" y="17.5117" width="17.1" height="5" />
      </svg>
    </div>
    <!-- Close -->
    <div>
      <span>icon-close</span>
      <svg
        id="icon-close"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleClose contentClose"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title v-if="$options.getString('icon-close', 'title')" id="titleClose">
          {{ $options.getString('icon-close', 'title') }}
        </title>
        <desc id="contentClose">
          {{ $options.getString('icon-close', 'description') }}
        </desc>
        <path
          d="M18.71,17.29a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0L12,13.41l-5.29,5.3a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.42L10.59,12,5.29,6.71A1,1,0,0,1,6.71,5.29L12,10.59l5.29-5.3a1,1,0,1,1,1.42,1.42L13.41,12Z"
        />
      </svg>
    </div>
    <!-- Chat hat 2 -->
    <div>
      <span>icon-chef-hat-2</span>
      <svg
        id="icon-chef-hat-2"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleChefHat2 contentChefHat2"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-chef-hat-2', 'title')"
          id="titleChefHat2"
        >
          {{ $options.getString('icon-chef-hat-2', 'title') }}
        </title>
        <desc id="contentChefHat2">
          {{ $options.getString('icon-chef-hat-2', 'description') }}
        </desc>
        <path
          d="M66.6666 63.3333V41.9266C72.5466 39.3533 76.6666 33.4966 76.6666 26.6666C76.6666 17.4633 69.2032 9.99992 59.9999 9.99992C57.9032 9.99992 55.9166 10.4299 54.0666 11.1366C51.1166 6.46325 45.9366 3.33325 39.9999 3.33325C34.0632 3.33325 28.8833 6.46325 25.9333 11.1366C24.0833 10.4299 22.0966 9.99992 19.9999 9.99992C10.7966 9.99992 3.33325 17.4633 3.33325 26.6666C3.33325 33.4966 7.45325 39.3533 13.3333 41.9266V63.3333"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.3333 76.6665H66.6666"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.6665 43.3333V59.9999"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M40 43.3333V59.9999"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M53.3333 43.3333V59.9999"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Timer -->
    <div>
      <span>icon-timer</span>
      <svg
        id="icon-timer"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleTimer contentTimer"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-timer', 'title')" id="titleTimer">
          {{ $options.getString('icon-timer', 'title') }}
        </title>
        <desc id="contentTimer">
          {{ $options.getString('icon-timer', 'description') }}
        </desc>
        <path
          d="M7.33337 23.3333C4.77671 28.3332 3.33337 33.9966 3.33337 39.9999C3.33337 60.2499 19.75 76.6666 40 76.6666C60.25 76.6666 76.6667 60.2499 76.6667 39.9999C76.6667 19.7499 60.25 3.33325 40 3.33325V16.6666"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M40.0001 39.9998L26.6667 26.6665"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Whisk -->
    <div>
      <span>icon-whisk</span>
      <svg
        id="icon-whisk"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleWhisk contentWhisk"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-whisk', 'title')" id="titleWhisk">
          {{ $options.getString('icon-whisk', 'title') }}
        </title>
        <desc id="contentWhisk">
          {{ $options.getString('icon-whisk', 'description') }}
        </desc>
        <path
          d="M46.6667 56.6666C46.6667 56.6666 60 36.6666 60 19.9999C60 3.33325 40 3.33325 40 3.33325C40 3.33325 20 3.33325 20 19.9999C20 36.6666 33.3333 56.6666 33.3333 56.6666"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42.22 56.6666C42.22 56.6666 46.6633 36.6666 46.6633 19.9999C46.6633 3.33325 39.9966 3.33325 39.9966 3.33325C39.9966 3.33325 33.33 3.33325 33.33 19.9999C33.33 36.6666 37.7733 56.6666 37.7733 56.6666"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M40 76.6665C36.3167 76.6665 33.3334 73.6832 33.3334 69.9998V56.6665H46.6667V69.9998C46.6667 73.6832 43.6834 76.6665 40 76.6665Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Truck -->
    <div>
      <span>icon-truck</span>
      <svg
        id="icon-truck"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleTruck contentTruck"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title v-if="$options.getString('icon-truck', 'title')" id="titleTruck">
          {{ $options.getString('icon-truck', 'title') }}
        </title>
        <desc id="contentTruck">
          {{ $options.getString('icon-truck', 'description') }}
        </desc>
        <path
          d="M76.4,33.9l-7.9-9.8c-2.8-3.5-7-5.6-11.6-5.6h-5.4v-1.8c0-4.5-3.7-8.2-8.2-8.2H10c-4.5,0-8.2,3.7-8.2,8.2V60 c0,0.8,0.7,1.5,1.5,1.5h8.6c0.7,5.6,5.6,10,11.4,10c6.3,0,11.5-5.2,11.5-11.5s-5.2-11.5-11.5-11.5c-5.8,0-10.7,4.4-11.4,10H4.8 V16.7c0-2.8,2.3-5.2,5.2-5.2h33.3c2.8,0,5.2,2.3,5.2,5.2V20c0,0.8,0.7,1.5,1.5,1.5h6.9c3.6,0,7,1.6,9.2,4.4l7.4,9.2h-22V23.3 c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v13.3c0,0.8,0.7,1.5,1.5,1.5h25c0,0,0.1,0,0.1,0c0,0.3,0.1,0.6,0.1,0.8v19.5H70 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h6.7c0.8,0,1.5-0.7,1.5-1.5V39C78.2,37.2,77.5,35.3,76.4,33.9z M23.3,51.5 c4.7,0,8.5,3.8,8.5,8.5s-3.8,8.5-8.5,8.5s-8.5-3.8-8.5-8.5S18.6,51.5,23.3,51.5z"
        />
        <path
          d="M56.7,48.5c-6.3,0-11.5,5.2-11.5,11.5s5.2,11.5,11.5,11.5S68.2,66.3,68.2,60S63,48.5,56.7,48.5z M56.7,68.5 c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5S61.4,68.5,56.7,68.5z"
        />
      </svg>
    </div>
    <!-- Double cooking -->
    <div>
      <span>icon-double-cooking</span>
      <svg
        id="icon-double-cooking"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleDoubleCooking contentDoubleCooking"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-double-cooking', 'title')"
          id="titleDoubleCooking"
        >
          {{ $options.getString('icon-double-cooking', 'title') }}
        </title>
        <desc id="contentDoubleCooking">
          {{ $options.getString('icon-double-cooking', 'description') }}
        </desc>
        <path
          d="M49.2,28.8l-3,1.4v-5.6h2c0.5,0,1,0.1,1.4,0.4c0.4,0.3,0.7,0.7,0.8,1.2c0.1,0.5,0.1,1-0.2,1.5 C50.1,28.3,49.7,28.6,49.2,28.8L49.2,28.8z M44.2,36.1c0,1-0.2,1.9-0.6,2.8c-0.4,0.9-0.9,1.7-1.6,2.4c-0.7,0.7-1.5,1.2-2.4,1.6 c-0.9,0.4-1.8,0.5-2.8,0.5H18.2c-1,0-1.9-0.2-2.8-0.6c-0.9-0.4-1.7-0.9-2.4-1.6c-0.7-0.7-1.2-1.5-1.6-2.4c-0.4-0.9-0.6-1.8-0.6-2.8 V24.7h33.3L44.2,36.1z M5.9,28.8c-0.5-0.2-0.8-0.6-1.1-1c-0.2-0.5-0.3-1-0.2-1.5c0.1-0.5,0.4-0.9,0.8-1.2s0.9-0.5,1.4-0.4h2v5.6 L5.9,28.8z M48.3,22.6H6.8c-0.9,0-1.9,0.4-2.6,0.9C3.5,24.1,3,25,2.8,25.9c-0.2,0.9-0.1,1.9,0.3,2.8c0.4,0.9,1.1,1.6,1.9,2l3.9,1.9 v3.5c0,1.2,0.2,2.5,0.7,3.6c0.5,1.1,1.2,2.2,2,3c0.9,0.9,1.9,1.6,3,2c1.1,0.5,2.4,0.7,3.6,0.7h18.7c2.5,0,4.9-1,6.6-2.7 c1.8-1.8,2.7-4.1,2.7-6.6v-3.5l3.9-1.9c0.8-0.4,1.5-1.1,1.9-2c0.4-0.9,0.5-1.8,0.3-2.8c-0.2-0.9-0.7-1.7-1.5-2.3 C50.1,22.9,49.2,22.6,48.3,22.6z"
        />
        <path
          d="M18.6,16.9c-2.1,1.8-1.6,3.6-0.4,3.6c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3 c0.1-0.1,0.1-0.3,0.1-0.4c0-1,2.1-1.3,2.1-3.5c0-2.8-3.5-2.7-1.4-4.4C22,9.8,21.4,8,20.3,8c-0.3,0-0.5,0.1-0.7,0.3 c-0.2,0.2-0.3,0.5-0.3,0.7c0,1-2.1,1.3-2.1,3.5c0,2.2,2.1,2.5,2.1,3.5C19.2,16.3,19.1,16.5,18.6,16.9"
        />
        <path
          d="M35.2,16.9c-2.1,1.8-1.5,3.6-0.4,3.6c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7c0-1,2.1-1.3,2.1-3.5 c0-2.8-3.5-2.7-1.4-4.4C38.6,9.8,38.1,8,36.9,8c-0.3,0-0.5,0.1-0.7,0.3S35.9,8.8,35.9,9c0,1-2.1,1.3-2.1,3.5c0,2.2,2.1,2.5,2.1,3.5 C35.9,16.4,35.7,16.5,35.2,16.9"
        />
        <path
          d="M74.1,54.6l-3,1.4v-5.6h2c0.5,0,1,0.1,1.4,0.4c0.4,0.3,0.7,0.7,0.8,1.2c0.1,0.5,0.1,1-0.2,1.5 C75,54,74.6,54.4,74.1,54.6L74.1,54.6z M69.1,61.8c0,1-0.2,1.9-0.6,2.8c-0.4,0.9-0.9,1.7-1.6,2.4c-0.7,0.7-1.5,1.2-2.4,1.6 c-0.9,0.4-1.8,0.5-2.8,0.5H43.1c-1,0-1.9-0.2-2.8-0.6c-0.9-0.4-1.7-0.9-2.4-1.6c-0.7-0.7-1.2-1.5-1.6-2.4c-0.4-0.9-0.6-1.8-0.6-2.8 V50.4h33.3L69.1,61.8z M30.8,54.6c-0.5-0.2-0.8-0.6-1.1-1c-0.2-0.5-0.3-1-0.2-1.5c0.1-0.5,0.4-0.9,0.8-1.2c0.4-0.3,0.9-0.5,1.4-0.4 h2V56L30.8,54.6z M73.2,48.3H31.7c-0.9,0-1.9,0.4-2.6,0.9c-0.7,0.6-1.3,1.4-1.5,2.3c-0.2,0.9-0.1,1.9,0.3,2.8 c0.4,0.9,1.1,1.6,1.9,2l3.9,1.9v3.5c0,1.2,0.2,2.5,0.7,3.6c0.5,1.1,1.2,2.2,2,3c0.9,0.9,1.9,1.6,3,2c1.1,0.5,2.4,0.7,3.6,0.7h18.7 c2.5,0,4.9-1,6.6-2.7c1.8-1.8,2.7-4.1,2.7-6.6v-3.5l3.9-1.9c0.8-0.4,1.5-1.1,1.9-2c0.4-0.9,0.5-1.8,0.3-2.8 c-0.2-0.9-0.7-1.7-1.5-2.3C75,48.7,74.1,48.3,73.2,48.3z"
        />
        <path
          d="M51.8,42.6c-2.1,1.8-1.5,3.6-0.4,3.6c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7c0-1,2.1-1.3,2.1-3.5 c0-2.8-3.5-2.7-1.4-4.4c2.1-1.7,1.5-3.6,0.4-3.6c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.5-0.3,0.7c0,1-2.1,1.3-2.1,3.5 c0,2.2,2.1,2.5,2.1,3.5C52.5,42.1,52.3,42.2,51.8,42.6z"
        />
        <path
          d="M60.1,42.6c-2.1,1.8-1.5,3.6-0.4,3.6c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.7c0-1,2.1-1.3,2.1-3.5 c0-2.8-3.5-2.7-1.4-4.4s1.6-3.6,0.4-3.6c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.5-0.3,0.7c0,1-2.1,1.3-2.1,3.5 c0,2.2,2.1,2.5,2.1,3.5C60.8,42.1,60.6,42.2,60.1,42.6"
        />
        <path
          d="M26.9,16.9c-2.1,1.8-1.6,3.6-0.4,3.6c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3 c0.1-0.1,0.1-0.3,0.1-0.4c0-1,2.1-1.3,2.1-3.5c0-2.8-3.5-2.7-1.4-4.4C30.3,9.8,29.8,8,28.6,8c-0.3,0-0.5,0.1-0.7,0.3 c-0.2,0.2-0.3,0.5-0.3,0.7c0,1-2.1,1.3-2.1,3.5c0,2.2,2.1,2.5,2.1,3.5C27.5,16.3,27.4,16.5,26.9,16.9"
        />
      </svg>
    </div>
    <!-- Three Pots -->
    <div>
      <span>icon-three-pots</span>
      <svg
        id="icon-three-pots"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleThreePots contentThreePots"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-three-pots', 'title')"
          id="titleThreePots"
        >
          {{ $options.getString('icon-three-pots', 'title') }}
        </title>
        <desc id="contentThreePots">
          {{ $options.getString('icon-three-pots', 'description') }}
        </desc>
        <path
          d="M35.25,53.83c-.34-.15-.62-.42-.78-.75-.17-.33-.21-.71-.13-1.08,.08-.36,.29-.69,.59-.91s.66-.34,1.03-.33h1.48v4.12l-2.18-1.06h-.02Zm3.73-3.07h24.54v8.43c0,.71-.14,1.4-.41,2.06-.27,.65-.67,1.24-1.17,1.74-.5,.5-1.09,.89-1.74,1.16-.65,.27-1.35,.41-2.06,.41h-13.8c-.71,0-1.41-.13-2.06-.4-.65-.27-1.25-.66-1.75-1.16-.5-.5-.9-1.09-1.17-1.74-.27-.65-.41-1.35-.41-2.06l.03-8.43Zm26.07,4.12v-4.12h1.46c.37-.01,.74,.1,1.03,.33s.5,.55,.59,.91c.08,.36,.04,.74-.13,1.08-.17,.33-.44,.6-.78,.75l-2.18,1.06Zm-30.98-4.95c-.54,.44-.93,1.04-1.09,1.72-.16,.68-.09,1.39,.2,2.03,.29,.64,.78,1.16,1.4,1.48l2.87,1.43v2.59c0,1.83,.73,3.59,2.02,4.88,1.29,1.29,3.05,2.02,4.88,2.02h13.8c.91,0,1.81-.18,2.64-.52,.84-.35,1.6-.86,2.24-1.5,.64-.64,1.15-1.4,1.5-2.24,.35-.84,.53-1.74,.52-2.64v-2.59l2.87-1.43c.62-.33,1.11-.85,1.4-1.48,.29-.64,.36-1.35,.2-2.03-.16-.68-.54-1.29-1.09-1.72-.54-.44-1.22-.68-1.91-.7h-30.53c-.7,.01-1.37,.26-1.91,.7Z"
        />
        <path
          class="cls-1"
          d="M50.77,45.05c-1.57,1.31-1.14,2.64-.27,2.64,.2,0,.4-.08,.54-.23,.14-.14,.22-.34,.22-.54s1.53-.93,1.53-2.55c0-2.05-2.59-1.96-1.04-3.25,1.55-1.29,1.14-2.63,.28-2.63-.2,0-.4,.08-.54,.22s-.23,.34-.23,.54c0,.7-1.53,.93-1.53,2.55s1.53,1.85,1.53,2.56c0,.26-.12,.37-.49,.68Z"
        />
        <path
          class="cls-1"
          d="M44.63,45.05c-1.58,1.31-1.15,2.64-.28,2.64,.1,0,.2-.02,.29-.06,.09-.04,.18-.1,.25-.17,.07-.07,.13-.16,.17-.25,.04-.09,.06-.19,.06-.29,0-.7,1.53-.93,1.53-2.55,0-2.05-2.59-1.96-1.04-3.25,1.55-1.29,1.15-2.63,.27-2.63-.2,0-.4,.08-.54,.22-.14,.14-.22,.34-.22,.54s-1.53,.93-1.53,2.55,1.53,1.85,1.53,2.56c0,.26-.12,.37-.49,.68"
        />
        <path
          class="cls-1"
          d="M56.9,45.05c-1.57,1.31-1.14,2.64-.27,2.64,.2,0,.4-.08,.54-.22,.14-.14,.22-.34,.22-.54,0-.7,1.53-.93,1.53-2.55,0-2.05-2.59-1.96-1.05-3.25,1.55-1.29,1.15-2.63,.28-2.63-.2,0-.4,.08-.54,.22-.14,.14-.22,.34-.22,.54,0,.72-1.54,.93-1.54,2.57s1.53,1.85,1.53,2.56c0,.26-.12,.37-.49,.68"
        />
        <path
          class="cls-1"
          d="M35.25,21.24c-.34-.15-.62-.42-.78-.75-.17-.33-.21-.71-.13-1.08,.08-.36,.29-.68,.59-.91,.3-.23,.66-.34,1.03-.33h1.48v4.12l-2.18-1.06h-.02Zm3.73-3.07h24.54v8.43c0,.71-.14,1.4-.41,2.06-.27,.65-.67,1.24-1.17,1.74-.5,.5-1.09,.89-1.74,1.16-.65,.27-1.35,.41-2.06,.41h-13.8c-.71,0-1.41-.13-2.06-.4-.65-.27-1.25-.66-1.75-1.16-.5-.5-.9-1.09-1.17-1.74-.27-.65-.41-1.35-.41-2.06l.03-8.43Zm26.07,4.12v-4.12h1.46c.37-.01,.74,.1,1.03,.33,.3,.23,.5,.55,.59,.91,.08,.36,.04,.74-.13,1.08-.17,.33-.44,.6-.78,.75l-2.18,1.06Zm-30.98-4.95c-.54,.44-.93,1.04-1.09,1.72-.16,.68-.09,1.39,.2,2.03,.29,.64,.78,1.16,1.4,1.48l2.87,1.43v2.59c0,1.83,.73,3.59,2.02,4.88,1.29,1.29,3.05,2.02,4.88,2.02h13.8c.91,0,1.81-.18,2.64-.52,.84-.35,1.6-.86,2.24-1.5,.64-.64,1.15-1.4,1.5-2.24,.35-.84,.53-1.74,.52-2.64v-2.59l2.87-1.43c.62-.33,1.11-.85,1.4-1.48,.29-.64,.36-1.35,.2-2.03-.16-.68-.54-1.29-1.09-1.72-.54-.44-1.22-.68-1.91-.7h-30.53c-.7,.01-1.37,.26-1.91,.7Z"
        />
        <path
          class="cls-1"
          d="M44.63,12.47c-1.57,1.31-1.14,2.64-.27,2.64,.2,0,.4-.08,.54-.23,.14-.14,.22-.34,.22-.54,0-.7,1.53-.93,1.53-2.55s-2.59-1.96-1.04-3.25c1.55-1.29,1.14-2.63,.28-2.63-.2,0-.4,.08-.54,.22-.14,.14-.23,.34-.23,.54,0,.7-1.53,.93-1.53,2.55s1.53,1.85,1.53,2.56c0,.26-.12,.37-.49,.68Z"
        />
        <path
          class="cls-1"
          d="M50.76,12.47c-1.57,1.31-1.14,2.64-.27,2.64,.2,0,.4-.08,.54-.22,.14-.14,.22-.34,.22-.54,0-.7,1.53-.93,1.53-2.55s-2.59-1.96-1.05-3.25,1.15-2.63,.28-2.63c-.2,0-.4,.08-.54,.22-.14,.14-.22,.34-.22,.54,0,.72-1.54,.93-1.54,2.57,0,1.64,1.53,1.85,1.53,2.56,0,.26-.12,.37-.49,.68"
        />
        <path
          class="cls-1"
          d="M4.75,38.05c-.34-.15-.62-.42-.78-.75-.17-.33-.21-.71-.13-1.08,.08-.36,.29-.68,.59-.91,.3-.23,.66-.34,1.03-.33h1.48v4.12l-2.18-1.06h-.02Zm3.73-3.07h24.54v8.43c0,.71-.14,1.4-.41,2.06-.27,.65-.67,1.24-1.17,1.74-.5,.5-1.09,.89-1.74,1.16-.65,.27-1.35,.41-2.06,.41H13.85c-.71,0-1.41-.13-2.06-.4-.65-.27-1.25-.66-1.75-1.16-.5-.5-.9-1.09-1.17-1.74-.27-.65-.41-1.35-.41-2.06l.03-8.43Zm26.07,4.12v-4.12h1.46c.37-.01,.74,.1,1.03,.33,.3,.23,.5,.55,.59,.91,.08,.36,.04,.74-.13,1.08-.17,.33-.44,.6-.78,.75l-2.18,1.06ZM3.57,34.16c-.54,.44-.93,1.04-1.09,1.72-.16,.68-.09,1.39,.2,2.03,.29,.64,.78,1.16,1.4,1.48l2.87,1.43v2.59c0,1.83,.73,3.59,2.02,4.88,1.29,1.29,3.05,2.02,4.88,2.02h13.8c.91,0,1.81-.18,2.64-.52,.84-.35,1.6-.86,2.24-1.5,.64-.64,1.15-1.4,1.5-2.24,.35-.84,.53-1.74,.52-2.64v-2.59l2.87-1.43c.62-.33,1.11-.85,1.4-1.48,.29-.64,.36-1.35,.2-2.03-.16-.68-.54-1.29-1.09-1.72-.54-.44-1.22-.68-1.91-.7H5.48c-.7,.01-1.37,.26-1.91,.7Z"
        />
        <path
          class="cls-1"
          d="M20.26,29.28c-1.57,1.31-1.14,2.64-.27,2.64,.2,0,.4-.08,.54-.22,.14-.14,.22-.34,.22-.54,0-.7,1.53-.93,1.53-2.55s-2.59-1.96-1.05-3.25,1.15-2.63,.28-2.63c-.2,0-.4,.08-.54,.22-.14,.14-.22,.34-.22,.54,0,.72-1.54,.93-1.54,2.57,0,1.64,1.53,1.85,1.53,2.56,0,.26-.12,.37-.49,.68"
        />
      </svg>
    </div>
    <!-- Home Delivery -->
    <div>
      <span>icon-home-delivery</span>
      <svg
        id="icon-home-delivery"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleHomeDelivery contentHomeDelivery"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-home-delivery', 'title')"
          id="titleHomeDelivery"
        >
          {{ $options.getString('icon-home-delivery', 'title') }}
        </title>
        <desc id="contentHomeDelivery">
          {{ $options.getString('icon-home-delivery', 'description') }}
        </desc>
        <path
          d="M74.2,54c0.2-1.3,0.4-5.7-5.1-9c0.6-2.3,0.9-7.6-6.3-14.2c0,0,0,0,0.1-0.1c1.2-1,1.8-3,1.8-5.9 c0-1.8-0.6-3.2-1.8-4.2c-2.5-1.9-6.6-0.8-6.6-0.8l-0.1,0c-1.5,0.6-2.8,1.2-3.9,1.8l-3-2.7l2.1-2l-1.4-1.4l-5.7,5.6l1.4,1.4l2.2-2.2 l2.7,2.4c-1.5,1.1-2.3,2.2-2.4,3.3c0,0.5,0,0.9,0.2,1.2h-3.5v1.9H50l2.1,1.8l0.1,0.1h0c0,0,0.1,0,0.1,0.1h0 c0.9,0.3,4.9,2.2,4.9,8.9c0,6.7-2.3,11.1-7.5,13.4c-1.7,0.8-3.4,0.7-4.7-0.3c-2.2-1.6-3.2-5.5-2.7-10.6c1.5-0.7,2.5-2.2,2.5-3.9 c0-1.9-1.3-3.6-3-4.1V10c0-0.5-0.4-1-1-1H12.5c-0.5,0-1,0.4-1,1v25.5c-1.1,0.8-1.7,2.1-1.7,3.4c0,2.2,1.7,4.1,3.9,4.3 c-0.1,0.1-0.3,0.2-0.4,0.3C2.7,43.7,2,52.1,2,52.2v1.4c0,0.5,0.4,1,1,1h2.7c-1,2.5-1.5,4.6-1.7,5.4c-0.1,0.3,0,0.6,0.2,0.8 c0.2,0.2,0.5,0.3,0.8,0.3h3.2c0.5,5.5,4.8,9.8,10.1,9.8c5.3,0,9.7-4.2,10.1-9.8h26.9c0.3,0,0.6-0.1,0.7-0.3l0.7-0.8 c0,0.3,0,0.5,0,0.8C56.8,65.8,60.9,71,66.8,71C72.4,71,77,66.4,77,60.9C77,57.5,75.2,55,74.2,54L74.2,54z M25.5,61.2h0.9 c-0.4,4.4-4,7.8-8.2,7.8s-7.7-3.4-8.2-7.8h2.4 M12.4,61.2h13.1H12.4z M40,10.9v23.6H13.5V10.9H40z M40.6,36.5 c1.3,0,2.4,1.1,2.4,2.4c0,1.3-1.1,2.4-2.4,2.4H14.2c-1.3,0-2.4-1.1-2.4-2.4v-0.2c0.1-1.2,1.1-2.2,2.4-2.2H40.6z M10.6,46.3 l-0.2,0.2c-0.7,0.9-1.4,1.9-2,2.9l-0.1,0.2c-0.6,1-1.2,2-1.7,3.1H4v-0.4c0-0.2,0.6-5.6,7.1-6.7C10.9,45.9,10.7,46.1,10.6,46.3z M6.9,53.1L6.9,53.1L6.9,53.1L6.9,53.1z M7.9,54.3L8.1,54c0.4-0.6,3.8-6.2,14.8-6.2c3.3,0,5.8,1,7.5,2.9c2.5,2.8,2.8,6.9,2.8,8.7 h-27C6.5,58.1,7,56.3,7.9,54.3L7.9,54.3z M35.2,59.3c0-2.2-0.3-6.7-3.3-10c-2.1-2.3-5.1-3.5-9-3.5c-5.3,0-9,1.2-11.5,2.6l0.4-0.6 c0.1-0.1,0.2-0.2,0.2-0.2l2.3-2.3c0.9-0.8,1.9-1.5,3-2h23.2C40.1,48.8,41.3,53,44,55c1.9,1.4,4.2,1.5,6.6,0.5 c6-2.6,8.6-7.3,8.6-15.2c0-4.5-1.6-7.3-3.4-8.9h4.7c8.6,7.4,6.8,12.8,6.4,13.7L54.8,59.3L35.2,59.3L35.2,59.3z M61.6,22.2 c0.7,0.5,1,1.4,1,2.6c0,2.9-0.7,4-1.1,4.4c-0.1,0.1-0.2,0.2-0.3,0.2c-0.7-0.6-2.7-2.6-3.7-7.8C58.6,21.4,60.5,21.3,61.6,22.2 L61.6,22.2z M58.6,29.4h-5.5L50.3,27l0,0c0,0-0.4-0.3-0.3-0.7c0-0.4,0.6-1.9,5.7-4.2C56.4,25.8,57.6,28,58.6,29.4z M68,55.1h3.9 l0.7,0c0.6,0.7,2.4,2.8,2.4,5.8c0,4.4-3.5,8-7.8,8.2h-0.4c-4.8,0-8.1-4.2-8.2-8.2c0-1.3,0.3-2.6,1-3.9c0,0,0,0,0,0l1.3-1.8 M60.9,55.1c1.8,0,6,0,7.1,0L60.9,55.1z M72.4,53.1l-9.7,0l5.5-6.5C72.1,49,72.5,51.8,72.4,53.1z"
        />
      </svg>
    </div>
    <!-- Food Cost -->
    <div>
      <span>icon-food-cost</span>
      <svg
        id="icon-food-cost"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleFoodCost contentFoodCost"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-food-cost', 'title')"
          id="titleFoodCost"
        >
          {{ $options.getString('icon-food-cost', 'title') }}
        </title>
        <desc id="contentFoodCost">
          {{ $options.getString('icon-food-cost', 'description') }}
        </desc>
        <path
          d="M70.3,46.1C70.3,46.1,70.3,46.1,70.3,46.1c0.1-0.2,0.1-0.3,0.2-0.4c0,0,0,0,0-0.1c0-0.1,0-0.2,0-0.3
	c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2-0.1-0.3c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1-0.1-0.2-0.2-0.3c0,0,0,0-0.1-0.1
	c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.4-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.3-0.1-0.4-0.1h-1.5v-3.4
	c0-12.8-11.2-23.4-25.8-25.6c1.1-1.3,1.8-3,1.8-4.9c0-4.1-3.4-7.5-7.5-7.5s-7.5,3.3-7.5,7.5c0,1.9,0.7,3.6,1.8,4.9
	C15.7,17,4.5,27.7,4.5,40.4v3.4H3c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h5.5l-6.6,7.7c-0.5,0.6-0.5,1.6,0.2,2.1
	c0.3,0.2,0.6,0.4,1,0.4c0.4,0,0.8-0.2,1.1-0.5l8.3-9.7h22.1l5.8,6.4H20.6c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h23.2
	c0.2,0,0.3,0,0.5-0.1c0,0,0.1,0,0.1,0c0.2-0.1,0.3-0.2,0.4-0.3c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1l7.5-8.8h12.7L44.9,65.5
	H3.4c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h42c0.4,0,0.7-0.1,1-0.4L70,46.4c0,0,0,0,0,0C70.1,46.3,70.2,46.2,70.3,46.1z M31.5,9.9
	c0-2.5,2-4.5,4.5-4.5s4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5c0,0,0,0,0,0s0,0,0,0C33.5,14.4,31.5,12.4,31.5,9.9z M43.8,52.4l-5.1-5.6
	h9.9L43.8,52.4z M51.8,43.8H35.2H11.8H7.5v-3.4c0-12.7,12.8-23,28.5-23c0,0,0,0,0,0s0,0,0,0c15.7,0,28.5,10.3,28.5,23v3.4H51.8z"
        />
      </svg>
    </div>
    <!-- Pretagliati -->
    <div>
      <span>icon-pretagliati</span>
      <svg
        id="icon-pretagliati"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePretagliati contentPretagliati"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-pretagliati', 'title')"
          id="titlePretagliati"
        >
          {{ $options.getString('icon-pretagliati', 'title') }}
        </title>
        <desc id="contentPretagliati">
          {{ $options.getString('icon-pretagliati', 'description') }}
        </desc>
        <path
          d="M13.5,43c-3.1,0-5.9-2-6.7-5C4,27.2,15.3,14.8,32.2,10.3c8-2.1,16.1-2.2,22.8-0.2c6.9,2.1,11.5,6.2,12.9,11.5
		c0.5,1.8,0.2,3.6-0.7,5.2c-0.9,1.6-2.4,2.7-4.2,3.2L15.3,42.8C14.7,42.9,14.1,43,13.5,43z M14.9,41.3L14.9,41.3L14.9,41.3z
		 M44.4,11.7c-3.7,0-7.6,0.5-11.5,1.6C17.7,17.3,7.3,28,9.7,37.2c0.5,2,2.7,3.2,4.8,2.7l47.6-12.7c1-0.3,1.9-0.9,2.4-1.8
		c0.5-0.9,0.7-1.9,0.4-2.9c-1.1-4.3-5-7.6-10.9-9.4C51.1,12.1,47.9,11.7,44.4,11.7z"
        />
        <path
          d="M34.8,22c-0.7,0-1.3-0.4-1.4-1.1c-0.2-0.8,0.3-1.6,1.1-1.9c0.8-0.2,1.6,0.2,1.8,1l0,0c0.2,0.8-0.3,1.6-1.1,1.8
		C35,22,34.9,22,34.8,22z"
        />
        <path
          d="M21.1,28.8c-0.7,0-1.3-0.4-1.4-1.1c-0.2-0.8,0.3-1.6,1.1-1.9c0.8-0.2,1.6,0.2,1.8,1l0,0
		c0.2,0.8-0.3,1.6-1.1,1.8C21.3,28.7,21.2,28.8,21.1,28.8z"
        />
        <path
          d="M50,21c-0.7,0-1.3-0.4-1.4-1.1c-0.2-0.8,0.3-1.6,1.1-1.9c0.8-0.2,1.6,0.2,1.8,1l0,0c0.2,0.8-0.3,1.6-1.1,1.8
		C50.3,21,50.2,21,50,21z"
        />
        <path
          d="M56.5,68.5h-42C8.8,68.5,4,63.8,4,58c0-2.5,2-4.5,4.5-4.5h54c2.5,0,4.5,2,4.5,4.5C67,63.8,62.3,68.5,56.5,68.5
		z M8.5,56.5C7.7,56.5,7,57.2,7,58c0,4.1,3.4,7.5,7.5,7.5h42c4.1,0,7.5-3.4,7.5-7.5c0-0.8-0.7-1.5-1.5-1.5H8.5z"
        />
      </svg>
    </div>
    <!-- Temperatura -->
    <div>
      <span>icon-temperatura</span>
      <svg
        id="icon-temperatura"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleTemperatura contentTemperatura"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-temperatura', 'title')"
          id="titleTemperatura"
        >
          {{ $options.getString('icon-temperatura', 'title') }}
        </title>
        <desc id="contentTemperatura">
          {{ $options.getString('icon-temperatura', 'description') }}
        </desc>
        <path
          d="M24.7,49.8V23.5c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v26.3c-1.8,0.6-3,2.3-3,4.2c0,2.5,2,4.5,4.5,4.5
		s4.5-2,4.5-4.5C27.8,52,26.5,50.4,24.7,49.8z"
        />
        <path
          d="M47.7,3.5c-4.7,0-9.1,1.8-12.5,5c-2.3-4.2-6.8-7-12-7C15.7,1.5,9.6,7.6,9.6,15v29.6c-2,2.8-3,6-3,9.4
		c0,9.1,7.5,16.5,16.7,16.5S39.9,63.1,39.9,54c0-3.4-1-6.6-3-9.4v-9.1c3.1,2.1,7.2,3.8,10.8,3.8c10,0,18.1-8,18.1-17.9
		C65.8,11.6,57.7,3.5,47.7,3.5z M36.9,54c0,7.4-6.1,13.5-13.7,13.5c-7.6,0-13.7-6.1-13.7-13.5c0-2.9,0.9-5.6,2.7-8
		c0.2-0.3,0.3-0.6,0.3-0.9V15c0-5.8,4.8-10.5,10.7-10.5S33.9,9.2,33.9,15v30.1c0,0.3,0.1,0.6,0.3,0.9C36,48.4,36.9,51.1,36.9,54z
		 M47.7,36.3c-3.5,0-8.1-2.3-10.8-4.5c0,0,0,0,0,0V15c0-1.2-0.2-2.3-0.5-3.4l0.6-0.7c2.8-2.8,6.6-4.3,10.6-4.3
		c8.3,0,15.1,6.7,15.1,14.9C62.8,29.7,56.1,36.3,47.7,36.3z"
        />
        <path
          d="M53.9,15.7c-0.7-0.5-1.6-0.3-2.1,0.4l-5.2,7.7l-3.3-2.2c-0.7-0.5-1.6-0.3-2.1,0.4c-0.5,0.7-0.3,1.6,0.4,2.1
		l4.5,3c0.3,0.2,0.5,0.2,0.8,0.2c0.5,0,1-0.2,1.2-0.7l6.1-8.9C54.7,17.1,54.6,16.2,53.9,15.7z"
        />
      </svg>
    </div>
    <!-- ZoomIn -->
    <div>
      <span>icon-zoom-in</span>
      <svg
        id="icon-zoom-in"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleZoomIn contentZoomIn"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
        style="color: transparent"
      >
        <title
          v-if="$options.getString('icon-zoom-in', 'title')"
          id="titleZoomIn"
        >
          {{ $options.getString('icon-zoom-in', 'title') }}
        </title>
        <desc id="contentZoomIn">
          {{ $options.getString('icon-zoom-in', 'description') }}
        </desc>
        <path
          d="M0 0H72C76.4183 0 80 3.58172 80 8V80L0 0Z"
          fill="#EBEEF3"
          fill-opacity="0.75"
        />
        <g opacity="0.9" filter="url(#filter0_dddd_587_26189)">
          <path
            d="M53.3333 17.3333V25.3333"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M49.3333 21.3333H57.3333"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M53.3333 32C59.2243 32 64 27.2244 64 21.3333C64 15.4423 59.2243 10.6667 53.3333 10.6667C47.4423 10.6667 42.6666 15.4423 42.6666 21.3333C42.6666 27.2244 47.4423 32 53.3333 32Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M69.3333 37.3333L61.3333 29.3333"
            stroke="currentColor"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <filter
            id="filter0_dddd_587_26189"
            x="33"
            y="7"
            width="46"
            height="57"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_587_26189"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_587_26189"
              result="effect2_dropShadow_587_26189"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="10" />
            <feGaussianBlur stdDeviation="3" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
            />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_587_26189"
              result="effect3_dropShadow_587_26189"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="17" />
            <feGaussianBlur stdDeviation="3.5" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
            />
            <feBlend
              mode="normal"
              in2="effect3_dropShadow_587_26189"
              result="effect4_dropShadow_587_26189"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect4_dropShadow_587_26189"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </div>
    <!-- ZoomIn -->
    <!-- ZoomIn HOVER-->
    <div>
      <span>icon-zoom-in-hover</span>
      <svg
        id="icon-zoom-in-hover"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleZoomInHover contentZoomInHover"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
        style="color: transparent"
      >
        <title
          v-if="$options.getString('icon-zoom-in-hover', 'title')"
          id="titleZoomInHover"
        >
          {{ $options.getString('icon-zoom-in-hover', 'title') }}
        </title>
        <desc id="contentZoomInHover">
          {{ $options.getString('icon-zoom-in-hover', 'description') }}
        </desc>
        <path
          d="M0 0H72C76.4183 0 80 3.58172 80 8V80L0 0Z"
          fill="#D9DFE8"
          fill-opacity="0.75"
        />
        <g opacity="0.9">
          <path
            d="M53.3335 17.3333V25.3333"
            stroke="#203E84"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M49.3335 21.3333H57.3335"
            stroke="#203E84"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M53.3334 32C59.2245 32 64.0001 27.2244 64.0001 21.3333C64.0001 15.4423 59.2245 10.6667 53.3334 10.6667C47.4424 10.6667 42.6667 15.4423 42.6667 21.3333C42.6667 27.2244 47.4424 32 53.3334 32Z"
            stroke="#203E84"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M69.3335 37.3333L61.3335 29.3333"
            stroke="#203E84"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </div>
    <!-- ZoomOut -->
    <div>
      <span>icon-zoom-out</span>
      <svg
        id="icon-zoom-out"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleZoomOut contentZoomOut"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-zoom-out', 'title')"
          id="titleZoomOut"
        >
          {{ $options.getString('icon-zoom-out', 'title') }}
        </title>
        <desc id="contentZoomOut">
          {{ $options.getString('icon-zoom-out', 'description') }}
        </desc>
        <path
          d="M15.9999 30.6667C24.1001 30.6667 30.6666 24.1002 30.6666 16C30.6666 7.89982 24.1001 1.33333 15.9999 1.33333C7.89974 1.33333 1.33325 7.89982 1.33325 16C1.33325 24.1002 7.89974 30.6667 15.9999 30.6667Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.7706 12.2293L12.2292 19.7707"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.2292 12.2293L19.7706 19.7707"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Arrow Left -->
    <div>
      <span>icon-arrow-left</span>
      <svg
        id="icon-arrow-left"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleArrowLeft contentArrowLeft"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-arrow-left', 'title')"
          id="titleArrowLeft"
        >
          {{ $options.getString('icon-arrow-left', 'title') }}
        </title>
        <desc id="contentArrowLeft">
          {{ $options.getString('icon-arrow-left', 'description') }}
        </desc>
        <path
          d="M11 5L3 12L11 19"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 12H21"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Arrow Right -->
    <div>
      <span>icon-arrow-right</span>
      <svg
        id="icon-arrow-right"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleArrowRight contentArrowRight"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-arrow-right', 'title')"
          id="titleArrowRight"
        >
          {{ $options.getString('icon-arrow-right', 'title') }}
        </title>
        <desc id="contentArrowRight">
          {{ $options.getString('icon-arrow-right', 'description') }}
        </desc>
        <path
          d="M13 19L21 12L13 5"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 12H3"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Arrow Up Right -->
    <div>
      <span>icon-arrow-up-right</span>
      <svg
        id="icon-arrow-up-right"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleArrowUpRight contentArrowUpRight"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-arrow-up-right', 'title')"
          id="titleArrowUpRight"
        >
          {{ $options.getString('icon-arrow-up-right', 'title') }}
        </title>
        <desc id="contentArrowUpRight">
          {{ $options.getString('icon-arrow-up-right', 'description') }}
        </desc>
        <path
          d="M18 17V6H7"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 6L5 19"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Download -->
    <div>
      <span>icon-download</span>
      <svg
        id="icon-download"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleDownload contentDownload"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-download', 'title')"
          id="titleDownload"
        >
          {{ $options.getString('icon-download', 'title') }}
        </title>
        <desc id="contentDownload">
          {{ $options.getString('icon-download', 'description') }}
        </desc>
        <path
          d="M5 21H19"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 11L12 15L16 11"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 15V3"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Upload -->
    <div>
      <span>icon-upload</span>
      <svg
        id="icon-upload"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleUpload contentUpload"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-upload', 'title')"
          id="titleUpload"
        >
          {{ $options.getString('icon-upload', 'title') }}
        </title>
        <desc id="contentUpload">
          {{ $options.getString('icon-upload', 'description') }}
        </desc>
        <path
          d="M5 21.5H19"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 7.5L12 3.5L8 7.5"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 3.5V15.5"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Caret Down -->
    <div>
      <span>icon-caret-down</span>
      <svg
        id="icon-caret-down"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleCaretDown contentCaretDown"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-caret-down', 'title')"
          id="titleCaretDown"
        >
          {{ $options.getString('icon-caret-down', 'title') }}
        </title>
        <desc id="contentCaretDown">
          {{ $options.getString('icon-caret-down', 'description') }}
        </desc>
        <path
          d="M5 9L12 17L19 9"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Caret Right -->
    <div>
      <span>icon-caret-right</span>
      <svg
        id="icon-caret-right"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleCaretRight contentCaretRight"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-caret-right', 'title')"
          id="titleCaretRight"
        >
          {{ $options.getString('icon-caret-right', 'title') }}
        </title>
        <desc id="contentCaretRight">
          {{ $options.getString('icon-caret-right', 'description') }}
        </desc>
        <path
          d="M6 12.6667L11.3333 8.00001L6 3.33334"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Caret Left -->
    <div>
      <span>icon-caret-left</span>
      <svg
        id="icon-caret-left"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleCaretLeft contentCaretLeft"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-caret-left', 'title')"
          id="titleCaretLeft"
        >
          {{ $options.getString('icon-caret-left', 'title') }}
        </title>
        <desc id="contentCaretLeft">
          {{ $options.getString('icon-caret-left', 'description') }}
        </desc>
        <path
          d="M9.99996 3.33334L4.66663 8.00001L9.99996 12.6667"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Scroll Down -->
    <div>
      <span>icon-scroll-down</span>
      <svg
        id="icon-scroll-down"
        viewBox="0 0 24 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleScrollDown contentScrollDown"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-scroll-down', 'title')"
          id="titleScrollDown"
        >
          {{ $options.getString('icon-scroll-down', 'title') }}
        </title>
        <desc id="contentScrollDown">
          {{ $options.getString('icon-scroll-down', 'description') }}
        </desc>
        <path
          d="M5 9H19"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 1V9"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 23C8.134 23 5 19.866 5 16V5C5 2.791 6.791 1 9 1H15C17.209 1 19 2.791 19 5V16C19 19.866 15.866 23 12 23Z"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.33325 34L11.9999 39.3333L16.6666 34"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Print -->
    <div>
      <span>icon-print</span>
      <svg
        id="icon-print"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePrint contentPrint"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-print', 'title')" id="titlePrint">
          {{ $options.getString('icon-print', 'title') }}
        </title>
        <desc id="contentPrint">
          {{ $options.getString('icon-print', 'description') }}
        </desc>
        <path
          d="M19 11V23H5V11"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 15H9"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 19H9"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 3H18L16 1H8L6 3H3C1.896 3 1 3.895 1 5V9C1 10.104 1.896 11 3 11H21C22.104 11 23 10.104 23 9V5C23 3.895 22.104 3 21 3Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Calendar -->
    <div>
      <span>icon-calendar</span>
      <svg
        id="icon-calendar"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleCalendar contentCalendar"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMinYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-calendar', 'title')"
          id="titleCalendar"
        >
          {{ $options.getString('icon-calendar', 'title') }}
        </title>
        <desc id="contentCalendar">
          {{ $options.getString('icon-calendar', 'description') }}
        </desc>
        <path
          d="M1 10H23"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 23H3C1.895 23 1 22.104 1 21V5C1 3.895 1.896 3 3 3H21C22.105 3 23 3.896 23 5V21C23 22.104 22.104 23 21 23Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 1V6"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 1V6"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Clock -->
    <div>
      <span>icon-clock</span>
      <svg
        id="icon-clock"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleClock contentClock"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMinYMid"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-clock', 'title')" id="titleClock">
          {{ $options.getString('icon-clock', 'title') }}
        </title>
        <desc id="contentClock">
          {{ $options.getString('icon-clock', 'description') }}
        </desc>
        <path
          d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8 13H12V7"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Pinmap -->
    <div>
      <span>icon-pinmap</span>
      <svg
        id="icon-pinmap"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePinmap contentPinmap"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMinYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-pinmap', 'title')"
          id="titlePinmap"
        >
          {{ $options.getString('icon-pinmap', 'title') }}
        </title>
        <desc id="contentPinmap">
          {{ $options.getString('icon-pinmap', 'description') }}
        </desc>
        <path
          d="M12 23V13"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 13C15.3137 13 18 10.3137 18 7C18 3.68629 15.3137 1 12 1C8.68629 1 6 3.68629 6 7C6 10.3137 8.68629 13 12 13Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 4.98999V4.99999"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Email -->
    <div>
      <span>icon-email</span>
      <svg
        id="icon-email"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleEmail contentEmail"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-email', 'title')" id="titleEmail">
          {{ $options.getString('icon-email', 'title') }}
        </title>
        <desc id="contentEmail">
          {{ $options.getString('icon-email', 'description') }}
        </desc>
        <path
          d="M1 8.12451L10.324 12.4239C11.388 12.9145 12.613 12.9145 13.676 12.4239L23 8.12451"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 21.1906H3C1.895 21.1906 1 20.2963 1 19.1922V5.2039C1 4.09982 1.895 3.20557 3 3.20557H21C22.105 3.20557 23 4.09982 23 5.2039V19.1922C23 20.2963 22.105 21.1906 21 21.1906Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Facebook -->
    <div>
      <span>icon-facebook</span>
      <svg
        id="icon-facebook"
        viewBox="0 0 24 25"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleFacebook contentFacebook"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-facebook', 'title')"
          id="titleFacebook"
        >
          {{ $options.getString('icon-facebook', 'title') }}
        </title>
        <desc id="contentFacebook">
          {{ $options.getString('icon-facebook', 'description') }}
        </desc>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 12.265C0 18.2265 4.33333 23.1832 10 24.188L10.0682 24.1332C10.0455 24.1287 10.0227 24.1243 9.99994 24.1197V15.6128H6.99994V12.2637H9.99994V9.58433C9.99994 6.57008 11.9333 4.8955 14.6666 4.8955C15.5333 4.8955 16.4666 5.02947 17.3333 5.16343V8.24466H15.7999C14.3333 8.24466 13.9999 8.98148 13.9999 9.91924V12.2637H17.1999L16.6666 15.6128H13.9999V24.1197C13.9772 24.1242 13.9545 24.1287 13.9318 24.1331L14 24.188C19.6667 23.1832 24 18.2265 24 12.265C24 5.63365 18.6 0.208008 12 0.208008C5.4 0.208008 0 5.63365 0 12.265Z"
        />
      </svg>
    </div>
    <!-- Instagram -->
    <div>
      <span>icon-instagram</span>
      <svg
        id="icon-instagram"
        viewBox="0 0 24 25"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleInstagram contentInstagram"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-instagram', 'title')"
          id="titleInstagram"
        >
          {{ $options.getString('icon-instagram', 'title') }}
        </title>
        <desc id="contentInstagram">
          {{ $options.getString('icon-instagram', 'description') }}
        </desc>
        <path
          d="M12.0011 0.208008C8.74209 0.208008 8.33309 0.222246 7.05307 0.280448C5.77556 0.338899 4.90355 0.54098 4.14054 0.837482C3.35128 1.14373 2.68178 1.55338 2.01477 2.22008C1.34726 2.88652 0.937259 3.55546 0.629756 4.3438C0.332253 5.10642 0.129751 5.97794 0.0722506 7.25388C0.015 8.53281 0 8.94172 0 12.198C0 15.4543 0.0145004 15.8617 0.072501 17.1406C0.131252 18.4171 0.333504 19.2883 0.630007 20.0507C0.93676 20.8393 1.34676 21.5082 2.01402 22.1747C2.68078 22.8416 3.35028 23.2523 4.13904 23.5585C4.90255 23.855 5.77481 24.0571 7.05207 24.1155C8.33209 24.1737 8.74084 24.188 11.9996 24.188C15.2589 24.188 15.6667 24.1737 16.9467 24.1155C18.2242 24.0571 19.0972 23.855 19.8607 23.5585C20.6497 23.2523 21.3182 22.8416 21.985 22.1747C22.6525 21.5082 23.0625 20.8393 23.37 20.0509C23.665 19.2883 23.8675 18.4168 23.9275 17.1409C23.985 15.8619 24 15.4543 24 12.198C24 8.94172 23.985 8.53306 23.9275 7.25413C23.8675 5.97769 23.665 5.10642 23.37 4.34405C23.0625 3.55546 22.6525 2.88652 21.985 2.22008C21.3175 1.55313 20.65 1.14348 19.86 0.837482C19.0949 0.54098 18.2224 0.338899 16.9449 0.280448C15.6649 0.222246 15.2574 0.208008 11.9974 0.208008H12.0011ZM10.9246 2.3687C11.2441 2.3682 11.6006 2.3687 12.0011 2.3687C15.2052 2.3687 15.5849 2.38019 16.8502 2.43765C18.0202 2.4911 18.6552 2.68644 19.0782 2.85055C19.6382 3.06787 20.0375 3.32765 20.4572 3.7473C20.8772 4.16695 21.1372 4.56662 21.3552 5.12615C21.5195 5.5483 21.7152 6.18277 21.7685 7.35179C21.826 8.61574 21.8385 8.99542 21.8385 12.1952C21.8385 15.3951 21.826 15.7748 21.7685 17.0387C21.715 18.2077 21.5195 18.8422 21.3552 19.2643C21.1377 19.8239 20.8772 20.2223 20.4572 20.6417C20.0372 21.0613 19.6385 21.3211 19.0782 21.5384C18.6557 21.7033 18.0202 21.8981 16.8502 21.9516C15.5852 22.0091 15.2052 22.0215 12.0011 22.0215C8.79684 22.0215 8.41709 22.0091 7.15207 21.9516C5.98206 21.8976 5.34706 21.7023 4.9238 21.5382C4.3638 21.3209 3.96379 21.0611 3.54379 20.6414C3.12378 20.2218 2.86378 19.8231 2.64578 19.2633C2.48153 18.8412 2.28577 18.2067 2.23252 17.0377C2.17502 15.7738 2.16352 15.3941 2.16352 12.1923C2.16352 8.99043 2.17502 8.61274 2.23252 7.3488C2.28602 6.17977 2.48153 5.5453 2.64578 5.12265C2.86328 4.56312 3.12378 4.16346 3.54379 3.74381C3.96379 3.32416 4.3638 3.06437 4.9238 2.84655C5.34681 2.68169 5.98206 2.48686 7.15207 2.43315C8.25909 2.38319 8.68809 2.3682 10.9246 2.36571V2.3687ZM18.4067 4.35954C17.6117 4.35954 16.9667 5.00325 16.9667 5.79784C16.9667 6.59218 17.6117 7.23664 18.4067 7.23664C19.2017 7.23664 19.8467 6.59218 19.8467 5.79784C19.8467 5.0035 19.2017 4.35904 18.4067 4.35904V4.35954ZM12.0011 6.04064C8.59784 6.04064 5.83856 8.79759 5.83856 12.198C5.83856 15.5984 8.59784 18.3541 12.0011 18.3541C15.4044 18.3541 18.1627 15.5984 18.1627 12.198C18.1627 8.79759 15.4042 6.04064 12.0009 6.04064H12.0011ZM12.0011 8.20133C14.2101 8.20133 16.0012 9.99059 16.0012 12.198C16.0012 14.4052 14.2101 16.1947 12.0011 16.1947C9.79185 16.1947 8.00108 14.4052 8.00108 12.198C8.00108 9.99059 9.79185 8.20133 12.0011 8.20133Z"
        />
      </svg>
    </div>
    <!-- Linkedin -->
    <div>
      <span>icon-linkedin</span>
      <svg
        id="icon-linkedin"
        viewBox="0 0 24 25"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleLinkedin contentLinkedin"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-linkedin', 'title')"
          id="titleLinkedin"
        >
          {{ $options.getString('icon-linkedin', 'title') }}
        </title>
        <desc id="contentLinkedin">
          {{ $options.getString('icon-linkedin', 'description') }}
        </desc>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.70353 0.208008C0.762695 0.208008 0 0.970067 0 1.91012V22.4859C0 23.4259 0.762696 24.188 1.70353 24.188H22.2965C23.2373 24.188 24 23.4259 24 22.4859V1.91012C24 0.970069 23.2373 0.208008 22.2965 0.208008H1.70353ZM5.3869 7.65502C6.53675 7.65502 7.46889 6.72366 7.46889 5.57476C7.46889 4.42586 6.53675 3.49449 5.3869 3.49449C4.23704 3.49449 3.3049 4.42586 3.3049 5.57476C3.3049 6.72366 4.23704 7.65502 5.3869 7.65502ZM9.37565 9.1924H12.8262V10.7718C12.8262 10.7718 13.7625 8.90064 16.3102 8.90064C18.5828 8.90064 20.4655 10.0193 20.4655 13.4289V20.6189H16.8897V14.3002C16.8897 12.2888 15.815 12.0676 14.9961 12.0676C13.2965 12.0676 13.0055 13.5323 13.0055 14.5625V20.6189H9.37565V9.1924ZM7.20183 9.19241H3.57197V20.6189H7.20183V9.19241Z"
        />
      </svg>
    </div>
    <!-- Twitter -->
    <div>
      <span>icon-twitter</span>
      <svg
        id="icon-twitter"
        viewBox="0 0 24 25"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleTwitter contentTwitter"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-twitter', 'title')"
          id="titleTwitter"
        >
          {{ $options.getString('icon-twitter', 'title') }}
        </title>
        <desc id="contentTwitter">
          {{ $options.getString('icon-twitter', 'description') }}
        </desc>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.5444 6.6777C21.5534 6.91938 21.5564 7.16096 21.5564 7.40263C21.5564 14.7298 16.6041 23.1887 7.54803 23.1887C4.76618 23.1887 2.17945 22.2659 0 20.695C0.385257 20.7389 0.776522 20.772 1.17379 20.772C3.48032 20.772 5.60474 19.882 7.28986 18.388C5.13543 18.355 3.31622 16.7402 2.6888 14.5431C2.99 14.609 3.30019 14.6421 3.6174 14.6421C4.0647 14.6421 4.49898 14.5762 4.91526 14.4444C2.66076 13.9391 0.962647 11.6981 0.962647 9.00672C0.962647 8.97376 0.962647 8.96271 0.962647 8.94074C1.62709 9.3472 2.38758 9.59973 3.19512 9.63269C1.87224 8.63302 1.00265 6.93034 1.00265 5.00791C1.00265 3.99726 1.24481 3.04149 1.6711 2.2176C4.09871 5.5791 7.72816 7.78719 11.8199 8.01788C11.7358 7.61142 11.6928 7.1831 11.6928 6.75467C11.6928 3.68977 13.8972 1.20703 16.6171 1.20703C18.033 1.20703 19.3119 1.87723 20.2094 2.95379C21.3332 2.71212 22.3859 2.25077 23.3385 1.61362C22.9693 2.90988 22.1898 3.99721 21.1711 4.6783C22.1678 4.54647 23.1184 4.25009 24 3.81068C23.3386 4.9202 22.506 5.89774 21.5444 6.6777Z"
        />
      </svg>
    </div>
    <!-- Whatsapp -->
    <div>
      <span>icon-whatsapp</span>
      <svg
        id="icon-whatsapp"
        viewBox="0 0 24 25"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleWhatsapp contentWhatsapp"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-whatsapp', 'title')"
          id="titleWhatsapp"
        >
          {{ $options.getString('icon-whatsapp', 'title') }}
        </title>
        <desc id="contentWhatsapp">
          {{ $options.getString('icon-whatsapp', 'description') }}
        </desc>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.647 0.2227C15.6189 0.36801 18.3882 1.58726 20.5033 3.69294C22.7594 5.93891 24.0012 8.9244 24 12.0993C23.9973 18.6511 18.6362 23.9819 12.0503 23.9819C9.57364 23.9819 7.60557 23.2249 6.33479 22.5356L0 24.188L1.69534 18.0304C0.649598 16.2284 0.0993357 14.1843 0.100198 12.0899C0.102842 5.5383 5.46352 0.208008 12.0501 0.208008L12.647 0.2227ZM6.62826 20.3844L6.991 20.5984C8.51594 21.4983 10.2639 21.9744 12.0462 21.9751H12.0502C17.5246 21.9751 21.9802 17.5445 21.9823 12.0986C21.9834 9.45968 20.9513 6.97826 19.076 5.11146C17.2008 3.24455 14.7071 2.21583 12.0542 2.21497C6.5756 2.21497 2.11999 6.64516 2.1178 12.0906C2.11706 13.9568 2.64214 15.7743 3.63637 17.3467L3.87252 17.7204L2.86915 21.365L6.62826 20.3844ZM18.0704 14.925C17.9958 14.8011 17.7968 14.7268 17.4982 14.5782C17.1996 14.4296 15.7317 13.7113 15.458 13.6121C15.1843 13.5132 14.9852 13.4637 14.7862 13.7608C14.5872 14.058 14.0149 14.7268 13.8407 14.925C13.6666 15.1231 13.4924 15.1479 13.1939 14.9993C12.8953 14.8507 11.9332 14.5371 10.7927 13.5256C9.90505 12.7383 9.30581 11.7661 9.13162 11.4688C8.9575 11.1716 9.11305 11.0109 9.26252 10.8629C9.39686 10.7298 9.56116 10.5161 9.71045 10.3427C9.85975 10.1694 9.90947 10.0454 10.009 9.84737C10.1085 9.64918 10.0588 9.47586 9.98415 9.32723C9.90947 9.17855 9.31236 7.7171 9.06356 7.1226C8.82114 6.5437 8.57498 6.62207 8.39171 6.61292C8.21776 6.60435 8.01851 6.60246 7.81949 6.60246C7.62042 6.60246 7.29694 6.67672 7.02324 6.97403C6.74955 7.27122 5.9782 7.9896 5.9782 9.45094C5.9782 10.9124 7.04814 12.3242 7.19743 12.5223C7.34672 12.7206 9.30287 15.7194 12.2981 17.0056C13.0105 17.3115 13.5667 17.4942 14.0003 17.631C14.7156 17.857 15.3664 17.8251 15.8809 17.7487C16.4546 17.6634 17.6475 17.0304 17.8963 16.3369C18.1451 15.6433 18.1451 15.0488 18.0704 14.925Z"
        />
      </svg>
    </div>
    <!-- Youtube -->
    <div>
      <span>icon-youtube</span>
      <svg
        id="icon-youtube"
        viewBox="0 0 24 25"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleYoutube contentYoutube"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-youtube', 'title')"
          id="titleYoutube"
        >
          {{ $options.getString('icon-youtube', 'title') }}
        </title>
        <desc id="contentYoutube">
          {{ $options.getString('icon-youtube', 'description') }}
        </desc>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3904 4.72133C22.4184 4.9993 23.2289 5.81339 23.5057 6.84588C24.0197 8.73217 23.9999 12.6636 23.9999 12.6636C23.9999 12.6636 23.9999 16.5751 23.5057 18.4614C23.2289 19.4939 22.4184 20.308 21.3904 20.586C19.5123 21.0824 11.9999 21.0824 11.9999 21.0824C11.9999 21.0824 4.50739 21.0824 2.60954 20.5661C1.58154 20.2882 0.771002 19.4741 0.494232 18.4416C0 16.5751 0 12.6437 0 12.6437C0 12.6437 0 8.73217 0.494232 6.84588C0.771002 5.81339 1.60131 4.97945 2.60954 4.70147C4.48763 4.20508 11.9999 4.20508 11.9999 4.20508C11.9999 4.20508 19.5123 4.20508 21.3904 4.72133ZM15.8555 12.5063L9.6084 16.12V8.89257L15.8555 12.5063Z"
        />
      </svg>
    </div>
    <!-- Content Icons -->
    <!-- Pasta Package -->
    <div>
      <span>icon-pasta-package</span>
      <svg
        id="icon-pasta-package"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePastaPackage contentPastaPackage"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-pasta-package', 'title')"
          id="titlePastaPackage"
        >
          {{ $options.getString('icon-pasta-package', 'title') }}
        </title>
        <desc id="contentPastaPackage">
          {{ $options.getString('icon-pasta-package', 'description') }}
        </desc>
        <path
          d="M14.9994 64.9951V7.00037L21.9993 8.61133L28.9992 7.00037L35.9991 8.61133L42.999 7.00037L49.9989 8.61133L56.9988 7.00037"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.9988 7.00111L56.9988 64.9958L49.9989 63.3849L42.999 64.9958L35.9991 63.3849L28.9992 64.9958L21.9993 63.3849L14.9994 64.9958"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <mask id="path-3-inside-1_587_26154" fill="white">
          <rect x="37" y="14" width="16" height="44" rx="1" />
        </mask>
        <rect
          x="37"
          y="14"
          width="16"
          height="44"
          rx="1"
          stroke-width="6"
          mask="url(#path-3-inside-1_587_26154)"
        />
        <path
          d="M31.5 22C31.5 22.3894 31.2381 22.9799 30.3101 23.5509C29.4063 24.1071 28.063 24.5 26.5 24.5C24.937 24.5 23.5937 24.1071 22.69 23.5509C21.7619 22.9799 21.5 22.3894 21.5 22C21.5 21.6106 21.7619 21.0201 22.69 20.4491C23.5937 19.8929 24.937 19.5 26.5 19.5C28.063 19.5 29.4063 19.8929 30.3101 20.4491C31.2381 21.0201 31.5 21.6106 31.5 22Z"
          stroke-width="3"
        />
      </svg>
    </div>
    <!-- Drop -->
    <div>
      <span>icon-drop</span>
      <svg
        id="icon-drop"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleDrop contentDrop"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-drop', 'title')" id="titleDrop">
          {{ $options.getString('icon-drop', 'title') }}
        </title>
        <desc id="contentDrop">
          {{ $options.getString('icon-drop', 'description') }}
        </desc>
        <path
          d="M57 43.5C57 56.754 47.598 64.5 36 64.5C24.402 64.5 15 56.754 15 43.5C15 30.246 36 7.5 36 7.5C36 7.5 57 30.246 57 43.5Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Tractor -->
    <div>
      <span>icon-tractor</span>
      <svg
        id="icon-tractor"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleTractor contentTractor"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-tractor', 'title')"
          id="titleTractor"
        >
          {{ $options.getString('icon-tractor', 'title') }}
        </title>
        <desc id="contentTractor">
          {{ $options.getString('icon-tractor', 'description') }}
        </desc>
        <path
          d="M22.5 57C26.6421 57 30 53.6421 30 49.5C30 45.3579 26.6421 42 22.5 42C18.3579 42 15 45.3579 15 49.5C15 53.6421 18.3579 57 22.5 57Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 6H36"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 6V35.442"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42 30L30 6"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M65.25 51.75L69 45V30H22.5"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M57 30V21C57 17.685 59.685 15 63 15"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.5 69C33.2696 69 42 60.2696 42 49.5C42 38.7304 33.2696 30 22.5 30C11.7304 30 3 38.7304 3 49.5C3 60.2696 11.7304 69 22.5 69Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60 69C64.9706 69 69 64.9706 69 60C69 55.0294 64.9706 51 60 51C55.0294 51 51 55.0294 51 60C51 64.9706 55.0294 69 60 69Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Chicken -->
    <div>
      <span>icon-chicken</span>
      <svg
        id="icon-chicken"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleChicken contentChicken"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-chicken', 'title')"
          id="titleChicken"
        >
          {{ $options.getString('icon-chicken', 'title') }}
        </title>
        <desc id="contentChicken">
          {{ $options.getString('icon-chicken', 'description') }}
        </desc>
        <path
          d="M56.9609 27H65.9999"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M55.2239 17.862C57.9299 17.283 59.9609 14.88 59.9609 12C59.9609 8.688 57.2759 6 53.9609 6C52.7159 6 51.5609 6.378 50.6009 7.029C49.7849 4.689 47.5799 3 44.9609 3C42.3419 3 40.1369 4.689 39.3209 7.029C38.3609 6.378 37.2059 6 35.9609 6C32.6459 6 29.9609 8.688 29.9609 12C29.9609 14.88 31.9919 17.283 34.7009 17.862"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M44.9609 23.97V24"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.9609 69V60"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M38.9609 69V60"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M33 36V24C33 17.373 38.298 12 44.925 12C51.552 12 57 17.373 57 24V36C56.22 49.38 45 60 31.425 60C17.85 60 6.78 49.38 6 36H33Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Writing -->
    <div>
      <span>icon-writing</span>
      <svg
        id="icon-writing"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleWriting contentWriting"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-writing', 'title')"
          id="titleWriting"
        >
          {{ $options.getString('icon-writing', 'title') }}
        </title>
        <desc id="contentWriting">
          {{ $options.getString('icon-writing', 'description') }}
        </desc>
        <path
          d="M48.906 11.931L60.069 23.094"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M55.524 5.313L25.386 35.451L21 51L36.549 46.614L66.687 16.476C69.771 13.392 69.771 8.397 66.687 5.313C63.606 2.229 58.608 2.229 55.524 5.313V5.313Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36 9H9C5.685 9 3 11.685 3 15V63C3 66.315 5.685 69 9 69H48C51.315 69 54 66.315 54 63V45"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Chart Bar -->
    <div>
      <span>icon-chart-bar</span>
      <svg
        id="icon-chart-bar"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleChartBar contentChartBar"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-chart-bar', 'title')"
          id="titleChartBar"
        >
          {{ $options.getString('icon-chart-bar', 'title') }}
        </title>
        <desc id="contentChartBar">
          {{ $options.getString('icon-chart-bar', 'description') }}
        </desc>
        <path
          d="M12 69C8.685 69 6 66.315 6 63V39C6 35.685 8.685 33 12 33C15.315 33 18 35.685 18 39V63C18 66.315 15.315 69 12 69Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60 69C56.685 69 54 66.315 54 63V30C54 26.685 56.685 24 60 24C63.315 24 66 26.685 66 30V63C66 66.315 63.315 69 60 69Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36 69C32.685 69 30 66.315 30 63V9C30 5.685 32.685 3 36 3C39.315 3 42 5.685 42 9V63C42 66.315 39.315 69 36 69Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Target -->
    <div>
      <span>icon-target</span>
      <svg
        id="icon-target"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleTarget contentTarget"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-target', 'title')"
          id="titleTarget"
        >
          {{ $options.getString('icon-target', 'title') }}
        </title>
        <desc id="contentTarget">
          {{ $options.getString('icon-target', 'description') }}
        </desc>
        <path
          d="M60 40.5C60 56.2401 47.2401 69 31.5 69C15.7599 69 3 56.2401 3 40.5C3 24.7599 15.7599 12 31.5 12"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M48 40.5C48 49.6127 40.6127 57 31.5 57C22.3873 57 15 49.6127 15 40.5C15 31.3873 22.3873 24 31.5 24"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M41.3863 31.6364H56.7272L68.9999 21.4091L53.659 18.3409L50.5908 3L40.3635 15.2727V30.6136"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M41.9999 30L31.7087 40.2911"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M40.5396 31.4604L62.8636 9.13635"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Earth -->
    <div>
      <span>icon-earth</span>
      <svg
        id="icon-earth"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleEarth contentEarth"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-earth', 'title')" id="titleEarth">
          {{ $options.getString('icon-earth', 'title') }}
        </title>
        <desc id="contentEarth">
          {{ $options.getString('icon-earth', 'description') }}
        </desc>
        <path
          d="M21.0001 65.37V36C21.0001 32.685 18.3151 30 15.0001 30H3.57007"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51 6.63V9V19.146C51 21.828 48.828 24 46.146 24C45.393 24 44.649 23.826 43.974 23.487L40.023 21.513C39.351 21.174 38.607 21 37.854 21C35.172 21 33 23.172 33 25.854V31.146C33 33.828 35.172 36 37.854 36H45.999C50.418 36 54 39.582 54 44.001C54 46.518 52.815 48.891 50.799 50.4C45.261 54.555 42 61.074 42 68.001V68.43"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36 69C54.2254 69 69 54.2254 69 36C69 17.7746 54.2254 3 36 3C17.7746 3 3 17.7746 3 36C3 54.2254 17.7746 69 36 69Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Hot Pot -->
    <div>
      <span>icon-hot-pot</span>
      <svg
        id="icon-hot-pot"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleHotPot contentHotPot"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-hot-pot', 'title')"
          id="titleHotPot"
        >
          {{ $options.getString('icon-hot-pot', 'title') }}
        </title>
        <desc id="contentHotPot">
          {{ $options.getString('icon-hot-pot', 'description') }}
        </desc>
        <path
          d="M67.352 39.0905L63.0773 41.1624V33.0709H65.9853C66.7158 33.0433 67.433 33.2709 68.0141 33.7145C68.5951 34.1581 69.0036 34.7901 69.1695 35.502C69.3355 36.2139 69.2485 36.9613 68.9235 37.6161C68.5985 38.2709 68.0557 38.7922 67.3884 39.0905H67.352ZM60.1184 49.6175C60.1184 51.0042 59.8444 52.3773 59.3122 53.6578C58.78 54.9383 58 56.1011 57.0171 57.0793C56.0342 58.0574 54.8677 58.8318 53.5846 59.3578C52.3015 59.8839 50.9272 60.1512 49.5404 60.1445H22.4741C21.0904 60.1464 19.72 59.8755 18.4411 59.3474C17.1622 58.8192 16 58.0441 15.021 57.0663C14.0419 56.0886 13.2652 54.9275 12.7353 53.6494C12.2053 52.3712 11.9325 51.0011 11.9325 49.6175V33.0709H60.0675L60.1184 49.6175ZM4.64796 39.0905C3.9806 38.7922 3.43785 38.2709 3.11285 37.6161C2.78785 36.9613 2.70086 36.2139 2.8668 35.502C3.03274 34.7901 3.44127 34.1581 4.02229 33.7145C4.60331 33.2709 5.3206 33.0433 6.05108 33.0709H8.92274V41.1624L4.64796 39.0905ZM65.9489 30.0829H6.05108C4.6825 30.1098 3.36167 30.5908 2.29637 31.4504C1.23106 32.31 0.481719 33.4993 0.166204 34.8313C-0.149311 36.1633 -0.0130943 37.5623 0.553427 38.8085C1.11995 40.0546 2.08463 41.077 3.29574 41.7149L8.92274 44.5212V49.6102C8.92179 51.3897 9.2717 53.152 9.95247 54.7961C10.6332 56.4403 11.6315 57.9341 12.8902 59.192C14.1488 60.45 15.6431 61.4475 17.2876 62.1273C18.9322 62.8072 20.6946 63.1562 22.4741 63.1543H49.5404C53.1306 63.1543 56.5738 61.7281 59.1124 59.1895C61.6511 56.6508 63.0773 53.2077 63.0773 49.6175V44.5285L68.7043 41.7149C69.9154 41.077 70.8801 40.0546 71.4466 38.8085C72.0131 37.5623 72.1493 36.1633 71.8338 34.8313C71.5183 33.4993 70.7689 32.31 69.7036 31.4504C68.6383 30.5908 67.3175 30.1098 65.9489 30.0829Z"
        />
        <path
          d="M35.0393 21.8752C31.9568 24.4488 32.8001 27.0515 34.5013 27.0515C34.8992 27.0496 35.2801 26.8902 35.5607 26.6082C35.8414 26.3262 35.9989 25.9445 35.9989 25.5466C35.9989 24.1653 39.0087 23.7291 39.0087 20.5375C39.0087 16.5245 33.9197 16.6844 36.9659 14.1617C40.012 11.639 39.1978 9 37.5111 9C37.1113 9 36.7278 9.15831 36.4444 9.44033C36.161 9.72235 36.0009 10.1051 35.9989 10.5049C35.9989 11.8862 32.9964 12.3224 32.9964 15.514C32.9964 18.7055 35.9989 19.149 35.9989 20.5375C35.9989 21.0392 35.759 21.2646 35.0393 21.8752Z"
        />
        <path
          d="M23.0026 21.8752C19.9128 24.4488 20.7562 27.0515 22.4573 27.0515C22.655 27.0515 22.8507 27.0126 23.0332 26.937C23.2158 26.8613 23.3817 26.7505 23.5215 26.6107C23.6612 26.471 23.7721 26.3051 23.8477 26.1225C23.9233 25.9399 23.9622 25.7442 23.9622 25.5466C23.9622 24.1653 26.972 23.7291 26.972 20.5375C26.972 16.5245 21.883 16.6844 24.9292 14.1617C27.9753 11.639 27.1829 9 25.4671 9C25.068 9 24.6852 9.15855 24.403 9.44077C24.1208 9.723 23.9622 10.1058 23.9622 10.5049C23.9622 11.8862 20.9525 12.3224 20.9525 15.514C20.9525 18.7055 23.9622 19.149 23.9622 20.5375C23.9622 21.0392 23.7223 21.2646 23.0026 21.8752Z"
        />
        <path
          d="M47.0686 21.8752C43.9861 24.4488 44.8294 27.0515 46.5306 27.0515C46.9297 27.0515 47.3125 26.893 47.5947 26.6107C47.877 26.3285 48.0355 25.9457 48.0355 25.5466C48.0355 24.1653 51.0453 23.7291 51.0453 20.5375C51.0453 16.5245 45.9563 16.6844 48.9952 14.1617C52.034 11.639 51.2561 9 49.5404 9C49.1413 9 48.7585 9.15855 48.4763 9.44077C48.1941 9.723 48.0355 10.1058 48.0355 10.5049C48.0355 11.908 45.0112 12.3224 45.0112 15.543C45.0112 18.7637 48.021 19.1781 48.021 20.5666C48.021 21.0683 47.7811 21.2936 47.0541 21.9043"
        />
      </svg>
    </div>
    <!-- Prohibit -->
    <div>
      <span>icon-prohibit</span>
      <svg
        id="icon-prohibit"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleProhibit contentProhibit"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-prohibit', 'title')"
          id="titleProhibit"
        >
          {{ $options.getString('icon-prohibit', 'title') }}
        </title>
        <desc id="contentProhibit">
          {{ $options.getString('icon-prohibit', 'description') }}
        </desc>
        <path
          d="M35.772 3.60004C29.3738 3.64506 23.1322 5.58347 17.8341 9.17088C12.536 12.7583 8.41873 17.8341 6.00136 23.7582C3.584 29.6824 2.9748 36.1896 4.25059 42.4595C5.52637 48.7294 8.63001 54.4812 13.1702 58.9896C17.7103 63.4981 23.4837 66.5613 29.7624 67.7931C36.0411 69.0249 42.5439 68.3701 48.451 65.9113C54.3581 63.4525 59.4048 59.2997 62.955 53.9766C66.5052 48.6535 68.3998 42.3984 68.4 36C68.3569 27.3808 64.8982 19.1302 58.7821 13.0568C52.666 6.98343 44.3914 3.5827 35.772 3.60004ZM13.701 56.2671C8.54918 50.7759 5.6805 43.5296 5.6775 36C5.72738 30.1907 7.45623 24.5197 10.6557 19.6705C13.8552 14.8213 18.3887 11.0009 23.71 8.66958C29.0313 6.33828 34.9133 5.59562 40.6471 6.53109C46.3808 7.46656 51.7217 10.0402 56.0261 13.942L13.701 56.2671ZM57.8431 15.7264C62.9952 21.2196 65.8618 28.4688 65.8601 36C65.809 41.8088 64.0792 47.479 60.8793 52.3272C57.6793 57.1754 53.1457 60.9948 47.8246 63.3253C42.5035 65.6558 36.6221 66.3979 30.8889 65.4622C25.1557 64.5265 19.8154 61.9529 15.5115 58.0516L57.8431 15.7264Z"
        />
      </svg>
    </div>
    <!-- Growler -->
    <div>
      <span>icon-growler</span>
      <svg
        id="icon-growler"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleGrowler contentGrowler"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-growler', 'title')"
          id="titleGrowler"
        >
          {{ $options.getString('icon-growler', 'title') }}
        </title>
        <desc id="contentGrowler">
          {{ $options.getString('icon-growler', 'description') }}
        </desc>
        <path
          d="M18 57H57"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 39H57"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M27 3H48"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 27C24.3137 27 27 24.3137 27 21C27 17.6863 24.3137 15 21 15C17.6863 15 15 17.6863 15 21C15 24.3137 17.6863 27 21 27Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M47.424 27.246L45 3H30L27.576 27.246C22.11 28.368 18 33.204 18 39V63C18 66.312 20.688 69 24 69H51C54.312 69 57 66.312 57 63V39C57 33.204 52.89 28.368 47.424 27.246Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Protein -->
    <div>
      <span>icon-protein</span>
      <svg
        id="icon-protein"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleProtein contentProtein"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-protein', 'title')"
          id="titleProtein"
        >
          {{ $options.getString('icon-protein', 'title') }}
        </title>
        <desc id="contentProtein">
          {{ $options.getString('icon-protein', 'description') }}
        </desc>
        <path
          d="M43.2608 18.7255C46.4479 19.888 54.7814 22.9249 55.0949 23.0555C55.2183 23.1284 55.3324 23.2162 55.4345 23.3168C55.7073 23.5909 55.8604 23.9619 55.8604 24.3487C55.8604 24.7354 55.7073 25.1064 55.4345 25.3806C55.2725 25.5588 55.0668 25.6917 54.8377 25.7662C54.6087 25.8406 54.3641 25.854 54.1283 25.8051C51.7967 25.152 45.2789 22.5788 44.1882 22.1477L42.9277 18.6276C43.0414 18.6534 43.1528 18.6884 43.2608 18.7321"
        />
        <path
          d="M40.2837 19.3918C40.5981 19.0739 40.9829 18.8345 41.407 18.693L44.2415 26.5824L46.3118 32.199C46.491 32.7085 46.5223 33.2584 46.4021 33.7849C46.2819 34.3115 46.015 34.7933 45.6324 35.1745C45.2498 35.5558 44.7671 35.8209 44.2401 35.9392C43.7131 36.0576 43.1633 36.0243 42.6545 35.8432L33.7593 32.5778L32.4531 29.038C32.592 29.0652 32.7277 29.1068 32.858 29.1621L41.9034 32.4994C42.0492 32.5562 42.2083 32.5693 42.3614 32.5369C42.5145 32.5046 42.6548 32.4282 42.765 32.3172C42.8753 32.2063 42.9508 32.0655 42.9822 31.9122C43.0136 31.759 42.9996 31.5999 42.9418 31.4545L39.6372 22.3503C39.4526 21.8462 39.416 21.2999 39.5317 20.7757C39.6474 20.2515 39.9106 19.7713 40.2902 19.3918"
        />
        <path
          d="M29.8398 29.8413C30.155 29.5151 30.5451 29.2707 30.9761 29.1294L32.4978 33.5312L35.8417 42.6746C36.0209 43.1841 36.0522 43.7339 35.932 44.2605C35.8118 44.7871 35.5449 45.2688 35.1623 45.6501C34.7797 46.0313 34.297 46.2965 33.77 46.4148C33.243 46.5332 32.6932 46.4999 32.1844 46.3188L23.2631 43.0534L21.8916 39.5266C22.0571 39.5549 22.2192 39.6009 22.3749 39.6638L31.5182 42.9946C31.664 43.0514 31.8232 43.0645 31.9762 43.0321C32.1293 42.9997 32.2696 42.9234 32.3799 42.8124C32.4901 42.7014 32.5656 42.5607 32.597 42.4074C32.6284 42.2541 32.6144 42.095 32.5566 41.9496L29.2258 32.9173C29.029 32.3991 28.9859 31.835 29.1017 31.2928C29.2176 30.7506 29.4875 30.2534 29.8789 29.8609"
        />
        <path
          d="M19.3885 40.2908C19.6632 40.0069 19.9948 39.7844 20.3616 39.6377L23.4507 47.4748C24.7178 50.8448 25.4884 53.0327 25.8019 54.1429C25.8495 54.3788 25.8355 54.6229 25.7611 54.8517C25.6868 55.0806 25.5546 55.2863 25.3774 55.4491C25.1032 55.7219 24.7322 55.875 24.3455 55.875C23.9587 55.875 23.5877 55.7219 23.3136 55.4491C23.2048 55.3428 23.1143 55.2192 23.0458 55.0834C22.9217 54.7895 19.8783 46.4625 18.7223 43.2754C18.5301 42.7703 18.4895 42.2201 18.6055 41.6922C18.7215 41.1643 18.9891 40.6818 19.3754 40.3039"
        />
        <path
          d="M36.0066 68.4C29.598 68.4013 23.3329 66.502 18.0037 62.9423C12.6746 59.3827 8.52075 54.3225 6.06766 48.4019C3.61458 42.4814 2.9724 35.9663 4.22235 29.6807C5.4723 23.3951 8.55824 17.6213 13.0899 13.0897C17.6215 8.55811 23.3952 5.47218 29.6808 4.22223C35.9664 2.97228 42.4815 3.61445 48.4021 6.06754C54.3227 8.52063 59.3828 12.6744 62.9424 18.0036C66.5021 23.3327 68.4014 29.5978 68.4001 36.0065C68.3897 44.5946 64.9735 52.828 58.9008 58.9007C52.8281 64.9734 44.5947 68.3896 36.0066 68.4ZM36.0066 6.02297C30.0762 6.02168 24.2785 7.77908 19.3469 11.0729C14.4153 14.3668 10.5712 19.0491 8.3008 24.5278C6.03041 30.0064 5.4357 36.0353 6.59189 41.852C7.74807 47.6687 10.6032 53.0118 14.7962 57.2058C18.9892 61.3997 24.3318 64.256 30.1482 65.4135C35.9646 66.5709 41.9936 65.9775 47.4728 63.7083C52.952 61.4391 57.6351 57.5961 60.9301 52.6652C64.225 47.7343 65.9837 41.937 65.9837 36.0065C65.9681 28.0603 62.8051 20.4439 57.1868 14.8244C51.5686 9.20495 43.9529 6.04023 36.0066 6.02297Z"
        />
      </svg>
    </div>
    <!-- Fork -->
    <div>
      <span>icon-fork</span>
      <svg
        id="icon-fork"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleFork contentFork"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title v-if="$options.getString('icon-fork', 'title')" id="titleFork">
          {{ $options.getString('icon-fork', 'title') }}
        </title>
        <desc id="contentFork">
          {{ $options.getString('icon-fork', 'description') }}
        </desc>
        <path
          d="M67.9364 23.1628C66.6303 23.3401 65.3352 23.5915 64.0575 23.9158C62.0396 24.4396 59.7018 23.6932 59.0095 22.3116V20.7664C59.2549 20.3574 59.5825 20.0041 59.9715 19.7291C60.3606 19.454 60.8024 19.2632 61.269 19.1687C62.1792 18.9331 63.1342 18.9331 64.0444 19.1687C64.1097 19.1687 65.5072 19.5485 67.9626 19.9086L67.9364 23.1628ZM68.4001 16.7788C66.1798 16.4514 64.8868 16.124 64.8672 16.124C63.4259 15.7509 61.9137 15.7509 60.4723 16.124C59.9227 16.2708 59.3906 16.4772 58.8855 16.7395C58.5563 14.9359 57.6084 13.3044 56.2059 12.1278C54.8034 10.9511 53.0346 10.3033 51.2059 10.2966H35.2981C33.5949 8.82603 31.4065 8.04407 29.1596 8.10309C27.569 8.10228 25.996 8.43691 24.5427 9.08525C23.2016 8.42006 21.7223 8.08345 20.2262 8.10309C18.6314 8.1022 17.0541 8.43679 15.5962 9.08525C14.2575 8.42012 12.7802 8.08349 11.2862 8.10309C9.65891 8.09949 8.04946 8.44322 6.56485 9.11144L3.95273 10.2966H3.6001V13.4591H8.49128C9.30685 14.4742 9.98938 15.5898 10.5222 16.7788H3.6001V19.9414H11.8217C12.0633 20.5961 12.305 21.2509 12.5596 21.9515C12.7556 22.5146 12.958 23.0908 13.18 23.6605H3.6001V26.823H14.4404C14.9515 27.9795 15.5565 29.092 16.2493 30.1493H3.6001V33.3118H11.3385C11.3277 33.3988 11.3277 33.4867 11.3385 33.5737V62.7896C11.3246 63.0058 11.3551 63.2226 11.4281 63.4265C11.501 63.6305 11.6149 63.8172 11.7627 63.9753C11.9106 64.1333 12.0891 64.2593 12.2874 64.3454C12.4857 64.4315 12.6995 64.476 12.9155 64.476C13.1316 64.476 13.3454 64.4315 13.5437 64.3454C13.742 64.2593 13.9205 64.1333 14.0683 63.9753C14.2162 63.8172 14.3301 63.6305 14.403 63.4265C14.476 63.2226 14.5065 63.0058 14.4926 62.7896V33.5737C14.4998 33.4866 14.4998 33.399 14.4926 33.3118H19.4034C20.1187 33.7788 20.8973 34.1404 21.7151 34.3856V53.9371C21.7409 54.3389 21.9183 54.7158 22.2112 54.9912C22.5041 55.2666 22.8906 55.4198 23.2922 55.4198C23.6937 55.4198 24.0802 55.2666 24.3731 54.9912C24.6661 54.7158 24.8434 54.3389 24.8692 53.9371V34.7719C26.3655 34.7433 27.8413 34.4184 29.2119 33.816C30.0908 34.2549 31.0346 34.5489 32.0068 34.6868V46.9572C32.0326 47.359 32.21 47.7359 32.5029 48.0113C32.7958 48.2867 33.1823 48.44 33.5839 48.44C33.9854 48.44 34.3719 48.2867 34.6649 48.0113C34.9578 47.7359 35.1352 47.359 35.161 46.9572V34.6475C36.1724 34.4996 37.1603 34.2201 38.0996 33.816C39.4412 34.4795 40.9202 34.816 42.4161 34.7981C44.0429 34.7968 45.6505 34.4463 47.131 33.7701L48.1693 33.3118H51.2059C53.1215 33.3039 54.9678 32.5928 56.3961 31.3127C57.8243 30.0327 58.7354 28.2725 58.9573 26.3647C60.1062 26.9425 61.3747 27.2409 62.66 27.2355C63.4003 27.2355 64.1377 27.1409 64.8542 26.954C66.0189 26.671 67.1983 26.4524 68.387 26.2992L68.4001 16.7788ZM55.8424 25.4873C55.8406 26.7232 55.3502 27.908 54.4786 28.7819C53.607 29.6558 52.4254 30.1475 51.1928 30.1493H45.9294C44.935 29.1933 44.1189 28.0668 43.5197 26.823H44.3229V23.6605H42.1288C41.7957 22.7765 41.4757 21.8729 41.1296 20.9432C41.0186 20.6027 40.8945 20.2884 40.777 19.9414H44.3099V16.7788H39.5689C39.0911 15.6361 38.5369 14.527 37.9102 13.4591H51.2059C52.4351 13.4643 53.6124 13.9567 54.481 14.8288C55.3495 15.7009 55.8389 16.882 55.8424 18.1145V25.4873ZM42.4161 31.7927C37.4857 31.7927 35.6703 27.6873 33.2737 20.9432C31.9676 17.3354 30.6616 13.649 28.3368 11.1216C28.6187 11.09 28.9021 11.0747 29.1857 11.0758C34.1161 11.0758 35.9446 15.1812 38.3281 21.9319C39.6342 25.5331 40.9403 29.2326 43.2716 31.7534C42.9875 31.7854 42.7019 31.8007 42.4161 31.7993V31.7927ZM33.4827 31.7993C28.5523 31.7993 26.7238 27.6939 24.3403 20.9497C23.0342 17.3419 21.7282 13.6556 19.3969 11.1281C19.6809 11.096 19.9665 11.0807 20.2523 11.0823C25.1827 11.0823 26.9981 15.1877 29.3947 21.9384C30.7008 25.5397 32.0068 29.2391 34.3316 31.76C34.0497 31.7916 33.7663 31.8069 33.4827 31.8058V31.7993ZM24.5362 31.8058C19.6058 31.8058 17.7839 27.7004 15.3938 20.9563C14.0877 17.3485 12.7817 13.6621 10.4504 11.1347C10.7366 11.1027 11.0244 11.0874 11.3124 11.0888C16.2362 11.0888 18.0647 15.1943 20.4548 21.945C21.7608 25.5462 23.0669 29.2457 25.4112 31.7665C25.125 31.7983 24.8372 31.8136 24.5492 31.8124"
        />
      </svg>
    </div>
    <!-- Practical Usage -->
    <div>
      <span>icon-practical-usage</span>
      <svg
        id="icon-practical-usage"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePracticalUsage contentPracticalUsage"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-practical-usage', 'title')"
          id="titlePracticalUsage"
        >
          {{ $options.getString('icon-practical-usage', 'title') }}
        </title>
        <desc id="contentPracticalUsage">
          {{ $options.getString('icon-practical-usage', 'description') }}
        </desc>
        <path
          d="M24.2,25.8c-0.4,0-0.8-0.1-1.1-0.4L10.4,12.6c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l12.7,12.7
			c0.6,0.6,0.6,1.5,0,2.1C25,25.6,24.6,25.8,24.2,25.8z"
        />
        <path
          d="M63,70.6c-1.9,0-3.8-0.7-5.3-2.2L28.3,39c-2.9,1.9-6.9,1.6-9.4-1l-17-17c-0.6-0.6-0.6-1.5,0-2.1
			c0.6-0.6,1.5-0.6,2.1,0l17,17c1.8,1.8,4.6,1.8,6.4,0c0.6-0.6,1.5-0.6,2.1,0l30.3,30.3c0.8,0.8,2,1.3,3.2,1.3s2.3-0.5,3.2-1.3
			c1.8-1.8,1.8-4.6,0-6.4L35.9,29.6c-0.3-0.3-0.4-0.7-0.4-1.1c0-0.4,0.2-0.8,0.4-1.1c0.9-0.9,1.3-2,1.3-3.2c0-1.2-0.5-2.3-1.3-3.2
			l-17-17c-0.6-0.6-0.6-1.5,0-2.1c0.6-0.6,1.5-0.6,2.1,0l17,17c1.4,1.4,2.2,3.3,2.2,5.3c0,1.5-0.4,2.9-1.2,4.1l29.3,29.4
			c2.9,2.9,2.9,7.7,0,10.6C66.8,69.8,64.9,70.6,63,70.6z"
        />
        <path
          d="M57.2,33.3c-0.4,0-0.8-0.1-1.1-0.4c-0.6-0.6-0.6-1.5,0-2.1l3.4-3.4c3.1-3.1,4.8-7.3,4.8-11.7
			c0-3.9-1.3-7.6-3.8-10.6L49.3,16.3c-0.6,0.6-1.5,0.6-2.1,0c-0.6-0.6-0.6-1.5,0-2.1L59.6,1.9c0.6-0.6,1.5-0.6,2.1,0
			c3.7,3.7,5.7,8.6,5.7,13.8c0,5.2-2,10.1-5.7,13.8l-3.4,3.4C58,33.2,57.6,33.3,57.2,33.3z"
        />
        <path
          d="M9,70.5c-1.9,0-3.8-0.7-5.3-2.2c-2.9-2.9-2.9-7.7,0-10.6l10.5-10.5c0.6-0.6,1.5-0.6,2.1,0s0.6,1.5,0,2.1
			L5.8,59.9c-1.8,1.8-1.8,4.6,0,6.4c1.8,1.8,4.6,1.8,6.4,0L26.5,52c0.6-0.6,1.5-0.6,2.1,0s0.6,1.5,0,2.1L14.3,68.4
			C12.8,69.8,10.9,70.5,9,70.5z"
        />
      </svg>
    </div>
    <!-- Pot -->
    <div>
      <span>icon-pot</span>
      <svg
        id="icon-pot"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePot contentPot"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-pot', 'title')" id="titlePot">
          {{ $options.getString('icon-pot', 'title') }}
        </title>
        <desc id="contentPot">
          {{ $options.getString('icon-pot', 'description') }}
        </desc>
        <path
          d="M4 10V42C4 44.21 5.99 46 8.444 46H39.556C42.01 46 44 44.21 44 42V10"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2 10H46"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24 10C26.2091 10 28 8.20914 28 6C28 3.79086 26.2091 2 24 2C21.7909 2 20 3.79086 20 6C20 8.20914 21.7909 10 24 10Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Chef Hat -->
    <div>
      <span>icon-chef-hat</span>
      <svg
        id="icon-chef-hat"
        viewBox="0 0 75 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleChefHat contentChefHat"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-chef-hat', 'title')"
          id="titleChefHat"
        >
          {{ $options.getString('icon-chef-hat', 'title') }}
        </title>
        <desc id="contentChefHat">
          {{ $options.getString('icon-chef-hat', 'description') }}
        </desc>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M60.3789 39.4396C58.9233 39.8168 57.6199 40.6347 56.6471 41.7813C55.6743 42.9279 55.0797 44.3472 54.9447 45.8448L53.6651 58.881C48.6589 61.6215 43.0434 63.058 37.336 63.058C31.6287 63.058 26.0132 61.6215 21.007 58.881L19.7651 45.8448C19.6202 44.3509 19.0176 42.9383 18.0395 41.7999C17.0614 40.6615 15.7557 39.853 14.3007 39.4848C10.8038 38.6131 7.7218 36.5459 5.58842 33.6413C3.45504 30.7366 2.40461 27.1773 2.61902 23.5798C2.83342 19.9823 4.29916 16.573 6.76244 13.9422C9.22571 11.3115 12.5314 9.62509 16.1071 9.17491C16.756 9.0886 17.4095 9.04085 18.064 9.03191C19.7759 9.03091 21.4756 9.31844 23.0918 9.88242L24.0251 10.1985L24.5821 9.38566C26.8801 6.00781 30.4229 3.67806 34.4348 2.90643C38.4467 2.1348 42.6009 2.98416 45.9879 5.26858C47.6192 6.37431 49.0264 7.77894 50.1351 9.40824L50.6846 10.2286L51.6179 9.905C53.8484 9.1158 56.2324 8.85807 58.58 9.15233C62.1554 9.60365 65.4604 11.291 67.9227 13.9223C70.3851 16.5535 71.8498 19.963 72.0633 23.5604C72.2768 27.1578 71.2257 30.7166 69.0918 33.6206C66.958 36.5247 63.8758 38.5911 60.3789 39.4622V39.4396ZM53.2135 63.6002C53.0931 64.8044 50.6695 66.3474 49.0663 67.0248C45.3516 68.5821 41.364 69.3842 37.336 69.3842C33.3081 69.3842 29.3205 68.5821 25.6057 67.0248C24.0026 66.3624 21.579 64.8722 21.4586 63.6077L21.293 61.9368C26.2876 64.3773 31.7733 65.6458 37.3323 65.6458C42.8913 65.6458 48.377 64.3773 53.3716 61.9368L53.2135 63.6002ZM58.9187 6.57822C56.5024 6.26831 54.0482 6.45788 51.7082 7.13519C50.027 4.91777 47.8554 3.11966 45.3632 1.88169C42.8711 0.643724 40.1262 -0.000488281 37.3436 -0.000488281C34.5609 -0.000488281 31.816 0.643724 29.3239 1.88169C26.8318 3.11966 24.6601 4.91777 22.9789 7.13519C20.686 6.50036 18.29 6.32593 15.9292 6.62195C13.5685 6.91798 11.2898 7.6786 9.22454 8.85992C7.1593 10.0412 5.34847 11.6199 3.89654 13.5047C2.44461 15.3896 1.38033 17.5433 0.765131 19.8416C0.149929 22.1399 -0.00401787 24.5373 0.312175 26.8954C0.628368 29.2535 1.40844 31.5257 2.60737 33.5807C3.80631 35.6358 5.40036 37.4331 7.29754 38.8688C9.19472 40.3046 11.3575 41.3504 13.6609 41.946C14.6029 42.1763 15.4498 42.6944 16.0837 43.4282C16.7177 44.162 17.1073 45.075 17.1985 46.0405L18.2748 57.3305L18.892 63.7959C19.1629 66.5581 22.6553 68.4549 24.123 69.1925L24.6122 69.4032C28.6393 71.091 32.9621 71.9602 37.3285 71.9602C41.695 71.9602 46.0177 71.091 50.0448 69.4032C50.948 69.0269 55.4339 67.0022 55.7801 63.8561L56.3973 57.3831L57.4736 46.0555C57.5647 45.0901 57.9544 44.177 58.5883 43.4432C59.2223 42.7094 60.0691 42.1913 61.0111 41.961C65.0919 40.9445 68.6888 38.5332 71.1793 35.1445C73.6697 31.7558 74.897 27.603 74.6487 23.4049C74.4004 19.2067 72.6921 15.2276 69.8195 12.1561C66.9469 9.0846 63.0908 7.11413 58.9187 6.58574V6.57822ZM24.3037 43.7673C23.9717 43.8212 23.6738 44.0022 23.4729 44.2719C23.272 44.5416 23.184 44.879 23.2274 45.2125L24.4768 55.5466C24.5268 55.8476 24.6822 56.1212 24.9152 56.3183C25.1481 56.5155 25.4436 56.6234 25.7488 56.6229H25.9069C26.2385 56.5744 26.5376 56.3969 26.7391 56.1292C26.9407 55.8614 27.0284 55.5249 26.9832 55.1928L25.7037 44.8963C25.648 44.5652 25.4666 44.2684 25.1974 44.0678C24.9281 43.8673 24.5917 43.7785 24.2586 43.82L24.3037 43.7673ZM32.9866 46.4292C33.1427 46.3654 33.3099 46.333 33.4786 46.334H33.4861C33.6548 46.335 33.8216 46.3693 33.9769 46.435C34.1323 46.5007 34.2731 46.5964 34.3913 46.7167C34.5096 46.8371 34.6028 46.9796 34.6658 47.136C34.7287 47.2925 34.7601 47.4599 34.7581 47.6286V57.9552C34.7716 58.132 34.7485 58.3096 34.6902 58.4771C34.6318 58.6445 34.5395 58.7981 34.419 58.9282C34.2985 59.0582 34.1525 59.162 33.99 59.233C33.8275 59.3039 33.6521 59.3406 33.4748 59.3406C33.2975 59.3406 33.1221 59.3039 32.9596 59.233C32.7971 59.162 32.6511 59.0582 32.5306 58.9282C32.4101 58.7981 32.3178 58.6445 32.2594 58.4771C32.2011 58.3096 32.178 58.132 32.1915 57.9552V47.6135C32.1915 47.4449 32.2248 47.2779 32.2896 47.1221C32.3544 46.9664 32.4493 46.825 32.5689 46.7061C32.6885 46.5872 32.8305 46.4931 32.9866 46.4292ZM50.3685 43.7674C50.035 43.724 49.6977 43.812 49.428 44.0129C49.1583 44.2138 48.9773 44.5118 48.9234 44.8438L47.6213 55.1854C47.5781 55.5172 47.6666 55.8526 47.8678 56.1199C48.069 56.3872 48.3669 56.5651 48.6976 56.6155H48.8557C49.1609 56.616 49.4564 56.5081 49.6893 56.3109C49.9223 56.1138 50.0777 55.8402 50.1277 55.5391L51.4147 45.2427C51.4601 44.9089 51.3729 44.5705 51.1716 44.3003C50.9704 44.0302 50.6713 43.8496 50.3384 43.7976L50.3685 43.7674ZM40.2434 46.7087C40.4834 46.4688 40.8088 46.334 41.1482 46.334C41.4915 46.334 41.8208 46.4704 42.0636 46.7132C42.3064 46.9559 42.4428 47.2852 42.4428 47.6286V57.9551C42.4084 58.2725 42.258 58.566 42.0204 58.7792C41.7829 58.9924 41.4749 59.1103 41.1557 59.1103C40.8365 59.1103 40.5285 58.9924 40.291 58.7792C40.0534 58.566 39.903 58.2725 39.8687 57.9551V47.6135C39.8687 47.2742 40.0035 46.9487 40.2434 46.7087ZM20.6682 12.8704C10.3591 12.7769 8.06504 20.7533 7.83876 21.5401C7.82846 21.5759 7.82245 21.5968 7.82015 21.6014C7.75891 21.9299 7.82633 22.2694 8.00846 22.5496C8.1906 22.8298 8.4735 23.0293 8.79862 23.1067C8.89381 23.1142 8.98944 23.1142 9.08463 23.1067C9.36722 23.0935 9.63759 22.9875 9.85391 22.8052C10.0702 22.6229 10.2205 22.3744 10.2814 22.0981C10.2814 22.0379 11.8394 15.2413 20.5929 15.3994C20.931 15.3849 21.2517 15.2451 21.4924 15.0072C21.7331 14.7693 21.8766 14.4503 21.895 14.1123C21.8897 13.7843 21.7601 13.4706 21.5324 13.2344C21.3046 12.9983 20.9958 12.8575 20.6682 12.8403V12.8704ZM29.7762 8.36427C29.8604 8.21759 29.9727 8.08893 30.1066 7.98564L30.1367 7.92543C32.2327 6.41351 34.7516 5.59985 37.336 5.59985C39.9204 5.59985 42.4392 6.41351 44.5352 7.92543C44.7655 8.08026 44.9392 8.30577 45.0302 8.56795C45.1211 8.83013 45.1244 9.11477 45.0394 9.37895C44.9545 9.64313 44.7859 9.87254 44.5592 10.0326C44.3325 10.1926 44.0599 10.2746 43.7826 10.2662C43.5118 10.2723 43.2468 10.1875 43.0299 10.0254C41.3727 8.84549 39.3891 8.21145 37.3548 8.21145C35.3205 8.21145 33.3368 8.84549 31.6797 10.0254C31.5458 10.1287 31.3928 10.2046 31.2295 10.2487C31.0663 10.2929 30.8959 10.3045 30.7282 10.2828C30.5604 10.2612 30.3986 10.2067 30.2519 10.1225C30.1052 10.0382 29.9766 9.92597 29.8733 9.79204C29.77 9.65811 29.6941 9.50515 29.6499 9.34188C29.6058 9.17862 29.5942 9.00826 29.6158 8.84052C29.6375 8.67278 29.692 8.51095 29.7762 8.36427Z"
        />
      </svg>
    </div>
    <!-- Salt Pepper -->
    <div>
      <span>icon-salt-pepper</span>
      <svg
        id="icon-salt-pepper"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleSaltPepper contentSaltPepper"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-salt-pepper', 'title')"
          id="titleSaltPepper"
        >
          {{ $options.getString('icon-salt-pepper', 'title') }}
        </title>
        <desc id="contentSaltPepper">
          {{ $options.getString('icon-salt-pepper', 'description') }}
        </desc>
        <path
          d="M26 22V18C26 14.686 28.686 12 32 12H36C39.314 12 42 14.686 42 18V22"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26.0001 22L22.0841 41.184C21.5701 43.668 23.4541 46 25.9741 46H42.0261C44.5461 46 46.4301 43.668 45.9161 41.184L42.0001 22H26.0001Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 8.222V8C22 4.686 19.314 2 16 2H12C8.686 2 6 4.686 6 8V12"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 12H6.00004L2.08404 31.184C1.57204 33.668 3.45404 36 5.97404 36H14.978"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Kitchen Scale -->
    <div>
      <span>icon-kitchen-scale</span>
      <svg
        id="icon-kitchen-scale"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleKitchenScale contentKitchenScale"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-kitchen-scale', 'title')"
          id="titleKitchenScale"
        >
          {{ $options.getString('icon-kitchen-scale', 'title') }}
        </title>
        <desc id="contentKitchenScale">
          {{ $options.getString('icon-kitchen-scale', 'description') }}
        </desc>
        <path
          d="M4 4H44"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24 14V4"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.00403 16.97L2.13803 38.97C1.46003 41.508 3.37403 44 6.00203 44H41.998C44.626 44 46.54 41.508 45.862 38.97L39.996 16.97C39.53 15.218 37.944 14 36.132 14H11.868C10.056 14 8.47003 15.218 8.00403 16.97V16.97Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M32 22L28.238 25.762"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24 36C27.3137 36 30 33.3137 30 30C30 26.6863 27.3137 24 24 24C20.6863 24 18 26.6863 18 30C18 33.3137 20.6863 36 24 36Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Measuring Tape -->
    <div>
      <span>icon-measuring-tape</span>
      <svg
        id="icon-measuring-tape"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleMeasuringTape contentMeasuringTape"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-measuring-tape', 'title')"
          id="titleMeasuringTape"
        >
          {{ $options.getString('icon-measuring-tape', 'title') }}
        </title>
        <desc id="contentMeasuringTape">
          {{ $options.getString('icon-measuring-tape', 'description') }}
        </desc>
        <path
          d="M30 42V30"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 42V30"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 42V34"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M38 42V34"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M33.088 10C30.892 7.67 24 6 18 6C10 6 2 8 2 12C2 16 10 18 18 18H46V42H10C5.582 42 2 38.418 2 34V12"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Cooking Time -->
    <div>
      <span>icon-cooking-time</span>
      <svg
        id="icon-cooking-time"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleCookingTime contentCookingTime"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-cooking-time', 'title')"
          id="titleCookingTime"
        >
          {{ $options.getString('icon-cooking-time', 'title') }}
        </title>
        <desc id="contentCookingTime">
          {{ $options.getString('icon-cooking-time', 'description') }}
        </desc>
        <path
          d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 26H24V14"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Double Cooking Time -->
    <div>
      <span>icon-double-cooking-time</span>
      <svg
        id="icon-double-cooking-time"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleDoubleCookingTime contentDoubleCookingTime"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-double-cooking-time', 'title')"
          id="titleDoubleCookingTime"
        >
          {{ $options.getString('icon-double-cooking-time', 'title') }}
        </title>
        <desc id="contentDoubleCookingTime">
          {{ $options.getString('icon-double-cooking-time', 'description') }}
        </desc>
        <path
          d="M24 38C31.732 38 38 31.732 38 24C38 16.268 31.732 10 24 10C16.268 10 10 16.268 10 24C10 31.732 16.268 38 24 38Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 26H24V18"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Information -->
    <div>
      <span>icon-information</span>
      <svg
        id="icon-information"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleInformation contentInformation"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-information', 'title')"
          id="titleInformation"
        >
          {{ $options.getString('icon-information', 'title') }}
        </title>
        <desc id="contentInformation">
          {{ $options.getString('icon-information', 'description') }}
        </desc>
        <path
          d="M24 46C36.1503 46 46 36.1503 46 24C46 11.8497 36.1503 2 24 2C11.8497 2 2 11.8497 2 24C2 36.1503 11.8497 46 24 46Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24 22V36"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24 14V13.98"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Recycle Leaf -->
    <div>
      <span>icon-recycle-leaf</span>
      <svg
        id="icon-recycle-leaf"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleRecycleLeaf contentRecycleLeaf"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-recycle-leaf', 'title')"
          id="titleRecycleLeaf"
        >
          {{ $options.getString('icon-recycle-leaf', 'title') }}
        </title>
        <desc id="contentRecycleLeaf">
          {{ $options.getString('icon-recycle-leaf', 'description') }}
        </desc>
        <path
          d="M58.293 10.449L55.2 26.091L40.104 20.949"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M25.707 5.01303C32.88 0.870034 42.054 3.33003 46.197 10.503L52.626 21.639"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 32.0644L18.093 26.9224L21.186 42.5644"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.5831 63C7.41011 58.857 4.95011 49.683 9.09311 42.51L15.5221 31.374"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M37.0403 62.6743L42.7099 63.7305C44.6283 64.0946 54.2724 65.7256 59.2451 62.8545C64.6103 59.757 66.5521 53.9036 64.1753 48.5557L62.8349 46.234C59.3905 41.5012 53.3504 40.2563 47.9853 43.3538C43.0125 46.2248 39.6033 55.391 38.959 57.2358L37.0403 62.6743Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M52.0331 55.1555C63.934 48.6814 68.1074 43.6005 68.1074 43.6005"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Leaf -->
    <div>
      <span>icon-leaf</span>
      <svg
        id="icon-leaf"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleLeaf contentLeaf"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-leaf', 'title')" id="titleLeaf">
          {{ $options.getString('icon-leaf', 'title') }}
        </title>
        <desc id="contentLeaf">
          {{ $options.getString('icon-leaf', 'description') }}
        </desc>
        <path
          d="M63 7.5L50.616 8.463C46.422 8.775 25.449 10.758 16.704 19.503C7.26903 28.938 6.49203 42.198 14.418 51.999L18.501 56.082C28.305 64.008 41.565 63.231 51 53.796C59.745 45.051 61.728 24.081 62.04 19.884L63 7.5Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36 31.5C14.85 51.603 9 64.5 9 64.5"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Question Mark -->
    <div>
      <span>icon-question-mark</span>
      <svg
        id="icon-question-mark"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleQuestionMark contentQuestionMark"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-question-mark', 'title')"
          id="titleQuestionMark"
        >
          {{ $options.getString('icon-question-mark', 'title') }}
        </title>
        <desc id="contentQuestionMark">
          {{ $options.getString('icon-question-mark', 'description') }}
        </desc>
        <path
          d="M36 69C54.2254 69 69 54.2254 69 36C69 17.7746 54.2254 3 36 3C17.7746 3 3 17.7746 3 36C3 54.2254 17.7746 69 36 69Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36 42L43.026 38.487C46.074 36.963 48 33.846 48 30.438V30C48 25.029 43.971 21 39 21H36C31.029 21 27 25.029 27 30"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36 54.03V54"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Chat Bubbles -->
    <div>
      <span>icon-chat-bubbles</span>
      <svg
        id="icon-chat-bubbles"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleChatBubbles contentChatBubbles"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-chat-bubbles', 'title')"
          id="titleChatBubbles"
        >
          {{ $options.getString('icon-chat-bubbles', 'title') }}
        </title>
        <desc id="contentChatBubbles">
          {{ $options.getString('icon-chat-bubbles', 'description') }}
        </desc>
        <path
          d="M25.26 54.537C28.281 57.885 32.637 60 37.5 60H43.332L60 69V58.185C65.34 55.452 69 49.911 69 43.5C69 38.697 66.933 34.392 63.657 31.377"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34.5 3H19.5C10.386 3 3 10.386 3 19.5C3 25.908 6.66 31.452 12 34.185V46.5L27 36H34.5C43.614 36 51 28.614 51 19.5C51 10.386 43.614 3 34.5 3Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Android Phone -->
    <div>
      <span>icon-android-phone</span>
      <svg
        id="icon-android-phone"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleAndroidPhone contentAndroidPhone"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-android-phone', 'title')"
          id="titleAndroidPhone"
        >
          {{ $options.getString('icon-android-phone', 'title') }}
        </title>
        <desc id="contentAndroidPhone">
          {{ $options.getString('icon-android-phone', 'description') }}
        </desc>
        <path
          d="M12 51H60"
          stroke-width="4"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30 60H42"
          stroke-width="4"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M51 69H21C16.029 69 12 64.971 12 60V12C12 7.029 16.029 3 21 3H51C55.971 3 60 7.029 60 12V60C60 64.971 55.971 69 51 69Z"
          stroke-width="4"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Assistance Alt -->
    <div>
      <span>icon-assistance-alt</span>
      <svg
        id="icon-assistance-alt"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleAssistanceAlt contentAssistanceAlt"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-assistance-alt', 'title')"
          id="titleAssistanceAlt"
        >
          {{ $options.getString('icon-assistance-alt', 'title') }}
        </title>
        <desc id="contentAssistanceAlt">
          {{ $options.getString('icon-assistance-alt', 'description') }}
        </desc>
        <path
          d="M35.4545 6.5H25.6364C14.7927 6.5 6 16.2691 6 28.3182V39.2273C6 54.29 16.9882 66.5 30.5455 66.5C44.1027 66.5 55.0909 54.29 55.0909 39.2273V28.3182C55.0909 16.2691 46.2982 6.5 35.4545 6.5Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M41.4545 47.4092C41.4545 47.4092 37.8191 52.8637 30.5454 52.8637C23.2718 52.8637 19.6364 47.4092 19.6364 47.4092"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M57 30.5H63C64.6569 30.5 66 31.8431 66 33.5V57.5M66 57.5V63.5C66 65.1569 64.6569 66.5 63 66.5H60C58.3431 66.5 57 65.1569 57 63.5V62V57.5H66Z"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Grain -->
    <div>
      <span>icon-grain</span>
      <svg
        id="icon-grain"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleGrain contentGrain"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title v-if="$options.getString('icon-grain', 'title')" id="titleGrain">
          {{ $options.getString('icon-grain', 'title') }}
        </title>
        <desc id="contentGrain">
          {{ $options.getString('icon-grain', 'description') }}
        </desc>
        <path
          d="M59.1986 19.3842C57.532 19.2668 55.9719 18.5219 54.8328 17.2997C53.6937 16.0775 53.0603 14.4689 53.0603 12.7982C53.0603 11.1275 53.6937 9.51886 54.8328 8.29667C55.9719 7.07448 57.532 6.32959 59.1986 6.21217H65.801V12.7818C65.7992 14.5324 65.1031 16.2107 63.8653 17.4485C62.6275 18.6863 60.9492 19.3824 59.1986 19.3842ZM64.1096 28.3636L59.4403 33.0329C58.5172 33.957 57.3408 34.5865 56.0599 34.8418C54.7789 35.0971 53.4511 34.9668 52.2442 34.4673C51.0374 33.9678 50.0058 33.1216 49.2801 32.0357C48.5543 30.9498 48.1669 29.673 48.1669 28.3669C48.1669 27.0607 48.5543 25.784 49.2801 24.6981C50.0058 23.6122 51.0374 22.7659 52.2442 22.2664C53.4511 21.7669 54.7789 21.6366 56.0599 21.8919C57.3408 22.1472 58.5172 22.7768 59.4403 23.7008L64.1096 28.3636ZM52.9555 39.5177L48.2862 44.187C47.3631 45.111 46.1867 45.7406 44.9058 45.9959C43.6249 46.2512 42.297 46.1209 41.0902 45.6214C39.8833 45.1219 38.8518 44.2756 38.126 43.1897C37.4002 42.1038 37.0128 40.8271 37.0128 39.5209C37.0128 38.2148 37.4002 36.9381 38.126 35.8522C38.8518 34.7663 39.8833 33.92 41.0902 33.4205C42.297 32.921 43.6249 32.7907 44.9058 33.046C46.1867 33.3013 47.3631 33.9308 48.2862 34.8549L52.9555 39.5177ZM41.7949 50.6848L37.1256 55.3541C36.2025 56.275 35.0272 56.9017 33.7482 57.155C32.4692 57.4083 31.1437 57.2768 29.9394 56.7771C28.7351 56.2774 27.7058 55.432 26.9818 54.3477C26.2577 53.2633 25.8712 51.9887 25.8712 50.6848C25.8712 49.3809 26.2577 48.1063 26.9818 47.022C27.7058 45.9376 28.7351 45.0922 29.9394 44.5926C31.1437 44.0929 32.4692 43.9614 33.7482 44.2147C35.0272 44.4679 36.2025 45.0946 37.1256 46.0155L41.7949 50.6848ZM16.6525 44.1935C15.4174 42.9547 14.7239 41.2768 14.7239 39.5275C14.7239 37.7782 15.4174 36.1003 16.6525 34.8614L21.3218 30.1921L25.9911 34.8614C27.2261 36.1003 27.9197 37.7782 27.9197 39.5275C27.9197 41.2768 27.2261 42.9547 25.9911 44.1935C24.7512 45.429 23.0721 46.1226 21.3218 46.1226C19.5714 46.1226 17.8924 45.429 16.6525 44.1935ZM27.787 23.7008L32.4563 19.0315L37.1256 23.7008C38.3606 24.9396 39.0541 26.6176 39.0541 28.3669C39.0541 30.1162 38.3606 31.7941 37.1256 33.0329C35.8792 34.231 34.2126 34.8923 32.4838 34.8749C30.7551 34.8575 29.1021 34.1628 27.8801 32.9399C26.658 31.717 25.9644 30.0635 25.9482 28.3348C25.932 26.606 26.5946 24.9399 27.7935 23.6943L27.787 23.7008ZM38.9476 12.5402L43.6169 7.87092L48.2862 12.5402C49.5212 13.779 50.2148 15.457 50.2148 17.2063C50.2148 18.9555 49.5212 20.6335 48.2862 21.8723C47.0398 23.0703 45.3732 23.7317 43.6444 23.7143C41.9157 23.6969 40.2627 23.0021 39.0407 21.7792C37.8186 20.5563 37.125 18.9029 37.1088 17.1742C37.0927 15.4454 37.7552 13.7793 38.9541 12.5337L38.9476 12.5402ZM41.6381 28.5269C41.6381 28.4681 41.6381 28.4158 41.6381 28.3571C41.6334 27.5925 41.5347 26.8315 41.3443 26.091C42.087 26.2814 42.8502 26.3801 43.6169 26.3849H43.7801L41.6381 28.5269ZM45.6087 28.1938C45.6087 28.2526 45.6087 28.3048 45.6087 28.3571C45.6097 29.124 45.7085 29.8877 45.9026 30.6297C45.1539 30.4518 44.3863 30.3663 43.6169 30.375H43.4275L45.6087 28.1938ZM30.471 39.6875C30.471 39.6352 30.471 39.583 30.471 39.5242C30.4687 38.7573 30.37 37.9938 30.1771 37.2516C30.9207 37.4502 31.6866 37.5533 32.4563 37.5585H32.6195L30.471 39.6875ZM34.4415 39.361C34.4415 39.4132 34.4415 39.472 34.4415 39.5242C34.4426 40.2912 34.5414 41.0548 34.7354 41.7968C33.9916 41.5974 33.2262 41.49 32.4563 41.4768H32.293L34.4415 39.361ZM68.4001 12.7818V4.90607C68.4001 4.55968 68.2625 4.22746 68.0176 3.98252C67.7726 3.73758 67.4404 3.59998 67.094 3.59998H59.1986C57.101 3.6055 55.0682 4.32706 53.4365 5.64525C51.8048 6.96343 50.672 8.79922 50.2257 10.8488L50.1082 10.7182L44.5312 5.13464C44.287 4.89533 43.9588 4.76128 43.6169 4.76128C43.275 4.76128 42.9468 4.89533 42.7026 5.13464L37.1256 10.7182C36.2691 11.5678 35.5901 12.5792 35.1282 13.6936C34.6663 14.808 34.4307 16.0032 34.435 17.2095C34.435 17.2618 34.435 17.314 34.435 17.3728L33.3705 16.2953C33.1264 16.0559 32.7981 15.9219 32.4563 15.9219C32.1144 15.9219 31.7861 16.0559 31.542 16.2953L25.965 21.8854C25.109 22.7339 24.4303 23.7442 23.9684 24.8575C23.5065 25.9708 23.2706 27.1648 23.2744 28.3701C23.2744 28.4289 23.2744 28.4811 23.2744 28.5399L22.2034 27.4624C21.9595 27.225 21.6327 27.0922 21.2924 27.0922C20.9521 27.0922 20.6252 27.225 20.3814 27.4624L14.7978 33.0394C13.5142 34.3235 12.6401 35.9594 12.2861 37.7401C11.932 39.5209 12.1138 41.3667 12.8086 43.0442C13.5033 44.7216 14.6798 46.1554 16.1893 47.1644C17.6988 48.1733 19.4735 48.7121 21.2891 48.7126H21.4524L3.97027 66.1882C3.73291 66.4321 3.6001 66.7589 3.6001 67.0992C3.6001 67.4395 3.73291 67.7664 3.97027 68.0102C4.09097 68.1331 4.23546 68.23 4.39491 68.2951C4.55435 68.3603 4.7254 68.3922 4.8976 68.389C5.24024 68.3875 5.56859 68.2515 5.81186 68.0102L23.2809 50.5216C23.2809 50.5738 23.2809 50.6326 23.2809 50.6848C23.2814 52.5005 23.8202 54.2752 24.8292 55.7847C25.8381 57.2942 27.2719 58.4707 28.9494 59.1654C30.6269 59.8601 32.4726 60.042 34.2534 59.6879C36.0342 59.3338 37.67 58.4597 38.9541 57.1761L44.5377 51.5991C44.7766 51.3548 44.9102 51.0265 44.9099 50.6848C44.9085 50.3454 44.775 50.0198 44.5377 49.7771L43.4275 48.6996H43.5908C44.7984 48.71 45.9961 48.481 47.1147 48.0259C48.2334 47.5709 49.2508 46.8987 50.1082 46.0482L55.6852 40.4711C55.9226 40.2273 56.0554 39.9004 56.0554 39.5601C56.0554 39.2198 55.9226 38.893 55.6852 38.6491L54.6142 37.5585H54.7775C55.983 37.5612 57.1772 37.3254 58.2912 36.8648C59.4052 36.4042 60.4172 35.7278 61.2688 34.8745L66.8458 29.2909C67.0832 29.0471 67.216 28.7202 67.216 28.3799C67.216 28.0396 67.0832 27.7128 66.8458 27.4689L61.2688 21.8854L61.1317 21.7613C63.1818 21.3161 65.0183 20.1837 66.3367 18.5517C67.6551 16.9198 68.3762 14.8863 68.3805 12.7884"
        />
      </svg>
    </div>
    <!-- Box -->
    <div>
      <span>icon-box</span>
      <svg
        id="icon-box"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleBox contentBox"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-box', 'title')" id="titleBox">
          {{ $options.getString('icon-box', 'title') }}
        </title>
        <desc id="contentBox">
          {{ $options.getString('icon-box', 'description') }}
        </desc>
        <path
          d="M4 18H44"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24 4V18"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 44V18L8 4H40L44 18V44H4Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Lightbulb -->
    <div>
      <span>icon-lightbulb</span>
      <svg
        id="icon-lightbulb"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleLightbulb contentLightbulb"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-lightbulb', 'title')"
          id="titleLightbulb"
        >
          {{ $options.getString('icon-lightbulb', 'title') }}
        </title>
        <desc id="contentLightbulb">
          {{ $options.getString('icon-lightbulb', 'description') }}
        </desc>
        <path
          d="M30 69H42"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M43.7251 57C46.4161 57 48.7051 55.188 49.4911 52.614C50.7301 48.564 52.7041 44.733 55.2751 41.28C58.2421 37.293 60.0001 32.355 60.0001 27C60.0001 12.168 46.5451 0.476967 31.1761 3.47097C21.7861 5.29797 14.2411 12.891 12.4501 22.287C11.1091 29.334 12.8551 35.958 16.5661 41.064C19.1551 44.625 21.1951 48.528 22.4761 52.656C23.2681 55.209 25.5541 57 28.2301 57H43.7251Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Footprint -->
    <div>
      <span>icon-footprint</span>
      <svg
        id="icon-footprint"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleFootprint contentFootprint"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-footprint', 'title')"
          id="titleFootprint"
        >
          {{ $options.getString('icon-footprint', 'title') }}
        </title>
        <desc id="contentFootprint">
          {{ $options.getString('icon-footprint', 'description') }}
        </desc>
        <path
          d="M36.483 56.775C38.922 55.017 41.304 53.193 43.554 51.231C44.661 50.265 45.753 49.284 46.827 48.288C47.586 47.583 48.276 46.779 48.885 45.867C51.891 41.352 51.6931 35.283 48.3181 30.684C42.5941 22.887 31.317 21.864 24.855 27.87C24.831 27.885 24.8131 27.903 24.7951 27.918C21.8041 30.699 19.959 34.371 19.539 38.34C19.47 38.976 19.413 39.624 19.365 40.263C19.068 44.226 16.023 47.457 11.871 48.315C8.41805 49.029 5.32205 51.012 3.91805 54.009C2.95505 56.073 2.70005 58.41 3.39305 60.711C3.99905 62.724 5.22605 64.635 7.06205 66.18C11.748 70.122 18.81 69.789 23.214 66.045L36.483 56.775Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42 15C45.3137 15 48 12.3137 48 9C48 5.68629 45.3137 3 42 3C38.6863 3 36 5.68629 36 9C36 12.3137 38.6863 15 42 15Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M64.5 33C66.9853 33 69 30.9853 69 28.5C69 26.0147 66.9853 24 64.5 24C62.0147 24 60 26.0147 60 28.5C60 30.9853 62.0147 33 64.5 33Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M58.5 21C60.9853 21 63 18.9853 63 16.5C63 14.0147 60.9853 12 58.5 12C56.0147 12 54 14.0147 54 16.5C54 18.9853 56.0147 21 58.5 21Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M64.5 48C66.9853 48 69 45.9853 69 43.5C69 41.0147 66.9853 39 64.5 39C62.0147 39 60 41.0147 60 43.5C60 45.9853 62.0147 48 64.5 48Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Special Check -->
    <div>
      <span>icon-special-check</span>
      <svg
        id="icon-special-check"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleSpecialCheck contentSpecialCheck"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-special-check', 'title')"
          id="titleSpecialCheck"
        >
          {{ $options.getString('icon-special-check', 'title') }}
        </title>
        <desc id="contentSpecialCheck">
          {{ $options.getString('icon-special-check', 'description') }}
        </desc>
        <path
          d="M67.395 25.797L59.559 18.885L55.401 9.3L45.003 8.301L36 3L27 8.301L16.599 9.3L12.441 18.885L4.60498 25.797L6.88198 36L4.60498 46.2L12.441 53.115L16.599 62.7L26.997 63.699L29.775 65.334H29.772L36 69L42.225 65.334L45 63.699L55.401 62.7L59.559 53.118L67.395 46.2L65.118 36L67.395 25.797Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M45 27L33 45L24 39"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Sustainability -->
    <div>
      <span>icon-sustainability</span>
      <svg
        id="icon-sustainability"
        viewBox="0 0 76 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleSustainability contentSustainability"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-sustainability', 'title')"
          id="titleSustainability"
        >
          {{ $options.getString('icon-sustainability', 'title') }}
        </title>
        <desc id="contentSustainability">
          {{ $options.getString('icon-sustainability', 'description') }}
        </desc>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M35.0275 16.343C35.0275 11.9 33.4368 7.60375 30.5433 4.23204C27.6454 7.60166 26.0518 11.8987 26.0518 16.343C26.0518 20.7873 27.6454 25.0843 30.5433 28.454C33.4368 25.0823 35.0275 20.786 35.0275 16.343ZM34.4846 28.9591C38.2583 28.316 41.7366 26.5099 44.4336 23.7933H44.4642C47.607 20.6539 49.5096 16.4847 49.8214 12.0535C45.5549 12.3608 41.5285 14.144 38.4336 17.0968C38.3026 21.3515 36.9299 25.4749 34.4846 28.9591ZM30.7499 32.6861H30.5433C30.0958 32.6854 29.6656 32.5128 29.3418 32.204C27.2026 30.1541 25.5024 27.6907 24.3447 24.9634C23.187 22.2362 22.5958 19.302 22.6071 16.3392C22.596 13.3768 23.1881 10.4433 24.3472 7.71711C25.5064 4.99095 27.2083 2.52928 29.3494 0.482041C29.6715 0.172881 30.1007 0.000244141 30.5471 0.000244141C30.9936 0.000244141 31.4228 0.172881 31.7448 0.482041C35.182 3.77849 37.4475 8.10798 38.1964 12.8111C42.0772 9.94245 46.8029 8.44799 51.6275 8.56367C52.0736 8.57154 52.4993 8.75225 52.8147 9.06775C53.1302 9.38325 53.311 9.80889 53.3188 10.255C53.3738 13.1817 52.8446 16.0899 51.7622 18.8096C50.6799 21.5293 49.0661 24.0059 47.0152 26.0945C44.9644 28.1832 42.5176 29.8419 39.8181 30.9737C37.1186 32.1055 34.2205 32.6876 31.2933 32.6861H30.8877H30.7499ZM46.9668 60.9183L71.6097 36.2755L71.5944 36.3061C72.1477 35.7484 72.4582 34.9947 72.4582 34.2091C72.4582 33.4236 72.1477 32.6698 71.5944 32.1122C71.0263 31.5762 70.2747 31.2776 69.4936 31.2776C68.7125 31.2776 67.961 31.5762 67.3929 32.1122L57.4439 42.0612C57.8374 42.9026 58.0462 43.8186 58.0561 44.7474C58.0592 45.5908 57.8954 46.4265 57.5743 47.2064C57.2531 47.9863 56.781 48.695 56.1849 49.2917C55.5889 49.8885 54.8808 50.3615 54.1013 50.6835C53.3218 51.0056 52.4863 51.1703 51.6429 51.1683H35.3878C34.9499 51.1391 34.5395 50.9446 34.2397 50.6242C33.9399 50.3038 33.7731 49.8814 33.7731 49.4426C33.7731 49.0037 33.9399 48.5813 34.2397 48.2609C34.5395 47.9405 34.9499 47.746 35.3878 47.7168H51.6505C52.0404 47.7178 52.4266 47.6416 52.7869 47.4927C53.1472 47.3437 53.4744 47.1249 53.7497 46.8489C54.0251 46.5728 54.243 46.245 54.3911 45.8843C54.5391 45.5237 54.6143 45.1373 54.6122 44.7474C54.6146 44.1083 54.4046 43.4864 54.0153 42.9795L53.9311 42.8877C53.6552 42.544 53.3057 42.2665 52.9084 42.0758C52.511 41.8851 52.076 41.7859 51.6352 41.7857H22.1939C20.4444 41.777 18.7608 42.4527 17.5026 43.6683L4.16327 57L15 67.829L20.5332 62.2959C20.6933 62.1343 20.8841 62.0064 21.0944 61.9197C21.3047 61.8329 21.5302 61.7891 21.7577 61.7908H44.8622C45.2533 61.7915 45.6406 61.7147 46.0018 61.565C46.363 61.4153 46.691 61.1955 46.9668 60.9183ZM71.9539 28.2782C72.7326 28.6011 73.4401 29.0743 74.0357 29.6709L74.051 29.6403C75.2521 30.8452 75.9265 32.4772 75.9265 34.1785C75.9265 35.8799 75.2521 37.5118 74.051 38.7168L49.4082 63.3596C48.8127 63.956 48.1052 64.4286 47.3263 64.7504C46.5474 65.0722 45.7126 65.2368 44.8699 65.2346H22.4694L16.2168 71.4948C15.8942 71.8179 15.4565 71.9995 15 72C14.5415 71.9982 14.1019 71.8169 13.7755 71.4948L0.505102 58.2168C0.183494 57.8932 0.00206465 57.4562 0 57C0.0295819 56.5526 0.22952 56.1335 0.558674 55.829L15.0995 41.2882C16.9984 39.4403 19.5442 38.4076 22.1939 38.4107H51.6352C51.9274 38.4108 52.2191 38.4338 52.5077 38.4795H52.6913C52.9498 38.5191 53.2054 38.5753 53.4566 38.6479H53.5332C54.1236 38.8204 54.6857 39.0782 55.2015 39.4132L64.9592 29.6709C65.5548 29.0743 66.2623 28.6011 67.041 28.2782C67.8197 27.9553 68.6544 27.7891 69.4974 27.7891C70.3405 27.7891 71.1752 27.9553 71.9539 28.2782Z"
        />
      </svg>
    </div>
    <!-- World -->
    <div>
      <span>icon-world</span>
      <svg
        id="icon-world"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleWorld contentWorld"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title v-if="$options.getString('icon-world', 'title')" id="titleWorld">
          {{ $options.getString('icon-world', 'title') }}
        </title>
        <desc id="contentWorld">
          {{ $options.getString('icon-world', 'description') }}
        </desc>
        <path
          d="M37.5995 50.9912H51.7021C49.4314 59.4281 45.3545 65.812 40.7624 68.322C40.6738 68.3658 40.5889 68.4167 40.5085 68.4744C39.5509 68.6049 38.5788 68.7065 37.6068 68.7573L37.5995 50.9912ZM6.82631 50.9912H16.8664C17.8946 55.1521 19.5455 59.1337 21.7631 62.8014C21.8632 62.9919 21.9997 63.1609 22.1651 63.2987C22.3304 63.4364 22.5212 63.5402 22.7267 63.6042C22.9322 63.6682 23.1482 63.6911 23.3625 63.6716C23.5768 63.6521 23.7852 63.5906 23.9757 63.4906C24.1663 63.3905 24.3352 63.254 24.473 63.0886C24.6107 62.9233 24.7146 62.7325 24.7786 62.527C24.8426 62.3216 24.8654 62.1055 24.8459 61.8912C24.8264 61.6769 24.7649 61.4685 24.6649 61.278C24.6301 61.2006 24.5862 61.1275 24.5343 61.0604C22.6459 57.924 21.2167 54.5331 20.2905 50.9912H34.3278V68.7573C28.5901 68.461 23.0305 66.6643 18.2046 63.5468C13.3786 60.4292 9.45523 56.0998 6.82631 50.9912ZM55.7718 24.3821H66.4793C69.527 32.4472 69.2853 41.3866 65.8064 49.2753C62.3274 57.1639 55.8895 63.3708 47.879 66.5592C51.1362 62.6853 53.6825 57.3098 55.206 50.9912H59.4861C59.7097 51.0088 59.9345 50.9803 60.1467 50.9076C60.3588 50.8348 60.5538 50.7192 60.7195 50.5681C60.8852 50.4169 61.0181 50.2333 61.1101 50.0288C61.202 49.8242 61.251 49.6029 61.254 49.3786C61.2569 49.1543 61.2139 48.9318 61.1274 48.7248C61.041 48.5179 60.913 48.3309 60.7513 48.1753C60.5897 48.0198 60.3979 47.8991 60.1877 47.8207C59.9776 47.7423 59.7536 47.7079 59.5296 47.7195H55.9024C56.5751 43.941 56.9077 40.1099 56.8962 36.272C56.902 32.2747 56.5255 28.286 55.7718 24.3603V24.3821ZM37.6358 24.3603H52.4493C53.2423 28.281 53.636 32.272 53.6245 36.272C53.6255 40.1083 53.2489 43.9353 52.5001 47.6977H37.5995L37.6358 24.3603ZM19.4998 24.3603H34.3278V47.7195H19.478C18.6853 43.7987 18.2916 39.8078 18.3028 35.8078C18.2942 31.9712 18.6709 28.1434 19.4272 24.3821L19.4998 24.3603ZM24.0265 5.62217C20.762 9.48877 18.223 14.8425 16.7141 21.1103H12.4195C12.0037 21.1319 11.6117 21.3109 11.323 21.6109C11.0344 21.9109 10.8707 22.3095 10.8651 22.7258C10.8596 23.1421 11.0126 23.5449 11.2932 23.8525C11.5738 24.1601 11.9609 24.3494 12.3759 24.3821H16.0031C15.3318 28.1534 14.9992 31.9772 15.0093 35.8078C15.0048 39.8047 15.3788 43.7931 16.1265 47.7195H5.36817C2.27211 39.665 2.49786 30.7113 5.99588 22.8231C9.49389 14.9349 15.9784 8.75655 24.0265 5.64394V5.62217ZM37.5995 3.46761C43.3234 3.73075 48.8763 5.50083 53.6965 8.59883C58.5168 11.6968 62.4334 16.0128 65.0502 21.1103H55.0536C54.0273 16.9512 52.3815 12.9699 50.1714 9.30016C50.0571 9.11868 49.9081 8.96149 49.7331 8.83757C49.558 8.71365 49.3602 8.62542 49.1511 8.57793C48.9419 8.53044 48.7254 8.52461 48.514 8.56078C48.3026 8.59695 48.1004 8.6744 47.9189 8.78872C47.7374 8.90304 47.5802 9.05199 47.4563 9.22705C47.3324 9.40212 47.2442 9.59988 47.1967 9.80905C47.1492 10.0182 47.1434 10.2347 47.1795 10.4461C47.2157 10.6575 47.2931 10.8597 47.4075 11.0412C49.2929 14.1791 50.7219 17.5695 51.6513 21.1103H37.5995V3.46761ZM34.2987 3.46761V21.1103H20.2179C22.4886 12.688 26.5728 6.28958 31.1939 3.77955L31.2954 3.72877C32.2965 3.59094 33.3049 3.47487 34.335 3.42409L34.2987 3.46761ZM35.989 6.57891e-06C28.8666 -0.00429814 21.903 2.10398 15.979 6.05814C10.0551 10.0123 5.43705 15.6346 2.70911 22.2139C-0.0188279 28.7932 -0.734078 36.0337 0.653848 43.0196C2.04177 50.0054 5.47051 56.4227 10.5063 61.4595C15.5421 66.4963 21.9586 69.9263 28.9442 71.3156C35.9298 72.705 43.1705 71.9912 49.7503 69.2645C56.3301 66.5379 61.9534 61.921 65.9087 55.9979C69.8641 50.0747 71.9738 43.1115 71.9709 35.9891C71.9632 26.4478 68.17 17.2994 61.424 10.552C54.678 3.80463 45.5303 0.00961204 35.989 6.57891e-06Z"
        />
      </svg>
    </div>
    <!-- Search -->
    <div>
      <span>icon-search</span>
      <svg
        id="icon-search"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleSearch contentSearch"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-search', 'title')"
          id="titleSearch"
        >
          {{ $options.getString('icon-search', 'title') }}
        </title>
        <desc id="contentSearch">
          {{ $options.getString('icon-search', 'description') }}
        </desc>
        <path
          d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22 22L16 16"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Check Mark -->
    <div>
      <span>icon-check-mark</span>
      <svg
        id="icon-check-mark"
        viewBox="0 0 71 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleCheckMark contentCheckMark"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-check-mark', 'title')"
          id="titleCheckMark"
        >
          {{ $options.getString('icon-check-mark', 'title') }}
        </title>
        <desc id="contentCheckMark">
          {{ $options.getString('icon-check-mark', 'description') }}
        </desc>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M66.9968 41.9309L67.4588 43.3523L66.4425 44.397C64.9489 45.7923 63.6679 47.3989 62.6403 49.1657C61.9796 50.4871 61.7612 51.9006 61.3626 54.4796L61.3626 54.4796C61.3324 54.6749 61.3012 54.8767 61.2687 55.0858L61.0697 56.5498L59.6981 57.0686C57.7448 57.669 55.8912 58.5551 54.1973 59.6981C52.7014 61.0886 51.42 62.6932 50.3951 64.4598L49.5778 65.6182L48.0925 65.5258C47.3818 65.4547 46.8275 65.4121 46.2802 65.3766H46.1949C44.807 65.2117 43.4019 65.2644 42.0303 65.5329C40.0745 66.1308 38.2218 67.0248 36.5367 68.1838L35.2503 68.9371L33.9782 68.2264C32.2871 67.0662 30.4268 66.1745 28.4632 65.5827C27.1107 65.2998 25.7219 65.2326 24.3483 65.3837C23.9112 65.3837 23.4476 65.4323 22.9192 65.4877C22.7774 65.5025 22.631 65.5179 22.4792 65.5329L21.0152 65.6253L20.1908 64.474C19.1884 62.6922 17.9044 61.0842 16.3886 59.7124C14.6975 58.5663 12.843 57.6822 10.8879 57.0899L9.55176 56.5711L9.31723 55.1C9.16807 53.0722 8.7128 51.0786 7.96692 49.187C6.90743 47.4043 5.58756 45.7898 4.05101 44.397L3.03473 43.3523L3.46114 41.9309C4.21333 40.0352 4.67572 38.0371 4.83277 36.0037C4.6831 33.9738 4.22042 31.9793 3.46114 30.0908L3.03473 28.6694L4.01548 27.5892L4.25279 27.3374C6.18554 25.2874 7.18306 24.2293 7.83899 22.856C8.61274 20.9447 9.09199 18.927 9.26037 16.872L9.4949 15.4506L10.7955 14.9247C12.748 14.329 14.6016 13.4476 16.2962 12.3093C17.8069 10.93 19.0901 9.32056 20.0984 7.5406L20.9228 6.32532L22.3868 6.39639C24.4061 6.69491 26.4582 6.69491 28.4774 6.39639C29.8999 6.07603 31.1028 5.39174 33.2475 4.17167C33.4817 4.03845 33.7271 3.89884 33.9853 3.75263L35.2503 3.04194L36.494 3.75263C38.1874 4.92633 40.0461 5.84131 42.009 6.46746C44.0372 6.77311 46.0998 6.77311 48.128 6.46746L49.5494 6.36797L50.3667 7.57614C51.3937 9.34547 52.6747 10.9545 54.1689 12.352C55.8733 13.4927 57.7363 14.3763 59.6981 14.9744L61.0697 15.5288L61.2687 16.8862C61.2989 17.0825 61.328 17.2723 61.3561 17.456L61.3564 17.4577C61.7581 20.0794 61.9696 21.4601 62.6403 22.8347C63.6762 24.5958 64.9563 26.2013 66.4425 27.6034L67.4588 28.6836L66.9968 30.105C66.2408 31.9945 65.7782 33.9886 65.6252 36.018C65.7837 38.0465 66.246 40.0397 66.9968 41.9309ZM47.6163 68.4325H47.9432L50.253 68.6031C50.5054 68.6134 50.7565 68.5618 50.9845 68.4528C51.2124 68.3437 51.4102 68.1806 51.5606 67.9777L52.8399 66.0517C53.7192 64.5487 54.7921 63.1677 56.0309 61.9439C57.5061 61.0011 59.1034 60.2647 60.7783 59.755L62.8677 58.9448C63.1213 58.8642 63.3462 58.7119 63.5152 58.5064C63.6841 58.3008 63.79 58.0508 63.8201 57.7864L64.1754 55.4766C64.3103 53.7407 64.6809 52.0312 65.277 50.3952C66.1747 48.8886 67.2881 47.5214 68.5817 46.3372L70.0883 44.731C70.2654 44.5451 70.3902 44.3158 70.4501 44.0662C70.51 43.8166 70.5029 43.5556 70.4295 43.3096C70.2486 42.7405 70.1096 42.3073 69.9925 41.9422C69.8888 41.6189 69.8022 41.3489 69.7188 41.0852C69.0983 39.4612 68.7106 37.7576 68.5675 36.0251C68.7114 34.2903 69.099 32.5845 69.7188 30.9578C69.8822 30.4035 70.0741 29.7994 70.4295 28.7405C70.4985 28.5009 70.5033 28.2475 70.4435 28.0055C70.3836 27.7635 70.2611 27.5415 70.0883 27.3617L68.5177 25.6632C67.2536 24.4735 66.1627 23.1123 65.277 21.6194C64.6548 19.9783 64.2649 18.2584 64.1185 16.5095C64.0308 15.9784 63.9431 15.3939 63.8646 14.8704C63.8286 14.6303 63.7945 14.4031 63.7632 14.1998C63.7331 13.9464 63.6355 13.7059 63.4804 13.5033C63.3254 13.3007 63.1186 13.1436 62.8819 13.0485L60.7499 12.2809C59.0874 11.7674 57.5041 11.026 56.0451 10.0778C54.7954 8.85573 53.715 7.47179 52.8328 5.96287L52.6575 5.69939L52.657 5.69871C52.3987 5.31013 52.0881 4.84281 51.582 4.10086C51.4488 3.86859 51.2527 3.67865 51.0164 3.55292C50.78 3.42719 50.5129 3.37077 50.2459 3.39017C49.2296 3.44703 48.5686 3.5181 47.9361 3.58917C46.2006 3.84255 44.4389 3.86167 42.6983 3.64602C41.0356 3.09649 39.4571 2.31918 38.0078 1.33628L36.0179 0.184963C35.7998 0.0661559 35.5555 0.00390625 35.3072 0.00390625C35.0589 0.00390625 34.8145 0.0661559 34.5965 0.184963L32.5781 1.34339C31.1482 2.31595 29.5946 3.09276 27.9586 3.65313C26.225 3.86559 24.4708 3.84647 22.7422 3.59627C22.1239 3.52521 21.4416 3.45414 20.4324 3.39728C20.1769 3.37512 19.92 3.41981 19.687 3.52697C19.454 3.63413 19.2529 3.80006 19.1034 4.00847C18.7214 4.54962 18.4486 4.95042 18.2263 5.27697L18.2263 5.277L18.2262 5.27711C18.0515 5.53375 17.9081 5.74453 17.7673 5.94155C16.8573 7.46053 15.7403 8.84545 14.4484 10.0564C13.0211 11.0067 11.4656 11.7485 9.82893 12.2596L7.69686 13.084C7.44978 13.1669 7.23026 13.3162 7.0623 13.5155C6.89434 13.7148 6.78441 13.9564 6.74453 14.214L6.39629 16.545C6.26797 18.2886 5.90706 20.0071 5.32315 21.6549C4.40132 23.1483 3.27992 24.5088 1.99001 25.6987C1.99001 25.6987 0.568634 27.1201 0.447816 27.2836C0.262141 27.4644 0.127547 27.6911 0.0576585 27.9407C-0.0122297 28.1903 -0.0149304 28.454 0.0498299 28.705C0.249483 29.2961 0.3866 29.7406 0.501567 30.1133L0.501584 30.1133C0.595323 30.4172 0.674337 30.6733 0.76052 30.9223C1.39776 32.5484 1.81368 34.2527 1.99712 35.9895C1.81536 37.7243 1.39938 39.4265 0.76052 41.0496C0.675844 41.3172 0.596011 41.5929 0.500249 41.9235C0.395077 42.2866 0.270692 42.7161 0.0995782 43.2741C0.0254198 43.5015 0.0133285 43.7446 0.064554 43.9782C0.115779 44.2119 0.228463 44.4276 0.390961 44.6031L1.96159 46.3016C3.26481 47.4962 4.39184 48.8696 5.30894 50.381C5.89905 52.0351 6.26476 53.7609 6.39629 55.5122C6.49769 56.1319 6.5857 56.814 6.66031 57.3924L6.6604 57.3931C6.67988 57.5441 6.69845 57.6881 6.7161 57.8219C6.75402 58.0753 6.85534 58.315 7.01064 58.5187C7.16595 58.7225 7.37021 58.8837 7.60447 58.9875L9.82893 59.7692C11.4627 60.2813 13.0174 61.018 14.4484 61.9581C15.7032 63.1836 16.784 64.5753 17.6607 66.0944L17.7327 66.1983C18.0329 66.6317 18.3672 67.1145 18.9329 67.9564C19.0644 68.1852 19.2571 68.3729 19.4893 68.4985C19.7215 68.624 19.9841 68.6824 20.2476 68.6671C20.7393 68.6327 21.1529 68.5983 21.518 68.5679L21.5182 68.5679L21.5184 68.5679C21.9077 68.5355 22.242 68.5077 22.5574 68.4894H22.7919L25.7626 68.2264C26.4753 68.1766 27.1913 68.2148 27.8947 68.3401C29.5306 68.9005 31.0843 69.6773 32.5142 70.6499L34.4757 71.8083C34.7027 71.9308 34.9567 71.995 35.2148 71.995C35.4728 71.995 35.7268 71.9308 35.9539 71.8083L37.9438 70.6499C39.3957 69.6689 40.9767 68.894 42.6415 68.3472C43.3188 68.2248 44.0084 68.1842 44.6954 68.2264L47.6163 68.4325ZM50.5087 51.2905C46.974 54.8128 42.3277 57.001 37.3609 57.4826C32.3941 57.9642 27.414 56.7093 23.2684 53.9317C19.1229 51.154 16.0682 47.0253 14.6247 42.2486C13.1811 37.4719 13.4378 32.3425 15.3512 27.7338C17.2645 23.1251 20.7161 19.322 25.1183 16.9722C29.5205 14.6224 34.6011 13.8711 39.495 14.8462C44.3888 15.8213 48.7934 18.4626 51.9588 22.3202C55.1241 26.1779 56.8545 31.0135 56.8552 36.0035C56.8547 38.8444 56.2932 41.6573 55.2029 44.2806C54.1125 46.9039 52.5149 49.2861 50.5016 51.2905H50.5087ZM35.2005 11.5345C29.5497 11.5475 24.0781 13.5188 19.7173 17.1126C15.3566 20.7065 12.3764 25.7008 11.2841 31.245C10.1918 36.7892 11.055 42.5407 13.7267 47.52C16.3984 52.4994 20.7134 56.3988 25.937 58.5542C31.1606 60.7096 36.9698 60.9878 42.3754 59.3415C47.7811 57.6951 52.449 54.226 55.5844 49.5248C58.7197 44.8235 60.1286 39.1809 59.5712 33.5577C59.0137 27.9344 56.5244 22.6782 52.5271 18.684C50.2518 16.4105 47.55 14.6086 44.5766 13.3817C41.6033 12.1548 38.417 11.5271 35.2005 11.5345ZM21.6262 35.6697L31.0357 46.593L48.8456 30.24L46.7135 27.9302L32.3292 41.078C32.1861 41.2007 32.02 41.2937 31.8406 41.3516C31.6612 41.4095 31.4721 41.4312 31.2843 41.4153C31.0965 41.3994 30.9137 41.3463 30.7465 41.2592C30.5794 41.172 30.4313 41.0524 30.3108 40.9074L24.0567 33.6158L21.6262 35.6697ZM31.5545 37.9225L45.8394 24.8743C45.9804 24.7446 46.1462 24.6448 46.3267 24.5809C46.5073 24.5169 46.6989 24.4901 46.89 24.502C47.0812 24.514 47.268 24.5645 47.4392 24.6504C47.6104 24.7364 47.7624 24.856 47.8862 25.0022L51.9726 29.4227C52.0989 29.5607 52.1967 29.7222 52.2604 29.8981C52.3242 30.0739 52.3525 30.2606 52.3439 30.4475C52.3354 30.6343 52.29 30.8177 52.2104 30.9869C52.1308 31.1562 52.0187 31.3081 51.8803 31.4339L31.8743 49.72C31.736 49.8484 31.5736 49.9481 31.3964 50.013C31.2191 50.078 31.0308 50.1071 30.8422 50.0985C30.6537 50.0899 30.4687 50.0438 30.2982 49.963C30.1276 49.8821 29.9749 49.7681 29.8489 49.6276L18.4778 36.4585C18.2393 36.1636 18.1246 35.7877 18.1577 35.4099C18.1908 35.0321 18.3693 34.6819 18.6555 34.4331L23.275 30.4816C23.4176 30.3585 23.5833 30.265 23.7625 30.2065C23.9416 30.148 24.1306 30.1257 24.3184 30.1409C24.5062 30.1562 24.6891 30.2086 24.8565 30.2951C25.0239 30.3817 25.1724 30.5006 25.2933 30.6451L31.5545 37.9225Z"
        />
      </svg>
    </div>
    <!-- Lactose -->
    <div>
      <span>icon-lactose</span>
      <svg
        id="icon-lactose"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleLactose contentLactose"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-lactose', 'title')"
          id="titleLactose"
        >
          {{ $options.getString('icon-lactose', 'title') }}
        </title>
        <desc id="contentLactose">
          {{ $options.getString('icon-lactose', 'description') }}
        </desc>
        <path
          d="M54 12L39 27V69"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 12L3 27V69H69V27L54 12V3H18V12Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Egg -->
    <div>
      <span>icon-egg</span>
      <svg
        id="icon-egg"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleEgg contentEgg"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-egg', 'title')" id="titleEgg">
          {{ $options.getString('icon-egg', 'title') }}
        </title>
        <desc id="contentEgg">
          {{ $options.getString('icon-egg', 'description') }}
        </desc>
        <path
          d="M30 39H39L45 30L51 39H61.5"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36 3C21.087 3 9 26.793 9 43.614C9 60.435 21.087 69 36 69C50.913 69 63 60.438 63 43.614C63 26.79 50.913 3 36 3Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Vegetarian -->
    <div>
      <span>icon-vegetarian</span>
      <svg
        id="icon-vegetarian"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleVegetarian contentVegetarian"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-vegetarian', 'title')"
          id="titleVegetarian"
        >
          {{ $options.getString('icon-vegetarian', 'title') }}
        </title>
        <desc id="contentVegetarian">
          {{ $options.getString('icon-vegetarian', 'description') }}
        </desc>
        <path
          d="M68.9401 3.06302C68.9401 3.06302 43.2001 1.34102 28.3951 16.149L16.1491 28.392C1.33807 43.203 3.06007 68.937 3.06007 68.937C3.06007 68.937 28.8001 70.659 43.6051 55.851L55.8511 43.608C70.6621 28.797 68.9401 3.06302 68.9401 3.06302V3.06302Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.9941 57.0061C24.3078 57.0061 26.9941 54.3198 26.9941 51.0061C26.9941 47.6924 24.3078 45.0061 20.9941 45.0061C17.6804 45.0061 14.9941 47.6924 14.9941 51.0061C14.9941 54.3198 17.6804 57.0061 20.9941 57.0061Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M35.9941 42.0061C39.3078 42.0061 41.9941 39.3198 41.9941 36.0061C41.9941 32.6924 39.3078 30.0061 35.9941 30.0061C32.6804 30.0061 29.9941 32.6924 29.9941 36.0061C29.9941 39.3198 32.6804 42.0061 35.9941 42.0061Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M50.9941 27.0061C54.3078 27.0061 56.9941 24.3198 56.9941 21.0061C56.9941 17.6924 54.3078 15.0061 50.9941 15.0061C47.6804 15.0061 44.9941 17.6924 44.9941 21.0061C44.9941 24.3198 47.6804 27.0061 50.9941 27.0061Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- SunTime -->
    <div>
      <span>icon-sun-time</span>
      <svg
        id="icon-sun-time"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleSunTime contentSunTime"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-sun-time', 'title')"
          id="titleSunTime"
        >
          {{ $options.getString('icon-sun-time', 'title') }}
        </title>
        <desc id="contentSunTime">
          {{ $options.getString('icon-sun-time', 'description') }}
        </desc>
        <path
          d="M30 39H36V30"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36 54C45.9411 54 54 45.9411 54 36C54 26.0589 45.9411 18 36 18C26.0589 18 18 26.0589 18 36C18 45.9411 26.0589 54 36 54Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M63 47.1841L69 49.6681"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 22.332L9 24.816"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M47.1841 9L49.6681 3"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.332 69L24.816 63"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M47.1841 63L49.6681 69"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.332 3L24.816 9"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M63 24.816L69 22.332"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 49.6681L9 47.1841"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Pan -->
    <div>
      <span>icon-pan</span>
      <svg
        id="icon-pan"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePan contentPan"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-pan', 'title')" id="titlePan">
          {{ $options.getString('icon-pan', 'title') }}
        </title>
        <desc id="contentPan">
          {{ $options.getString('icon-pan', 'description') }}
        </desc>
        <path
          d="M42 57C56.9117 57 69 44.9117 69 30C69 15.0883 56.9117 3 42 3C27.0883 3 15 15.0883 15 30C15 44.9117 27.0883 57 42 57Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M42 45C50.2843 45 57 38.2843 57 30C57 21.7157 50.2843 15 42 15C33.7157 15 27 21.7157 27 30C27 38.2843 33.7157 45 42 45Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 69L22.5 49.5"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Microwave -->
    <div>
      <span>icon-microwave</span>
      <svg
        id="icon-microwave"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleMicrowave contentMicrowave"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-microwave', 'title')"
          id="titleMicrowave"
        >
          {{ $options.getString('icon-microwave', 'title') }}
        </title>
        <desc id="contentMicrowave">
          {{ $options.getString('icon-microwave', 'description') }}
        </desc>
        <path
          d="M33 27V45"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M45 12V60"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M57 23.97V24"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M57 35.97V36"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M63 60H9C5.685 60 3 57.315 3 54V18C3 14.685 5.685 12 9 12H63C66.315 12 69 14.685 69 18V54C69 57.315 66.315 60 63 60Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Oven -->
    <div>
      <span>icon-oven</span>
      <svg
        id="icon-oven"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleOven contentOven"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-oven', 'title')" id="titleOven">
          {{ $options.getString('icon-oven', 'title') }}
        </title>
        <desc id="contentOven">
          {{ $options.getString('icon-oven', 'description') }}
        </desc>
        <path
          d="M21 39H51"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 27H66"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 15H15.03"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M27 15H27.03"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M44.97 15H45"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.97 15H57"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M69 9V69H3V9C3 5.685 5.685 3 9 3H63C66.315 3 69 5.685 69 9Z"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Water -->
    <div>
      <span>icon-water</span>
      <svg
        id="icon-water"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleWater contentWater"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-water', 'title')" id="titleWater">
          {{ $options.getString('icon-water', 'title') }}
        </title>
        <desc id="contentWater">
          {{ $options.getString('icon-water', 'description') }}
        </desc>
        <path
          d="M3 15C11.241 15 11.241 21 19.485 21C27.735 21 27.735 15 35.982 15C44.238 15 44.238 21 52.491 21C60.744 21 60.744 15 69 15"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 33C11.241 33 11.241 39 19.485 39C27.735 39 27.735 33 35.982 33C44.238 33 44.238 39 52.491 39C60.744 39 60.747 33 69 33"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 51C11.241 51 11.241 57 19.485 57C27.735 57 27.735 51 35.982 51C44.238 51 44.238 57 52.491 57C60.744 57 60.747 51 69 51"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div>
      <span>icon-sauce</span>
      <svg
        id="icon-sauce"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleSauce contentSauce"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-sauce', 'title')" id="titleSauce">
          {{ $options.getString('icon-sauce', 'title') }}
        </title>
        <desc id="contentSauce">
          {{ $options.getString('icon-sauce', 'description') }}
        </desc>
        <g
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          stroke-width="3"
        >
          <path d="m12 36h15" />
          <path d="m45 36h15" />
          <path
            d="m36 45c4.9706 0 9-4.0294 9-9s-4.0294-9-9-9-9 4.0294-9 9 4.0294 9 9 9z"
          />
          <path d="m9 6h54" />
          <path d="m9 66h54" />
          <path d="m12 6v60" />
          <path d="m60 6v60" />
        </g>
      </svg>
    </div>

    <!-- Content Icons End -->
    <!-- Play -->
    <div>
      <span>icon-play</span>
      <svg
        id="icon-play"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePlay contentPlay"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title v-if="$options.getString('icon-play', 'title')" id="titlePlay">
          {{ $options.getString('icon-play', 'title') }}
        </title>
        <desc id="contentPlay">
          {{ $options.getString('icon-play', 'description') }}
        </desc>
        <path
          opacity="0.8"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM30 53.3265V26.6732C30 23.9265 33.4233 22.3565 35.82 24.0065L55.21 37.3332C57.15 38.6665 57.15 41.3332 55.21 42.6665L35.82 55.9932C33.4233 57.6432 30 56.0732 30 53.3265Z"
        />
      </svg>
    </div>
    <!-- Scroller -->
    <div>
      <span>icon-scroller</span>
      <svg
        id="icon-scroller"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleScroller contentScroller"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-scroller', 'title')"
          id="titleScroller"
        >
          {{ $options.getString('icon-scroller', 'title') }}
        </title>
        <desc id="contentScroller">
          {{ $options.getString('icon-scroller', 'description') }}
        </desc>
        <path
          d="M0 32C0 14.3269 14.3269 0 32 0V0C49.6731 0 64 14.3269 64 32V32C64 49.6731 49.6731 64 32 64V64C14.3269 64 0 49.6731 0 32V32Z"
        />
        <path
          d="M23 25L15 32L23 39"
          stroke="white"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M41 39L49 32L41 25"
          stroke="white"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!-- Tap Scroller -->
    <div>
      <span>icon-tap-scroller</span>
      <svg
        id="icon-tap-scroller"
        viewBox="0 0 92 95"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleTapScroller contentTapScroller"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-tap-scroller', 'title')"
          id="titleTapScroller"
        >
          {{ $options.getString('icon-tap-scroller', 'title') }}
        </title>
        <desc id="contentTapScroller">
          {{ $options.getString('icon-tap-scroller', 'description') }}
        </desc>
        <path
          d="M9.02422 25.8338L8.07153 30.7422L14.5506 31.9997L15.5033 27.0913L9.02422 25.8338Z"
        />
        <path
          d="M16.7977 34.418L12.5215 39.4453L16.3301 42.6849L20.6063 37.6575L16.7977 34.418Z"
        />
        <path
          d="M38.778 11.0743L35.8245 16.9766L40.2959 19.2141L43.2494 13.3119L38.778 11.0743Z"
        />
        <path
          d="M40.9612 22.5451L41.2068 27.5391L47.7988 27.2148L47.5532 22.2209L40.9612 22.5451Z"
        />
        <path
          d="M67.1171 33.0532C66.2199 33.4949 65.5008 34.0719 64.9157 34.6945C63.9839 33.4813 62.7816 32.6242 61.4427 32.1689C59.5683 31.5313 57.4206 31.6971 55.5366 32.6248C54.2806 33.2433 53.3366 34.0425 52.5706 34.977C50.2544 33.4423 47.2151 33.1555 44.5236 34.4807C43.6265 34.9225 42.8177 35.5437 42.2767 36.2559L33.2472 20.8612C31.5685 17.4521 27.2841 15.9949 23.875 17.6735C20.3762 19.3964 18.9645 23.5469 20.6873 27.0458L35.4752 58.8886L26.7241 56.5098C23.2885 55.1919 19.3881 56.7781 17.8466 60.2123C17.1207 61.9073 17.154 63.7859 17.7697 65.4891C18.4751 67.1481 19.7189 68.542 21.3697 69.1782L48.6558 82.9401L48.9236 83.0311C49.593 83.2588 50.3495 83.8895 51.1487 84.8336L55.6813 82.2673C54.2609 80.5145 52.6596 79.0736 50.9646 78.3478L23.6785 64.5859C23.1885 64.2699 22.7882 63.9096 22.657 63.4169C22.4362 62.9683 22.4844 62.3872 22.621 61.9856C23.0295 61.0042 24.1503 60.5638 25.0419 61.0164L39.4632 64.9504L42.436 61.4802L25.3082 24.6589C24.8223 23.6721 25.2322 22.4671 26.219 21.9811C27.2059 21.4952 28.4109 21.9051 28.941 22.9816L41.9986 45.1987L44.3868 49.596L48.7841 47.2078L46.3959 42.8105C46.1751 42.3619 45.1176 39.7616 46.9118 38.8781C48.437 38.1271 50.3114 38.7646 51.0624 40.2898L54.1547 46.5697L58.6404 44.3609L57.536 42.1181C56.4316 39.8753 56.4384 38.7572 56.6206 38.2217C56.6661 38.0878 56.8483 37.5522 57.8351 37.0663C58.5528 36.7129 59.3133 36.6728 59.9386 36.8108C60.608 37.0385 61.0967 37.5781 61.4501 38.2958L63.6589 42.7815L64.1448 43.7684L68.6305 41.5596L68.5421 41.3802C67.8795 40.0345 67.8904 38.2457 69.5052 37.4505C70.9407 36.7437 72.2354 37.1094 73.0319 38.5006C73.598 41.0085 77.8312 58.2076 80.3193 68.2405L84.9416 65.6301C82.2354 54.7014 77.9593 37.189 77.9607 36.9654L77.7398 36.5168C75.7519 32.4797 71.513 30.8886 67.4759 32.8765L67.1171 33.0532Z"
        />
      </svg>
    </div>
    <!-- Polygon separator -->
    <div>
      <span>icon-polygon-separator</span>
      <svg
        id="icon-polygon-separator"
        viewBox="0 0 55 217"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePolygonSeparator contentPolygonSeparator"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="none"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-polygon-separator', 'title')"
          id="titlePolygonSeparator"
        >
          {{ $options.getString('icon-polygon-separator', 'title') }}
        </title>
        <desc id="contentPolygonSeparator">
          {{ $options.getString('icon-polygon-separator', 'description') }}
        </desc>
        <path
          d="M55 108.5C33.5212 150.872 55 217 0 217V0C55 0 33.5212 66.1281 55 108.5Z"
        />
      </svg>
    </div>
    <!-- Ellipsis loader -->
    <div>
      <span>icon-ellipsis-loader</span>
      <svg
        id="icon-ellipsis-loader"
        viewBox="-2 22 56 56"
        enable-background="new 0 0 0 0"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        aria-labelledby="titleEllipsisLoader contentEllipsisLoader"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="currentColor"
      >
        <title
          v-if="$options.getString('icon-ellipsis-loader', 'title')"
          id="titleEllipsisLoader"
        >
          {{ $options.getString('icon-ellipsis-loader', 'title') }}
        </title>
        <desc id="contentEllipsisLoader">
          {{ $options.getString('icon-ellipsis-loader', 'description') }}
        </desc>
        <circle stroke="none" cx="6" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.1"
          />
        </circle>
        <circle stroke="none" cx="26" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.2"
          />
        </circle>
        <circle stroke="none" cx="46" cy="50" r="6">
          <animate
            attributeName="opacity"
            dur="1s"
            values="0;1;0"
            repeatCount="indefinite"
            begin="0.3"
          />
        </circle>
      </svg>
    </div>
    <!--FRIDGE-->
    <div>
      <span>icon-fridge</span>
      <svg
        id="icon-fridge"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleFridge contentFridge"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-fridge', 'title')"
          id="titleFridge"
        >
          {{ $options.getString('icon-fridge', 'title') }}
        </title>
        <desc id="contentFridge">
          {{ $options.getString('icon-fridge', 'description') }}
        </desc>
        <path
          d="M21 15V45"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 30H63"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M63 9V69H9V9C9 5.685 11.685 3 15 3H57C60.315 3 63 5.685 63 9Z"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--FRIDGE-->
    <!--OTHER PAN-->
    <div>
      <span>icon-other-pan</span>
      <svg
        id="icon-other-pan"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleOtherPan contentOtherPan"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-other-pan', 'title')"
          id="titleOtherPan"
        >
          {{ $options.getString('icon-other-pan', 'title') }}
        </title>
        <desc id="contentOtherPan">
          {{ $options.getString('icon-other-pan', 'description') }}
        </desc>
        <path
          d="M30.7387 52.1935C45.1423 48.334 55.7758 41.3132 54.4894 36.512C53.2029 31.7108 40.4836 30.9474 26.08 34.8068C11.6764 38.6662 1.0429 45.6871 2.32937 50.4883C3.61585 55.2894 16.3352 56.0529 30.7387 52.1935Z"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M29.8478 47.7733C40.3198 44.9673 48.2876 40.7466 47.6444 38.346C47.0011 35.9454 37.9904 36.274 27.5184 39.08C17.0464 41.886 9.07858 46.1067 9.72181 48.5073C10.3651 50.9079 19.3758 50.5793 29.8478 47.7733Z"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M54.75 35.2507C54.7501 47.2511 51 51.7502 35.25 57.0002C15.75 63.7502 6.74989 56.9988 2.99995 51.7497"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M53.9092 34.5L70.4092 27"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.9458 26.9673C23.9458 26.9673 28.2395 22.8867 18.8297 15.7338C12.1084 10.6245 13.7146 4.50198 13.7146 4.50198"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M35.968 25.4808C35.968 25.4808 38.9664 22.3117 33.5305 17.951C29.6477 14.8362 31.0934 10.4223 31.0934 10.4223"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.3023 30.7253C11.3023 30.7253 13.1981 28.6044 9.57454 25.8625C6.98628 23.904 7.84714 21.0004 7.84714 21.0004"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--OTHER PAN-->
    <!--AS BASE-->
    <div>
      <span>icon-as-base</span>
      <svg
        id="icon-as-base"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleAsBase contentAsBase"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-as-base', 'title')"
          id="titleAsBase"
        >
          {{ $options.getString('icon-as-base', 'title') }}
        </title>
        <desc id="contentAsBase">
          {{ $options.getString('icon-as-base', 'description') }}
        </desc>
        <path
          d="M38.907 23.073C38.436 18.543 34.653 15 30 15C25.029 15 21 19.029 21 24C21 25.113 21.228 26.163 21.597 27.147"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M68.787 45C68.928 44.019 69 43.02 69 42C69 30.402 59.598 21 48 21C41.523 21 35.736 23.937 31.884 28.545"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.5129 45C16.7489 41.505 20.0819 39 23.9999 39C27.9179 39 31.2509 41.505 32.4869 45"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M56.4869 45C56.8199 44.061 56.9999 43.053 56.9999 42C56.9999 37.029 52.9709 33 47.9999 33C45.3119 33 42.9239 34.203 41.2739 36.072"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.21289 45C4.66789 34.824 13.4219 27 23.9999 27C34.5779 27 43.3319 34.824 44.7869 45"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.533 31.887C9.08704 28.326 8.59204 24.279 9.36004 20.058C11.193 9.975 20.556 3 30.804 3C33.891 3 36.915 3.744 39.696 5.082C42.741 6.549 47.376 8.25 52.5 8.25C61.5 8.25 69 3 69 3"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 57H69"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 57V63C6 66.315 8.685 69 12 69H60C63.315 69 66 66.315 66 63V57"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--AS BASE-->
    <!--AS TOPPING-->
    <div>
      <span>icon-as-topping</span>
      <svg
        id="icon-as-topping"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleAsTopping contentAsTopping"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-as-topping', 'title')"
          id="titleAsTopping"
        >
          {{ $options.getString('icon-as-topping', 'title') }}
        </title>
        <desc id="contentAsTopping">
          {{ $options.getString('icon-as-topping', 'description') }}
        </desc>
        <path
          d="M36 3C16.371 3 3 12.132 3 19.923C3 24.228 5.496 26.445 9 27.582V63.504C9 66.537 11.463 69 14.499 69H57.498C60.537 69 63 66.537 63 63.501V27.579C66.504 26.442 69 24.225 69 19.92C69 12.132 55.629 3 36 3V3Z"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 39L51 21"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 57L51 39"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--AS TOPPING-->
    <!--RUNNING WATER-->
    <div>
      <span>icon-running-water</span>
      <svg
        id="icon-running-water"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleRunningWater contentRunningWater"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-running-water', 'title')"
          id="titleRunningWater"
        >
          {{ $options.getString('icon-running-water', 'title') }}
        </title>
        <desc id="contentRunningWater">
          {{ $options.getString('icon-running-water', 'description') }}
        </desc>
        <path
          d="M27.3158 12.6316C29.147 12.6316 30.6316 11.147 30.6316 9.31579C30.6316 7.48453 29.147 6 27.3158 6C25.4845 6 24 7.48453 24 9.31579C24 11.147 25.4845 12.6316 27.3158 12.6316Z"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M43.8948 12.6316C45.726 12.6316 47.2106 11.147 47.2106 9.31579C47.2106 7.48453 45.726 6 43.8948 6C42.0635 6 40.579 7.48453 40.579 9.31579C40.579 11.147 42.0635 12.6316 43.8948 12.6316Z"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M30.6316 9.31567H40.579"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M35.6052 6V15.9474"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M58.8158 33.7495V29.2104C58.8158 23.7162 54.3627 19.2631 48.8684 19.2631H42.6397C40.9669 17.2388 38.4369 15.9473 35.6053 15.9473C32.7736 15.9473 30.2436 17.2388 28.5708 19.2631H9L9 30.8683H28.5708C30.2436 32.8926 32.7736 34.1841 35.6053 34.1841C38.4369 34.1841 40.9669 32.8926 42.6397 30.8683H47.25V33.7495"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M46.5 39H60"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M61.5 58.2632C61.5 63.1462 57.8064 66 53.25 66C48.6936 66 45 63.1462 45 58.2632C45 53.3801 53.25 45 53.25 45C53.25 45 61.5 53.3801 61.5 58.2632Z"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--RUNNING WATER-->
    <!--STEAM OVEN-->
    <div>
      <span>icon-steam-oven</span>
      <svg
        id="icon-steam-oven"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleSteamOven contentSteamOven"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-steam-oven', 'title')"
          id="titleSteamOven"
        >
          {{ $options.getString('icon-steam-oven', 'title') }}
        </title>
        <desc id="contentSteamOven">
          {{ $options.getString('icon-steam-oven', 'description') }}
        </desc>
        <path
          d="M51 15V69"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60 28.4678V28.5008"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60 41.9678V42.0008"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M63 69H9C5.685 69 3 65.9794 3 62.25V21.75C3 18.0206 5.685 15 9 15H63C66.315 15 69 18.0206 69 21.75V62.25C69 65.9794 66.315 69 63 69Z"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36 43.5C37.242 43.5 38.397 43.122 39.354 42.4755C39.993 42.0435 40.5435 41.493 40.974 40.8555C41.622 39.897 42 38.742 42 37.5C42 36.258 41.622 35.103 40.9755 34.146C40.5435 33.507 39.993 32.9565 39.3555 32.526C38.397 31.878 37.242 31.5 36 31.5H35.4765C34.2405 28.0065 30.9165 25.5 27 25.5C23.0835 25.5 19.7595 28.0065 18.5235 31.5H18C16.758 31.5 15.603 31.878 14.646 32.5245C14.007 32.9565 13.4565 33.507 13.026 34.1445C12.378 35.103 12 36.258 12 37.5C12 40.8135 14.6865 43.5 18 43.5"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M27 58.5V52.5"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M36 55.5V49.5"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18 55.5V49.5"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--STEAM OVEN-->
    <!--SINGLE PORTION-->
    <div>
      <span>icon-single-portion</span>
      <svg
        id="icon-single-portion"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleSinglePortion contentSinglePortion"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-single-portion', 'title')"
          id="titleSinglePortion"
        >
          {{ $options.getString('icon-single-portion', 'title') }}
        </title>
        <desc id="contentSinglePortion">
          {{ $options.getString('icon-single-portion', 'description') }}
        </desc>
        <path
          d="M12 21H60"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 51H60"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M60 69V3L48 6.75L36 3L24 6.75L12 3V69L24 66L36 69L48 66L60 69Z"
          stroke="currentColor"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--SINGLE PORTION-->
    <!--EXPO-->
    <div>
      <span>icon-expo</span>
      <svg
        id="icon-expo"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleExpo contentExpo"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="none"
      >
        <title v-if="$options.getString('icon-expo', 'title')" id="titleExpo">
          {{ $options.getString('icon-expo', 'title') }}
        </title>
        <desc id="contentExpo">
          {{ $options.getString('icon-expo', 'description') }}
        </desc>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M29.2825 3.28248C31.0641 1.50089 33.4804 0.5 36 0.5C38.5196 0.5 40.9359 1.50089 42.7175 3.28249C44.1416 4.70658 45.0669 6.53624 45.3809 8.5H60C60.8284 8.5 61.5 9.17157 61.5 10V28.6694L67.361 41.3194C67.4526 41.517 67.5 41.7322 67.5 41.95V42V66C67.5 66.8284 66.8284 67.5 66 67.5H6C5.17157 67.5 4.5 66.8284 4.5 66V42V41.95C4.5 41.7322 4.54743 41.517 4.63899 41.3194L10.5 28.6694V10C10.5 9.17157 11.1716 8.5 12 8.5H26.6191C26.9331 6.53624 27.8584 4.70658 29.2825 3.28248ZM13.5 27.5H36H58.5V11.5H44C43.1716 11.5 42.5 10.8284 42.5 10C42.5 8.27609 41.8152 6.62279 40.5962 5.40381C39.3772 4.18482 37.7239 3.5 36 3.5C34.2761 3.5 32.6228 4.18482 31.4038 5.40381C30.1848 6.62279 29.5 8.27609 29.5 10C29.5 10.8284 28.8284 11.5 28 11.5L13.5 11.5V27.5ZM13.5 30.5V31.5H34.5V30.5H13.5ZM37.5 30.5V31.5H58.5V30.5H37.5ZM8.32499 40.5L10.5 35.8056V38V40.5H8.32499ZM7.5 64.5V43.5H12H22.0698L29.705 48.272C29.9434 48.421 30.2189 48.5 30.5 48.5H36.5H41.5C41.7811 48.5 42.0566 48.421 42.295 48.272L49.9302 43.5H60H64.5V64.5H7.5ZM61.5 35.8056L63.675 40.5H61.5V38V35.8056ZM58.5 40.5V39.5H37.5V41.5H46C46.3559 41.5 46.6829 41.624 46.9401 41.8311L48.705 40.728C48.9434 40.579 49.2189 40.5 49.5 40.5H58.5ZM58.5 36.5V34.5H37.5V36.5H58.5ZM13.5 34.5H34.5V36.5H13.5V34.5ZM13.5 39.5H34.5V41.5H26C25.6441 41.5 25.3171 41.624 25.0599 41.8311L23.295 40.728C23.0566 40.579 22.7811 40.5 22.5 40.5H13.5V39.5ZM29.3302 44.5H36H42.6698L41.0698 45.5H36.5H30.9302L29.3302 44.5Z"
          fill="currentColor"
        />
      </svg>
    </div>
    <!--EXPO-->

    <!--1-->
    <div>
      <span>icon-1</span>
      <svg
        id="icon-1"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title1 content1"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
        fill="none"
      >
        <title v-if="$options.getString('icon-1', 'title')" id="title1">
          {{ $options.getString('icon-1', 'title') }}
        </title>
        <desc id="content1">
          {{ $options.getString('icon-1', 'description') }}
        </desc>
        <path
          d="M25.6667 15.6665V32.3332"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.6667 18.9998L25.6667 15.6665"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34 40.6666H14C10.3184 40.6666 7.33337 37.6816 7.33337 33.9999V13.9999C7.33337 10.3183 10.3184 7.33325 14 7.33325H34C37.6817 7.33325 40.6667 10.3183 40.6667 13.9999V33.9999C40.6667 37.6816 37.6817 40.6666 34 40.6666Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--1-->

    <!--2-->
    <div>
      <span>icon-2</span>
      <svg
        id="icon-2"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title2 content2"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
        fill="none"
      >
        <title v-if="$options.getString('icon-2', 'title')" id="title2">
          {{ $options.getString('icon-2', 'title') }}
        </title>
        <desc id="content2">
          {{ $options.getString('icon-2', 'description') }}
        </desc>
        <path
          d="M19 15.6665H25.91C27.6167 15.6665 29 17.0498 29 18.7565C29 19.9265 28.3383 20.9965 27.2917 21.5198L24.9633 22.6848C21.3083 24.5115 19 28.2482 19 32.3332H29"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34 40.6666H14C10.3184 40.6666 7.33337 37.6816 7.33337 33.9999V13.9999C7.33337 10.3183 10.3184 7.33325 14 7.33325H34C37.6817 7.33325 40.6667 10.3183 40.6667 13.9999V33.9999C40.6667 37.6816 37.6817 40.6666 34 40.6666Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--2-->

    <!--3-->
    <div>
      <span>icon-3</span>
      <svg
        id="icon-3"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title3 content3"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
        fill="none"
      >
        <title v-if="$options.getString('icon-3', 'title')" id="title3">
          {{ $options.getString('icon-3', 'title') }}
        </title>
        <desc id="content3">
          {{ $options.getString('icon-3', 'description') }}
        </desc>
        <path
          d="M20.6667 23.9998H24.8333C27.135 23.9998 29 22.1348 29 19.8332C29 17.5315 27.135 15.6665 24.8333 15.6665H19"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 32.3333H24.8333C27.135 32.3333 29 30.4683 29 28.1667C29 25.865 27.135 24 24.8333 24"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34 40.6666H14C10.3184 40.6666 7.33337 37.6816 7.33337 33.9999V13.9999C7.33337 10.3183 10.3184 7.33325 14 7.33325H34C37.6817 7.33325 40.6667 10.3183 40.6667 13.9999V33.9999C40.6667 37.6816 37.6817 40.6666 34 40.6666Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--3-->

    <!--4-->
    <div>
      <span>icon-4</span>
      <svg
        id="icon-4"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title4 content4"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
        fill="none"
      >
        <title v-if="$options.getString('icon-4', 'title')" id="title4">
          {{ $options.getString('icon-4', 'title') }}
        </title>
        <desc id="content4">
          {{ $options.getString('icon-4', 'description') }}
        </desc>
        <path
          d="M19 15.6665V25.6665H29"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M29 15.6665V32.3332"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34 40.6666H14C10.3184 40.6666 7.33337 37.6816 7.33337 33.9999V13.9999C7.33337 10.3183 10.3184 7.33325 14 7.33325H34C37.6817 7.33325 40.6667 10.3183 40.6667 13.9999V33.9999C40.6667 37.6816 37.6817 40.6666 34 40.6666Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--4-->

    <!--5-->
    <div>
      <span>icon-5</span>
      <svg
        id="icon-5"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title5 content5"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
        fill="none"
      >
        <title v-if="$options.getString('icon-5', 'title')" id="title5">
          {{ $options.getString('icon-5', 'title') }}
        </title>
        <desc id="content5">
          {{ $options.getString('icon-5', 'description') }}
        </desc>
        <path
          d="M27.3333 15.6665H19V22.3332H24C26.7617 22.3332 29 24.5715 29 27.3332C29 30.0948 26.7617 32.3332 24 32.3332H19"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34 40.6666H14C10.3184 40.6666 7.33337 37.6816 7.33337 33.9999V13.9999C7.33337 10.3183 10.3184 7.33325 14 7.33325H34C37.6817 7.33325 40.6667 10.3183 40.6667 13.9999V33.9999C40.6667 37.6816 37.6817 40.6666 34 40.6666Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--5-->

    <!--6-->
    <div>
      <span>icon-6</span>
      <svg
        id="icon-6"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title6 content6"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
        fill="none"
      >
        <title v-if="$options.getString('icon-6', 'title')" id="title6">
          {{ $options.getString('icon-6', 'title') }}
        </title>
        <desc id="content6">
          {{ $options.getString('icon-6', 'description') }}
        </desc>
        <path
          d="M23.1667 24H24.8333C27.135 24 29 25.865 29 28.1667C29 30.4683 27.135 32.3333 24.8333 32.3333H23.1667C20.865 32.3333 19 30.4683 19 28.1667C19 25.865 20.865 24 23.1667 24Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 28.1665V20.6665C19 17.9048 21.2383 15.6665 24 15.6665H27.3333"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 7.33325H34C37.6817 7.33325 40.6667 10.3183 40.6667 13.9999V33.9999C40.6667 37.6816 37.6817 40.6666 34 40.6666H14C10.3184 40.6666 7.33337 37.6816 7.33337 33.9999V13.9999C7.33337 10.3183 10.3184 7.33325 14 7.33325Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--6-->

    <!--7-->
    <div>
      <span>icon-7</span>
      <svg
        id="icon-7"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title7 content7"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
        fill="none"
      >
        <title v-if="$options.getString('icon-7', 'title')" id="title7">
          {{ $options.getString('icon-7', 'title') }}
        </title>
        <desc id="content7">
          {{ $options.getString('icon-7', 'description') }}
        </desc>
        <path
          d="M19 17.3333H29L23.1667 32.3333"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34 40.6666H14C10.3184 40.6666 7.33337 37.6816 7.33337 33.9999V13.9999C7.33337 10.3183 10.3184 7.33325 14 7.33325H34C37.6817 7.33325 40.6667 10.3183 40.6667 13.9999V33.9999C40.6667 37.6816 37.6817 40.6666 34 40.6666Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--7-->

    <!--8-->
    <div>
      <span>icon-8</span>
      <svg
        id="icon-8"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title8 content8"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
        fill="none"
      >
        <title v-if="$options.getString('icon-8', 'title')" id="title8">
          {{ $options.getString('icon-8', 'title') }}
        </title>
        <desc id="content8">
          {{ $options.getString('icon-8', 'description') }}
        </desc>
        <path
          d="M24.8333 32.3333H23.1667C20.865 32.3333 19 30.4683 19 28.1667C19 25.865 20.865 24 23.1667 24H24.8333C27.135 24 29 25.865 29 28.1667C29 30.4683 27.135 32.3333 24.8333 32.3333Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M24 23.9998C26.3012 23.9998 28.1667 22.1344 28.1667 19.8332C28.1667 17.532 26.3012 15.6665 24 15.6665C21.6989 15.6665 19.8334 17.532 19.8334 19.8332C19.8334 22.1344 21.6989 23.9998 24 23.9998Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34 40.6666H14C10.3184 40.6666 7.33337 37.6816 7.33337 33.9999V13.9999C7.33337 10.3183 10.3184 7.33325 14 7.33325H34C37.6817 7.33325 40.6667 10.3183 40.6667 13.9999V33.9999C40.6667 37.6816 37.6817 40.6666 34 40.6666Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--8-->

    <!--9-->
    <div>
      <span>icon-9</span>
      <svg
        id="icon-9"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title9 content9"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
        fill="none"
      >
        <title v-if="$options.getString('icon-9', 'title')" id="title9">
          {{ $options.getString('icon-9', 'title') }}
        </title>
        <desc id="content9">
          {{ $options.getString('icon-9', 'description') }}
        </desc>
        <path
          d="M24.8333 23.9998H23.1667C20.865 23.9998 19 22.1348 19 19.8332C19 17.5315 20.865 15.6665 23.1667 15.6665H24.8333C27.135 15.6665 29 17.5315 29 19.8332C29 22.1348 27.135 23.9998 24.8333 23.9998Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M29.0001 19.8333V27.3333C29.0001 30.0949 26.7617 32.3333 24.0001 32.3333H20.6667"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M34 40.6666H14C10.3184 40.6666 7.33337 37.6816 7.33337 33.9999V13.9999C7.33337 10.3183 10.3184 7.33325 14 7.33325H34C37.6817 7.33325 40.6667 10.3183 40.6667 13.9999V33.9999C40.6667 37.6816 37.6817 40.6666 34 40.6666Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--9-->

    <!--10-->
    <div>
      <span>icon-10</span>
      <svg
        id="icon-10"
        viewBox="0 0 48 48"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="title10 content10"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        stroke="currentColor"
        fill="none"
      >
        <title v-if="$options.getString('icon-10', 'title')" id="title10">
          {{ $options.getString('icon-10', 'title') }}
        </title>
        <desc id="content10">
          {{ $options.getString('icon-10', 'description') }}
        </desc>
        <path
          d="M34 40.6666H14C10.3184 40.6666 7.33337 37.6816 7.33337 33.9999V13.9999C7.33337 10.3183 10.3184 7.33325 14 7.33325H34C37.6817 7.33325 40.6667 10.3183 40.6667 13.9999V33.9999C40.6667 37.6816 37.6817 40.6666 34 40.6666Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 15.6665V32.3332"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14 18.9998L19 15.6665"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M29.8334 32.3332C27.5317 32.3332 25.6667 30.4682 25.6667 28.1665V19.8332C25.6667 17.5315 27.5317 15.6665 29.8334 15.6665C32.1351 15.6665 34.0001 17.5315 34.0001 19.8332V28.1665C34.0001 30.4682 32.1351 32.3332 29.8334 32.3332Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--10-->

    <!--BACON-->
    <div>
      <span>icon-bacon</span>
      <svg
        id="icon-bacon"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleBacon contentBacon"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-bacon', 'title')" id="titleBacon">
          {{ $options.getString('icon-bacon', 'title') }}
        </title>
        <desc id="contentBacon">
          {{ $options.getString('icon-bacon', 'description') }}
        </desc>
        <path
          d="M11.2889 58.377C13.5839 56.796 15.5789 55.836 17.5289 54.918C20.7449 53.4 23.7869 51.966 28.3619 47.376C32.9189 42.807 34.3379 39.78 35.8409 36.579C37.4729 33.102 39.1619 29.502 44.3579 24.291C49.5359 19.101 53.0939 17.421 56.5379 15.795C57.9149 15.147 59.2649 14.496 60.7109 13.623"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5811 69C21.8761 67.419 23.8711 66.459 25.8211 65.541C29.0371 64.023 32.0791 62.589 36.6541 57.999C41.2111 53.43 42.6301 50.403 44.1331 47.202C45.7651 43.725 47.4541 40.125 52.6501 34.914C57.8281 29.724 61.3861 28.044 64.8301 26.418C66.2011 25.773 67.5541 25.122 69.0001 24.249"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 47.751L19.581 69"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M52.419 3C50.973 3.873 49.62 4.524 48.246 5.172C44.802 6.798 41.244 8.478 36.066 13.668C30.87 18.879 29.184 22.476 27.549 25.953C26.049 29.154 24.627 32.178 20.07 36.75C15.495 41.34 12.453 42.774 9.237 44.292C7.29 45.213 5.295 46.17 3 47.751"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M68.9999 24.249L52.4189 3"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--BACON-->

    <!--CHEESE-->
    <div>
      <span>icon-cheese</span>
      <svg
        id="icon-cheese"
        viewBox="0 0 72 72"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleCheese contentCheese"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-cheese', 'title')"
          id="titleCheese"
        >
          {{ $options.getString('icon-cheese', 'title') }}
        </title>
        <desc id="contentCheese">
          {{ $options.getString('icon-cheese', 'description') }}
        </desc>
        <path
          d="M69 36V60H3V36"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 36H69"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 36L48 12"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M48 12L69 36"
          stroke-width="3"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--CHEESE-->

    <!--DIAMETER-->
    <div>
      <span>icon-diameter</span>
      <svg
        id="icon-diameter"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleDiameter contentDiameter"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-diameter', 'title')"
          id="titleDiameter"
        >
          {{ $options.getString('icon-diameter', 'title') }}
        </title>
        <desc id="contentDiameter">
          {{ $options.getString('icon-diameter', 'description') }}
        </desc>
        <g>
          <path
            d="M17 7L7 17"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6 14V18H10"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18 10V6H14"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </div>
    <!--DIAMETER-->

    <!--PATENT-->
    <div>
      <span>icon-patent</span>
      <svg
        id="icon-patent"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePatent contentPatent"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-patent', 'title')"
          id="titlePatent"
        >
          {{ $options.getString('icon-patent', 'title') }}
        </title>
        <desc id="contentPatent">
          {{ $options.getString('icon-patent', 'description') }}
        </desc>
        <g>
          <path
            d="M18.1899 13.1353C18.2689 12.768 18.3124 12.3884 18.3124 12C18.3124 11.6116 18.2689 11.232 18.1899 10.8647L19.6169 9.78182C20.0136 9.48073 20.1163 8.95855 19.8595 8.54836L19.1728 7.45164C18.916 7.04145 18.374 6.86182 17.8928 7.02836L16.156 7.62836C15.5405 7.13091 14.8214 6.74255 14.0297 6.49455L13.7255 4.81018C13.6402 4.34255 13.2016 4 12.6872 4H11.3139C10.7996 4 10.361 4.34255 10.2765 4.81018L9.97147 6.49455C9.17974 6.74255 8.4607 7.13091 7.84516 7.62836L6.1084 7.02836C5.62641 6.86255 5.08515 7.04145 4.82835 7.45164L4.14091 8.54836C3.88411 8.95855 3.98683 9.48073 4.38349 9.78182L5.81051 10.8647C5.7315 11.232 5.68804 11.6109 5.68804 12C5.68804 12.3891 5.7315 12.768 5.81051 13.1353L4.38349 14.2182C3.98683 14.5193 3.88411 15.0415 4.14091 15.4516L4.82756 16.5484C5.08436 16.9585 5.62641 17.1382 6.10761 16.9716L7.84437 16.3716C8.45991 16.8691 9.17895 17.2575 9.97068 17.5055L10.2749 19.1898C10.361 19.6575 10.7996 20 11.3139 20H12.6872C13.2016 20 13.6402 19.6575 13.7247 19.1898L14.0289 17.5055C14.8207 17.2575 15.5405 16.8691 16.1552 16.3716L17.892 16.9716C18.3732 17.1382 18.9152 16.9593 19.172 16.5484L19.8587 15.4516C20.1155 15.0415 20.0136 14.5193 19.6161 14.2182L18.1899 13.1353Z"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.0002 15C13.6571 15 15.0002 13.6569 15.0002 12C15.0002 10.3431 13.6571 9 12.0002 9C10.3433 9 9.0002 10.3431 9.0002 12C9.0002 13.6569 10.3433 15 12.0002 15Z"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.0002 23C18.0753 23 23.0002 18.0751 23.0002 12C23.0002 5.92487 18.0753 1 12.0002 1C5.92507 1 1.0002 5.92487 1.0002 12C1.0002 18.0751 5.92507 23 12.0002 23Z"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </div>
    <!--PATENT-->

    <!--THICKNESS-->
    <div>
      <span>icon-thickness</span>
      <svg
        id="icon-thickness"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleThickness contentThickness"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-thickness', 'title')"
          id="titleThickness"
        >
          {{ $options.getString('icon-thickness', 'title') }}
        </title>
        <desc id="contentThickness">
          {{ $options.getString('icon-thickness', 'description') }}
        </desc>
        <g>
          <path
            d="M12 15V23"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.6655 18.6667L11.9987 15L8.33203 18.6667"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12 9L12 1"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M15.6655 5.33328L11.9987 9L8.33203 5.33328"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M1 12L23 12"
            stroke="currentColor"
            stroke-width="1"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
      </svg>
    </div>
    <!--THICKNESS-->

    <!--MULTI SENSOR 1-->
    <div>
      <span>icon-multi-sensor-1</span>
      <svg
        id="icon-multi-sensor-1"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleMultiSensor1 contentMultiSensor1"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-multi-sensor-1', 'title')"
          id="titleMultiSensor1"
        >
          {{ $options.getString('icon-multi-sensor-1', 'title') }}
        </title>
        <desc id="contentMultiSensor1">
          {{ $options.getString('icon-multi-sensor-1', 'description') }}
        </desc>
        <path
          d="M20.9375 20.8816C18.8567 21.2118 16.4183 20.3864 14.5483 18.5157C12.6783 16.6449 11.8625 14.2055 12.1833 12.1238C14.2642 11.7937 16.7025 12.6099 18.5725 14.4806C20.4425 16.3514 21.2583 18.7908 20.9283 20.8725L20.9375 20.8816Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.9375 20.8816C18.8567 21.2118 16.4183 20.3864 14.5483 18.5157C12.6783 16.6449 11.8625 14.2055 12.1833 12.1238C14.2642 11.7937 16.7025 12.6099 18.5725 14.4806C20.4425 16.3514 21.2583 18.7908 20.9283 20.8725L20.9375 20.8816Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.9267 11.8672C9.84584 12.1974 7.40751 11.372 5.53751 9.50124C3.66751 7.63046 2.85168 5.20028 3.18168 3.11858C5.26251 2.78845 7.70085 3.60462 9.57084 5.4754C11.4408 7.34618 12.2567 9.78553 11.9267 11.8672Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.18168 20.8818C2.85168 18.8001 3.67668 16.3607 5.54668 14.49C7.41668 12.6192 9.85501 11.803 11.9358 12.124C12.2658 14.2057 11.45 16.645 9.58001 18.5158C7.71001 20.3866 5.27168 21.2027 3.19085 20.8726L3.18168 20.8818Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.18168 20.8818C2.85168 18.8001 3.67668 16.3607 5.54668 14.49C7.41668 12.6192 9.85501 11.803 11.9358 12.124C12.2658 14.2057 11.45 16.645 9.58001 18.5158C7.71001 20.3866 5.27168 21.2027 3.19085 20.8726L3.18168 20.8818Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.1925 11.8671C11.8625 9.78543 12.6875 7.34608 14.5575 5.4753C16.4275 3.60452 18.8658 2.78835 20.9467 3.10932C21.2767 5.19102 20.4608 7.63037 18.5908 9.50115C16.7208 11.3719 14.2825 12.1881 12.2017 11.858L12.1925 11.8671Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 4.0446C12.8404 4.0446 13.5217 3.36304 13.5217 2.5223C13.5217 1.68156 12.8404 1 12 1C11.1596 1 10.4783 1.68156 10.4783 2.5223C10.4783 3.36304 11.1596 4.0446 12 4.0446Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 22.9999C12.8404 22.9999 13.5217 22.3184 13.5217 21.4776C13.5217 20.6369 12.8404 19.9553 12 19.9553C11.1596 19.9553 10.4783 20.6369 10.4783 21.4776C10.4783 22.3184 11.1596 22.9999 12 22.9999Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.4783 13.5177C22.3187 13.5177 23 12.8362 23 11.9954C23 11.1547 22.3187 10.4731 21.4783 10.4731C20.6379 10.4731 19.9567 11.1547 19.9567 11.9954C19.9567 12.8362 20.6379 13.5177 21.4783 13.5177Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.52167 13.5177C3.36206 13.5177 4.04333 12.8362 4.04333 11.9954C4.04333 11.1547 3.36206 10.4731 2.52167 10.4731C1.68127 10.4731 1 11.1547 1 11.9954C1 12.8362 1.68127 13.5177 2.52167 13.5177Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--MULTI SENSOR 1-->

    <!--MULTI SENSOR 2-->
    <div>
      <span>icon-multi-sensor-2</span>
      <svg
        id="icon-multi-sensor-2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleMultiSensor2 contentMultiSensor2"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title
          v-if="$options.getString('icon-multi-sensor-2', 'title')"
          id="titleMultiSensor2"
        >
          {{ $options.getString('icon-multi-sensor-2', 'title') }}
        </title>
        <desc id="contentMultiSensor2">
          {{ $options.getString('icon-multi-sensor-2', 'description') }}
        </desc>
        <path
          d="M16.5059 5.81796C14.1248 5.81796 12.194 7.75743 12.194 10.1298C12.194 7.74877 10.2632 5.81796 7.88219 5.81796C10.2632 5.81796 12.194 3.88715 12.194 1.51477C12.194 3.89581 14.1248 5.81796 16.5059 5.81796Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.1247 12.0086C7.74366 12.0086 5.81286 13.9481 5.81286 16.3205C5.81286 13.9394 3.88205 12.0086 1.50101 12.0086C3.88205 12.0086 5.81286 10.0778 5.81286 7.70544C5.81286 10.0865 7.74366 12.0086 10.1247 12.0086Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M22.281 12.0086C19.9 12.0086 17.9692 13.9481 17.9692 16.3205C17.9692 13.9394 16.0383 12.0086 13.6573 12.0086C16.0383 12.0086 17.9692 10.0778 17.9692 7.70544C17.9692 10.0865 19.9 12.0086 22.281 12.0086Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.5059 18.1734C14.1248 18.1734 12.194 20.1129 12.194 22.4853C12.194 20.1042 10.2632 18.1734 7.88219 18.1734C10.2632 18.1734 12.194 16.2426 12.194 13.8702C12.194 16.2513 14.1248 18.1734 16.5059 18.1734Z"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--MULTI SENSOR 2-->

    <!--PLUS-->
    <div>
      <span>icon-plus</span>
      <svg
        id="icon-plus"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titlePlus contentPlus"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-plus', 'title')" id="titlePlus">
          {{ $options.getString('icon-plus', 'title') }}
        </title>
        <desc id="contentPlus">
          {{ $options.getString('icon-plus', 'description') }}
        </desc>

        <path
          d="M12 4V20"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 12H20"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 4V20"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 12H20"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--PLUS-->

    <!--MINUS-->
    <div>
      <span>icon-minus</span>
      <svg
        id="icon-minus"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-labelledby="titleMinus contentMinus"
        role="img"
        version="1.1"
        xml:space="preserve"
        preserveAspectRatio="xMidYMid"
        fill="none"
        stroke="currentColor"
      >
        <title v-if="$options.getString('icon-minus', 'title')" id="titleMinus">
          {{ $options.getString('icon-minus', 'title') }}
        </title>
        <desc id="contentMinus">
          {{ $options.getString('icon-minus', 'description') }}
        </desc>
        <path
          d="M4 12H20"
          stroke-width="1"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <!--MINUS-->
  </div>
</template>

<script>
export default {
  name: 'SvgIconsCmp',
  functional: true,
  getString(id, attribute) {
    if (this.$store && this.$store.state.icons) {
      return this.$store.state.icons[id]
        ? this.$store.state.icons[id][attribute]
          ? this.$store.state.icons[id][attribute]
          : ''
        : '';
    } else {
      return '';
    }
  },
};
</script>

<style lang="scss" scoped>
.SvgIconsCmp {
  //----------------------------------------------DEBUG
  // background: #fff;
  // position: fixed;
  // z-index: 99999999999;
  // width: 100vw;
  // min-height: 100vh;
  // top: 0;
  // left: 0;
  // background: #fff;
  // padding: 100px 0;
  // div {
  //   display: inline-block;
  //   width: 100px;
  //   height: 40px;
  //   margin: 20px;
  // }
  // svg {
  //   width: 100%;
  //   height: 100%;
  // }
  //----------------------------------------------DEBUG
  //----------------------------------------------CORRECT
  position: fixed;
  right: -9999px;
  bottom: -9999px;
  width: 0;
  height: 0;
  visibility: hidden;
  span {
    display: none;
    visibility: hidden;
  }
  svg {
    visibility: visible;
  }
  // //----------------------------------------------CORRECT
}
</style>
